import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "row icon-lists whether-icon" }
const _hoisted_4 = { class: "col-lg-2 col-3" }
const _hoisted_5 = {
  class: "climacon climacon_sun",
  id: "sun",
  version: "1.1",
  viewBox: "15 15 70 70"
}
const _hoisted_6 = { class: "col-lg-2 col-3" }
const _hoisted_7 = {
  class: "climacon climacon_moon",
  id: "moon",
  version: "1.1",
  viewBox: "15 15 70 70"
}
const _hoisted_8 = { class: "col-lg-2 col-3" }
const _hoisted_9 = {
  class: "climacon climacon_snowflake",
  id: "sunsetAlt",
  version: "1.1",
  viewBox: "15 15 70 70"
}
const _hoisted_10 = { class: "col-lg-2 col-3" }
const _hoisted_11 = {
  class: "climacon climacon_cloud",
  id: "cloud",
  version: "1.1",
  viewBox: "15 15 70 70"
}
const _hoisted_12 = { class: "col-lg-2 col-3" }
const _hoisted_13 = {
  class: "climacon climacon_cloudSun",
  id: "cloudSun",
  version: "1.1",
  viewBox: "15 15 70 70"
}
const _hoisted_14 = { class: "col-lg-2 col-3" }
const _hoisted_15 = {
  class: "climacon climacon_cloudMoon",
  id: "cloudMoon",
  version: "1.1",
  viewBox: "15 15 70 70"
}
const _hoisted_16 = { class: "col-lg-2 col-3" }
const _hoisted_17 = {
  class: "climacon climacon_cloudDrizzleSun",
  id: "cloudDrizzleSun",
  version: "1.1",
  viewBox: "15 15 70 70"
}
const _hoisted_18 = { class: "col-lg-2 col-3" }
const _hoisted_19 = {
  class: "climacon climacon_cloudDrizzleMoon",
  id: "cloudDrizzleMoon",
  version: "1.1",
  viewBox: "15 15 70 70"
}
const _hoisted_20 = { class: "col-lg-2 col-3" }
const _hoisted_21 = {
  class: "climacon climacon_cloudDrizzleSunAlt",
  id: "cloudDrizzleSunAlt",
  version: "1.1",
  viewBox: "15 15 70 70"
}
const _hoisted_22 = { class: "col-lg-2 col-3" }
const _hoisted_23 = {
  class: "climacon climacon_cloudDrizzleMoonAlt",
  id: "cloudDrizzleMoonAlt",
  version: "1.1",
  viewBox: "15 15 70 70"
}
const _hoisted_24 = { class: "col-lg-2 col-3" }
const _hoisted_25 = {
  class: "climacon climacon_cloudRain",
  id: "cloudRain",
  version: "1.1",
  viewBox: "15 15 70 70"
}
const _hoisted_26 = { class: "col-lg-2 col-3" }
const _hoisted_27 = {
  class: "climacon climacon_cloudRainSun",
  id: "cloudRainSun",
  version: "1.1",
  viewBox: "15 15 70 70"
}
const _hoisted_28 = { class: "col-lg-2 col-3" }
const _hoisted_29 = {
  class: "climacon climacon_cloudRainMoon",
  id: "cloudRainMoon",
  version: "1.1",
  viewBox: "15 15 70 70"
}
const _hoisted_30 = { class: "col-lg-2 col-3" }
const _hoisted_31 = {
  class: "climacon climacon_cloudRainAlt",
  id: "cloudRainAlt",
  version: "1.1",
  viewBox: "15 15 70 70"
}
const _hoisted_32 = { class: "col-lg-2 col-3" }
const _hoisted_33 = {
  class: "climacon climacon_cloudSunRainAlt",
  id: "cloudRainSunAlt",
  version: "1.1",
  viewBox: "15 15 70 70"
}
const _hoisted_34 = { class: "col-lg-2 col-3" }
const _hoisted_35 = {
  class: "climacon climacon_cloudMoonRainAlt",
  id: "cloudRainMoonAlt",
  version: "1.1",
  viewBox: "15 15 70 70"
}
const _hoisted_36 = { class: "col-lg-2 col-3" }
const _hoisted_37 = {
  class: "climacon climacon_cloudHailAltSun",
  id: "cloudHailAltSun",
  version: "1.1",
  viewBox: "15 15 70 70"
}
const _hoisted_38 = { class: "col-lg-2 col-3" }
const _hoisted_39 = {
  class: "climacon climacon_cloudHailAltMoon",
  id: "cloudHailAltMoon",
  version: "1.1",
  viewBox: "15 15 70 70"
}
const _hoisted_40 = { class: "col-lg-2 col-3" }
const _hoisted_41 = {
  class: "climacon climacon_cloudSnowSun",
  id: "cloudSnowSun",
  version: "1.1",
  viewBox: "15 15 70 70"
}
const _hoisted_42 = { class: "col-lg-2 col-3" }
const _hoisted_43 = {
  class: "climacon climacon_cloudSnowMoon",
  id: "cloudSnowMoon",
  version: "1.1",
  viewBox: "15 15 70 70"
}
const _hoisted_44 = { class: "col-lg-2 col-3" }
const _hoisted_45 = {
  class: "climacon climacon_cloudSnowAlt",
  id: "cloudSnowAltfill2",
  version: "1.1",
  viewBox: "15 15 70 70"
}
const _hoisted_46 = { class: "col-lg-2 col-3" }
const _hoisted_47 = {
  class: "climacon climacon_cloudSnowSunAlt",
  id: "cloudSnowSunAlt",
  version: "1.1",
  viewBox: "15 15 70 70"
}
const _hoisted_48 = { class: "col-lg-2 col-3" }
const _hoisted_49 = {
  class: "climacon climacon_cloudSnowAlt",
  id: "cloudSnowAlt",
  version: "1.1",
  viewBox: "15 15 70 70"
}
const _hoisted_50 = { class: "col-lg-2 col-3" }
const _hoisted_51 = {
  class: "climacon climacon_cloudFogSun",
  id: "cloudFogSun",
  version: "1.1",
  viewBox: "15 15 70 70"
}
const _hoisted_52 = { class: "col-lg-2 col-3" }
const _hoisted_53 = {
  class: "climacon climacon_cloudFogSunFill",
  id: "cloudFogSunFill",
  version: "1.1",
  viewBox: "15 15 70 70"
}
const _hoisted_54 = { class: "col-lg-2 col-3" }
const _hoisted_55 = {
  class: "climacon climacon_cloudFogMoon",
  id: "cloudFogMoon",
  version: "1.1",
  viewBox: "15 15 70 70"
}
const _hoisted_56 = { class: "col-lg-2 col-3" }
const _hoisted_57 = {
  class: "climacon climacon_cloudFogMoonFill",
  id: "cloudFogMoonFill",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "15 15 70 70"
}
const _hoisted_58 = { class: "col-lg-2 col-3" }
const _hoisted_59 = {
  class: "climacon climacon_cloudFogSunAlt",
  id: "cloudFogSunAlt",
  version: "1.1",
  viewBox: "15 15 70 70"
}
const _hoisted_60 = { class: "col-lg-2 col-3" }
const _hoisted_61 = {
  class: "climacon climacon_cloudFogSunAltFill",
  id: "cloudFogSunAltFill",
  version: "1.1",
  viewBox: "15 15 70 70"
}
const _hoisted_62 = { class: "col-lg-2 col-3" }
const _hoisted_63 = {
  class: "climacon climacon_cloudFogMoonAlt",
  id: "cloudFogMoonAlt",
  version: "1.1",
  viewBox: "15 15 70 70"
}
const _hoisted_64 = { class: "col-lg-2 col-3" }
const _hoisted_65 = {
  class: "climacon climacon_cloudFogMoonAltFill",
  id: "cloudFogMoonAltFill",
  version: "1.1",
  viewBox: "15 15 70 70"
}
const _hoisted_66 = { class: "col-lg-2 col-3" }
const _hoisted_67 = {
  class: "climacon climacon_cloudLightningSun",
  id: "cloudLightningfill1",
  version: "1.1",
  viewBox: "15 15 70 70"
}
const _hoisted_68 = { class: "col-lg-2 col-3" }
const _hoisted_69 = {
  class: "climacon climacon_cloudLightningMoon",
  id: "cloudLightningMoon",
  version: "1.1",
  viewBox: "15 15 70 70"
}
const _hoisted_70 = { class: "col-lg-2 col-3" }
const _hoisted_71 = {
  class: "climacon climacon_sunriseAlt",
  id: "sunriseAlt",
  version: "1.1",
  viewBox: "15 15 70 70"
}
const _hoisted_72 = { class: "col-lg-2 col-3" }
const _hoisted_73 = {
  class: "climacon climacon_sunriseAltFill",
  id: "sunriseAltFill",
  version: "1.1",
  viewBox: "15 15 70 70"
}
const _hoisted_74 = { class: "col-lg-2 col-3" }
const _hoisted_75 = {
  class: "climacon climacon_sunsetAlt",
  id: "sunsetAltfill",
  version: "1.1",
  viewBox: "15 15 70 70"
}
const _hoisted_76 = { class: "col-lg-2 col-3" }
const _hoisted_77 = {
  class: "climacon climacon_sunsetAltFill",
  id: "sunsetAltFill",
  version: "1.1",
  viewBox: "15 15 70 70"
}

import { defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexWhether',
  setup(__props) {

const Card9 = defineAsyncComponent(() => import("@/components/commen/card/cardData9.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_clippath = _resolveComponent("clippath")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Icons",
      title: "Weather Icons"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(Card9), {
          colClass: "col-sm-12",
          cardhaderClass: "pb-0",
          title: "Whether Icons With Animations"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(), _createElementBlock("svg", _hoisted_5, [
                  _createVNode(_component_clippath, { id: "sunFillClip" }, {
                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                      _createElementVNode("path", { d: "M0,0v100h100V0H0z M50.001,57.999c-4.417,0-8-3.582-8-7.999c0-4.418,3.582-7.999,8-7.999s7.998,3.581,7.998,7.999C57.999,54.417,54.418,57.999,50.001,57.999z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _cache[1] || (_cache[1] = _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-sun" }, [
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-sun" }, [
                      _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-sunSpoke" }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-east",
                          d: "M72.03,51.999h-3.998c-1.105,0-2-0.896-2-1.999s0.895-2,2-2h3.998c1.104,0,2,0.896,2,2S73.136,51.999,72.03,51.999z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-northEast",
                          d: "M64.175,38.688c-0.781,0.781-2.049,0.781-2.828,0c-0.781-0.781-0.781-2.047,0-2.828l2.828-2.828c0.779-0.781,2.047-0.781,2.828,0c0.779,0.781,0.779,2.047,0,2.828L64.175,38.688z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M50.034,34.002c-1.105,0-2-0.896-2-2v-3.999c0-1.104,0.895-2,2-2c1.104,0,2,0.896,2,2v3.999C52.034,33.106,51.136,34.002,50.034,34.002z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-northWest",
                          d: "M35.893,38.688l-2.827-2.828c-0.781-0.781-0.781-2.047,0-2.828c0.78-0.781,2.047-0.781,2.827,0l2.827,2.828c0.781,0.781,0.781,2.047,0,2.828C37.94,39.469,36.674,39.469,35.893,38.688z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-west",
                          d: "M34.034,50c0,1.104-0.896,1.999-2,1.999h-4c-1.104,0-1.998-0.896-1.998-1.999s0.896-2,1.998-2h4C33.14,48,34.034,48.896,34.034,50z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-southWest",
                          d: "M35.893,61.312c0.781-0.78,2.048-0.78,2.827,0c0.781,0.78,0.781,2.047,0,2.828l-2.827,2.827c-0.78,0.781-2.047,0.781-2.827,0c-0.781-0.78-0.781-2.047,0-2.827L35.893,61.312z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-south",
                          d: "M50.034,65.998c1.104,0,2,0.895,2,1.999v4c0,1.104-0.896,2-2,2c-1.105,0-2-0.896-2-2v-4C48.034,66.893,48.929,65.998,50.034,65.998z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-southEast",
                          d: "M64.175,61.312l2.828,2.828c0.779,0.78,0.779,2.047,0,2.827c-0.781,0.781-2.049,0.781-2.828,0l-2.828-2.827c-0.781-0.781-0.781-2.048,0-2.828C62.126,60.531,63.392,60.531,64.175,61.312z"
                        })
                      ]),
                      _createElementVNode("g", {
                        class: "climacon_componentWrap climacon_componentWrap_sunBody",
                        "clip-path": "url(#sunFillClip)"
                      }, [
                        _createElementVNode("circle", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                          cx: "50.034",
                          cy: "50",
                          r: "11.999"
                        })
                      ])
                    ])
                  ], -1))
                ]))
              ]),
              _cache[109] || (_cache[109] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_sunFill",
                  id: "sunFill",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-sunFill" }, [
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-sun" }, [
                      _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-sunSpoke" }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-east",
                          d: "M72.03,51.999h-3.998c-1.105,0-2-0.896-2-1.999s0.895-2,2-2h3.998c1.104,0,2,0.896,2,2S73.136,51.999,72.03,51.999z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-northEast",
                          d: "M64.175,38.688c-0.781,0.781-2.049,0.781-2.828,0c-0.781-0.781-0.781-2.047,0-2.828l2.828-2.828c0.779-0.781,2.047-0.781,2.828,0c0.779,0.781,0.779,2.047,0,2.828L64.175,38.688z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M50.034,34.002c-1.105,0-2-0.896-2-2v-3.999c0-1.104,0.895-2,2-2c1.104,0,2,0.896,2,2v3.999C52.034,33.106,51.136,34.002,50.034,34.002z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-northWest",
                          d: "M35.893,38.688l-2.827-2.828c-0.781-0.781-0.781-2.047,0-2.828c0.78-0.781,2.047-0.781,2.827,0l2.827,2.828c0.781,0.781,0.781,2.047,0,2.828C37.94,39.469,36.674,39.469,35.893,38.688z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-west",
                          d: "M34.034,50c0,1.104-0.896,1.999-2,1.999h-4c-1.104,0-1.998-0.896-1.998-1.999s0.896-2,1.998-2h4C33.14,48,34.034,48.896,34.034,50z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-southWest",
                          d: "M35.893,61.312c0.781-0.78,2.048-0.78,2.827,0c0.781,0.78,0.781,2.047,0,2.828l-2.827,2.827c-0.78,0.781-2.047,0.781-2.827,0c-0.781-0.78-0.781-2.047,0-2.827L35.893,61.312z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-south",
                          d: "M50.034,65.998c1.104,0,2,0.895,2,1.999v4c0,1.104-0.896,2-2,2c-1.105,0-2-0.896-2-2v-4C48.034,66.893,48.929,65.998,50.034,65.998z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-southEast",
                          d: "M64.175,61.312l2.828,2.828c0.779,0.78,0.779,2.047,0,2.827c-0.781,0.781-2.049,0.781-2.828,0l-2.828-2.827c-0.781-0.781-0.781-2.048,0-2.828C62.126,60.531,63.392,60.531,64.175,61.312z"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_sunBody" }, [
                        _createElementVNode("circle", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                          cx: "50.034",
                          cy: "50",
                          r: "11.999"
                        }),
                        _createElementVNode("circle", {
                          class: "climacon_component climacon_component-fill climacon_component-fill_sunBody",
                          fill: "#FFFFFF",
                          cx: "50.034",
                          cy: "50",
                          r: "7.999"
                        })
                      ])
                    ])
                  ])
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(), _createElementBlock("svg", _hoisted_7, [
                  _createVNode(_component_clippath, { id: "moonFillClip" }, {
                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M50,57.999c-4.418,0-7.999-3.582-7.999-7.999c0-3.803,2.655-6.979,6.211-7.792c0.903,4.854,4.726,8.676,9.579,9.58C56.979,55.344,53.802,57.999,50,57.999z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _cache[3] || (_cache[3] = _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-moon" }, [
                    _createElementVNode("g", {
                      class: "climacon_componentWrap climacon_componentWrap-moon",
                      "clip-path": "url(#moonFillClip)"
                    }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_moon",
                        d: "M50,61.998c-6.627,0-11.999-5.372-11.999-11.998c0-6.627,5.372-11.999,11.999-11.999c0.755,0,1.491,0.078,2.207,0.212c-0.132,0.576-0.208,1.173-0.208,1.788c0,4.418,3.582,7.999,8,7.999c0.614,0,1.212-0.076,1.788-0.208c0.133,0.717,0.211,1.452,0.211,2.208C61.998,56.626,56.626,61.998,50,61.998z"
                      })
                    ])
                  ], -1))
                ]))
              ]),
              _cache[110] || (_cache[110] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_moonFill",
                  id: "moonfill",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-moonFill" }, [
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-moon" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_moon",
                        d: "M50,61.998c-6.627,0-11.999-5.372-11.999-11.998c0-6.627,5.372-11.999,11.999-11.999c0.755,0,1.491,0.078,2.207,0.212c-0.132,0.576-0.208,1.173-0.208,1.788c0,4.418,3.582,7.999,8,7.999c0.614,0,1.212-0.076,1.788-0.208c0.133,0.717,0.211,1.452,0.211,2.208C61.998,56.626,56.626,61.998,50,61.998z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_moon",
                        fill: "#FFFFFF",
                        d: "M48.212,42.208c-3.556,0.813-6.211,3.989-6.211,7.792c0,4.417,3.581,7.999,7.999,7.999c3.802,0,6.979-2.655,7.791-6.211C52.938,50.884,49.115,47.062,48.212,42.208z"
                      })
                    ])
                  ])
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(), _createElementBlock("svg", _hoisted_9, [
                  _createVNode(_component_clippath, { id: "snowflakeFillClip" }, {
                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M50,54c-2.209,0-4-1.791-4-4c0-2.208,1.791-3.999,4-3.999s3.999,1.791,3.999,3.999C53.999,52.209,52.209,54,50,54z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _cache[5] || (_cache[5] = _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-snowflake" }, [
                    _createElementVNode("g", {
                      class: "climacon_componentWrap climacon_componentWrap-snowflake",
                      "clip-path": "url(#snowflakeFillClip)"
                    }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_snowflake",
                        d: "M59.659,46.733l-1.958,1.13c0.188,0.682,0.298,1.396,0.298,2.137c0,0.742-0.108,1.456-0.298,2.139l1.958,1.129c0.956,0.553,1.284,1.775,0.731,2.732c-0.553,0.956-1.774,1.284-2.731,0.73l-1.954-1.127c-1.003,1.02-2.277,1.766-3.705,2.133v2.263c0,1.104-0.896,2-2,2c-1.104,0-2-0.896-2-2v-2.263c-1.428-0.367-2.703-1.113-3.705-2.133l-1.954,1.127c-0.957,0.554-2.18,0.226-2.731-0.73c-0.553-0.957-0.225-2.18,0.731-2.732l1.958-1.129c-0.189-0.683-0.298-1.396-0.298-2.139c0-0.741,0.108-1.455,0.298-2.137l-1.958-1.13c-0.956-0.553-1.284-1.775-0.731-2.732c0.552-0.956,1.774-1.284,2.731-0.731l1.954,1.128c1.002-1.02,2.277-1.766,3.705-2.134v-2.262c0-1.104,0.896-2,2-2c1.104,0,2,0.896,2,2v2.262c1.428,0.368,2.702,1.114,3.705,2.134l1.954-1.128c0.957-0.553,2.18-0.225,2.731,0.731C60.943,44.958,60.615,46.181,59.659,46.733z"
                      })
                    ])
                  ], -1))
                ]))
              ]),
              _cache[111] || (_cache[111] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_snowflakeFill",
                  id: "snowflakeFill",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-snowflakeFill" }, [
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-snowflake" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_snowflake",
                        d: "M59.659,46.733l-1.958,1.13c0.188,0.682,0.298,1.396,0.298,2.137c0,0.742-0.108,1.456-0.298,2.139l1.958,1.129c0.956,0.553,1.284,1.775,0.731,2.732c-0.553,0.956-1.774,1.284-2.731,0.73l-1.954-1.127c-1.003,1.02-2.277,1.766-3.705,2.133v2.263c0,1.104-0.896,2-2,2c-1.104,0-2-0.896-2-2v-2.263c-1.428-0.367-2.703-1.113-3.705-2.133l-1.954,1.127c-0.957,0.554-2.18,0.226-2.731-0.73c-0.553-0.957-0.225-2.18,0.731-2.732l1.958-1.129c-0.189-0.683-0.298-1.396-0.298-2.139c0-0.741,0.108-1.455,0.298-2.137l-1.958-1.13c-0.956-0.553-1.284-1.775-0.731-2.732c0.552-0.956,1.774-1.284,2.731-0.731l1.954,1.128c1.002-1.02,2.277-1.766,3.705-2.134v-2.262c0-1.104,0.896-2,2-2c1.104,0,2,0.896,2,2v2.262c1.428,0.368,2.702,1.114,3.705,2.134l1.954-1.128c0.957-0.553,2.18-0.225,2.731,0.731C60.943,44.958,60.615,46.181,59.659,46.733z"
                      }),
                      _createElementVNode("circle", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_snowflake",
                        fill: "#FFFFFF",
                        cx: "50",
                        cy: "50",
                        r: "4"
                      })
                    ])
                  ])
                ])
              ], -1)),
              _cache[112] || (_cache[112] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_wind",
                  id: "wind",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-wind" }, [
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_componentWrap-wind" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-wind climacon_component-wind_curl",
                        d: "M65.999,52L65.999,52h-3c-1.104,0-2-0.895-2-1.999c0-1.104,0.896-2,2-2h3c1.104,0,2-0.896,2-1.999c0-1.105-0.896-2-2-2s-2-0.896-2-2s0.896-2,2-2c0.138,0,0.271,0.014,0.401,0.041c3.121,0.211,5.597,2.783,5.597,5.959C71.997,49.314,69.312,52,65.999,52z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-wind",
                        d: "M55.999,48.001h-2h-6.998H34.002c-1.104,0-1.999,0.896-1.999,2c0,1.104,0.895,1.999,1.999,1.999h2h3.999h3h4h3h3.998h2c3.313,0,6,2.688,6,6c0,3.176-2.476,5.748-5.597,5.959C56.271,63.986,56.139,64,55.999,64c-1.104,0-2-0.896-2-2c0-1.105,0.896-2,2-2s2-0.896,2-2s-0.896-2-2-2h-2h-3.998h-3h-4h-3h-3.999h-2c-3.313,0-5.999-2.686-5.999-5.999c0-3.175,2.475-5.747,5.596-5.959c0.131-0.026,0.266-0.04,0.403-0.04l0,0h12.999h6.998h2c1.104,0,2-0.896,2-2s-0.896-2-2-2s-2-0.895-2-2c0-1.104,0.896-2,2-2c0.14,0,0.272,0.015,0.403,0.041c3.121,0.211,5.597,2.783,5.597,5.959C61.999,45.314,59.312,48.001,55.999,48.001z"
                      })
                    ])
                  ])
                ])
              ], -1)),
              _cache[113] || (_cache[113] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_tornado",
                  id: "tornado",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-tornado" }, [
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-tornado" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_tornadoLine",
                        d: "M68.997,36.459H31.002c-1.104,0-2-0.896-2-1.999c0-1.104,0.896-2,2-2h37.995c1.104,0,2,0.896,2,2C70.997,35.563,70.102,36.459,68.997,36.459z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_tornadoLine",
                        d: "M35.002,40.459h29.996c1.104,0,2,0.896,2,2s-0.896,1.999-2,1.999H35.002c-1.104,0-2-0.896-2-1.999C33.002,41.354,33.898,40.459,35.002,40.459z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_tornadoLine",
                        d: "M39.001,48.458h21.998c1.104,0,1.999,0.896,1.999,1.999c0,1.104-0.896,2-1.999,2H39.001c-1.104,0-1.999-0.896-1.999-2C37.002,49.354,37.897,48.458,39.001,48.458z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_tornadoLine",
                        d: "M47,64.456h5.999c1.104,0,2,0.896,2,1.999s-0.896,2-2,2H47c-1.104,0-2-0.896-2-2S45.896,64.456,47,64.456z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_tornadoLine",
                        d: "M40.869,58.456c0-1.104,0.896-1.999,2-1.999h13.998c1.104,0,2,0.896,2,1.999c0,1.104-0.896,2-2,2H42.869C41.765,60.456,40.869,59.561,40.869,58.456z"
                      })
                    ])
                  ])
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(), _createElementBlock("svg", _hoisted_11, [
                  _createVNode(_component_clippath, { id: "cloudFillClip" }, {
                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M59.943,61.639c-3.02,0-12.381,0-15.999,0c-6.626,0-11.998-5.371-11.998-11.998c0-6.627,5.372-11.999,11.998-11.999c5.691,0,10.434,3.974,11.665,9.29c1.252-0.81,2.733-1.291,4.334-1.291c4.418,0,8,3.582,8,8C67.943,58.057,64.361,61.639,59.943,61.639z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _cache[7] || (_cache[7] = _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloud" }, [
                    _createElementVNode("g", {
                      class: "climacon_componentWrap climacon_componentWrap_cloud",
                      "clip-path": "url(#cloudFillClip)"
                    }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M43.945,65.639c-8.835,0-15.998-7.162-15.998-15.998c0-8.836,7.163-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,6.625-5.371,11.998-11.998,11.998C57.168,65.639,47.143,65.639,43.945,65.639z"
                      })
                    ])
                  ], -1))
                ]))
              ]),
              _cache[114] || (_cache[114] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_cloudFill",
                  id: "cloudFill",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloud" }, [
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M43.945,65.639c-8.835,0-15.998-7.162-15.998-15.998c0-8.836,7.163-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,6.625-5.371,11.998-11.998,11.998C57.168,65.639,47.143,65.639,43.945,65.639z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_cloud",
                        fill: "#FFFFFF",
                        d: "M59.943,61.639c4.418,0,8-3.582,8-7.998c0-4.417-3.582-8-8-8c-1.601,0-3.082,0.481-4.334,1.291c-1.23-5.316-5.973-9.29-11.665-9.29c-6.626,0-11.998,5.372-11.998,11.999c0,6.626,5.372,11.998,11.998,11.998C47.562,61.639,56.924,61.639,59.943,61.639z"
                      })
                    ])
                  ])
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(), _createElementBlock("svg", _hoisted_13, [
                  _createVNode(_component_clippath, { id: "cloudFillClipfill" }, {
                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M59.943,61.639c-3.02,0-12.381,0-15.999,0c-6.626,0-11.998-5.371-11.998-11.998c0-6.627,5.372-11.999,11.998-11.999c5.691,0,10.434,3.974,11.665,9.29c1.252-0.81,2.733-1.291,4.334-1.291c4.418,0,8,3.582,8,8C67.943,58.057,64.361,61.639,59.943,61.639z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_clippath, { id: "sunCloudFillClip" }, {
                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M57.945,49.641c-4.417,0-8-3.582-8-7.999c0-4.418,3.582-7.999,8-7.999s7.998,3.581,7.998,7.999C65.943,46.059,62.362,49.641,57.945,49.641z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _cache[10] || (_cache[10] = _createElementVNode("g", { class: "climacon_iconWrap climacon_cloudSun-iconWrap" }, [
                    _createElementVNode("g", { "clip-path": "url(#cloudFillClip)" }, [
                      _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-sun climacon_componentWrap-sun_cloud" }, [
                        _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_sunSpoke" }, [
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-orth",
                            d: "M80.029,43.611h-3.998c-1.105,0-2-0.896-2-1.999s0.895-2,2-2h3.998c1.104,0,2,0.896,2,2S81.135,43.611,80.029,43.611z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M72.174,30.3c-0.781,0.781-2.049,0.781-2.828,0c-0.781-0.781-0.781-2.047,0-2.828l2.828-2.828c0.779-0.781,2.047-0.781,2.828,0c0.779,0.781,0.779,2.047,0,2.828L72.174,30.3z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M58.033,25.614c-1.105,0-2-0.896-2-2v-3.999c0-1.104,0.895-2,2-2c1.104,0,2,0.896,2,2v3.999C60.033,24.718,59.135,25.614,58.033,25.614z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M43.892,30.3l-2.827-2.828c-0.781-0.781-0.781-2.047,0-2.828c0.78-0.781,2.047-0.781,2.827,0l2.827,2.828c0.781,0.781,0.781,2.047,0,2.828C45.939,31.081,44.673,31.081,43.892,30.3z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M42.033,41.612c0,1.104-0.896,1.999-2,1.999h-4c-1.104,0-1.998-0.896-1.998-1.999s0.896-2,1.998-2h4C41.139,39.612,42.033,40.509,42.033,41.612z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M43.892,52.925c0.781-0.78,2.048-0.78,2.827,0c0.781,0.78,0.781,2.047,0,2.828l-2.827,2.827c-0.78,0.781-2.047,0.781-2.827,0c-0.781-0.78-0.781-2.047,0-2.827L43.892,52.925z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M58.033,57.61c1.104,0,2,0.895,2,1.999v4c0,1.104-0.896,2-2,2c-1.105,0-2-0.896-2-2v-4C56.033,58.505,56.928,57.61,58.033,57.61z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M72.174,52.925l2.828,2.828c0.779,0.78,0.779,2.047,0,2.827c-0.781,0.781-2.049,0.781-2.828,0l-2.828-2.827c-0.781-0.781-0.781-2.048,0-2.828C70.125,52.144,71.391,52.144,72.174,52.925z"
                          })
                        ]),
                        _createElementVNode("g", {
                          class: "climacon_wrapperComponent climacon_wrapperComponent-sunBody",
                          "clip-path": "url(#sunCloudFillClip)"
                        }, [
                          _createElementVNode("circle", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                            cx: "58.033",
                            cy: "41.612",
                            r: "11.999"
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("g", {
                      class: "climacon_wrapperComponent climacon_wrapperComponent-cloud",
                      "clip-path": "url(#cloudFillClip)"
                    }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M44.033,65.641c-8.836,0-15.999-7.162-15.999-15.998c0-8.835,7.163-15.998,15.999-15.998c6.006,0,11.233,3.312,13.969,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,6.625-5.371,11.998-11.998,11.998C57.26,65.641,47.23,65.641,44.033,65.641z"
                      })
                    ])
                  ], -1))
                ]))
              ]),
              _cache[115] || (_cache[115] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_cloudSunFill",
                  id: "cloudSunFill",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_cloudSunFill-iconWrap" }, [
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-sun climacon_componentWrap-sun_cloud" }, [
                      _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_sunSpoke" }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M80.029,43.611h-3.998c-1.105,0-2-0.896-2-1.999s0.895-2,2-2h3.998c1.104,0,2,0.896,2,2S81.135,43.611,80.029,43.611z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M72.174,30.3c-0.781,0.781-2.049,0.781-2.828,0c-0.781-0.781-0.781-2.047,0-2.828l2.828-2.828c0.779-0.781,2.047-0.781,2.828,0c0.779,0.781,0.779,2.047,0,2.828L72.174,30.3z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M58.033,25.614c-1.105,0-2-0.896-2-2v-3.999c0-1.104,0.895-2,2-2c1.104,0,2,0.896,2,2v3.999C60.033,24.718,59.135,25.614,58.033,25.614z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M43.892,30.3l-2.827-2.828c-0.781-0.781-0.781-2.047,0-2.828c0.78-0.781,2.047-0.781,2.827,0l2.827,2.828c0.781,0.781,0.781,2.047,0,2.828C45.939,31.081,44.673,31.081,43.892,30.3z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M42.033,41.612c0,1.104-0.896,1.999-2,1.999h-4c-1.104,0-1.998-0.896-1.998-1.999s0.896-2,1.998-2h4C41.139,39.612,42.033,40.509,42.033,41.612z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M43.892,52.925c0.781-0.78,2.048-0.78,2.827,0c0.781,0.78,0.781,2.047,0,2.828l-2.827,2.827c-0.78,0.781-2.047,0.781-2.827,0c-0.781-0.78-0.781-2.047,0-2.827L43.892,52.925z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M58.033,57.61c1.104,0,2,0.895,2,1.999v4c0,1.104-0.896,2-2,2c-1.105,0-2-0.896-2-2v-4C56.033,58.505,56.928,57.61,58.033,57.61z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M72.174,52.925l2.828,2.828c0.779,0.78,0.779,2.047,0,2.827c-0.781,0.781-2.049,0.781-2.828,0l-2.828-2.827c-0.781-0.781-0.781-2.048,0-2.828C70.125,52.144,71.391,52.144,72.174,52.925z"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-sunBody" }, [
                        _createElementVNode("circle", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                          cx: "58.033",
                          cy: "41.612",
                          r: "11.999"
                        }),
                        _createElementVNode("circle", {
                          class: "climacon_component climacon_component-fill climacon_component-fill_sunBody",
                          fill: "#FFFFFF",
                          cx: "58.033",
                          cy: "41.612",
                          r: "7.999"
                        })
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M44.033,65.641c-8.836,0-15.999-7.162-15.999-15.998c0-8.835,7.163-15.998,15.999-15.998c6.006,0,11.233,3.312,13.969,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,6.625-5.371,11.998-11.998,11.998C57.26,65.641,47.23,65.641,44.033,65.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_cloud",
                        fill: "#FFFFFF",
                        d: "M60.035,61.641c4.418,0,8-3.582,8-7.998c0-4.418-3.582-8-8-8c-1.6,0-3.082,0.481-4.334,1.291c-1.23-5.316-5.976-9.29-11.668-9.29c-6.627,0-11.999,5.372-11.999,11.999c0,6.627,5.372,11.998,11.999,11.998C47.65,61.641,57.016,61.641,60.035,61.641z"
                      })
                    ])
                  ])
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_14, [
                (_openBlock(), _createElementBlock("svg", _hoisted_15, [
                  _createVNode(_component_clippath, { id: "cloudFillClipfill1" }, {
                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M59.943,61.639c-3.02,0-12.381,0-15.999,0c-6.626,0-11.998-5.371-11.998-11.998c0-6.627,5.372-11.999,11.998-11.999c5.691,0,10.434,3.974,11.665,9.29c1.252-0.81,2.733-1.291,4.334-1.291c4.418,0,8,3.582,8,8C67.943,58.057,64.361,61.639,59.943,61.639z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_clippath, { id: "moonCloudFillClipfill" }, {
                    default: _withCtx(() => _cache[12] || (_cache[12] = [
                      _createElementVNode("path", { d: "M0,0v100h100V0H0z M60.943,46.641c-4.418,0-7.999-3.582-7.999-7.999c0-3.803,2.655-6.979,6.211-7.792c0.903,4.854,4.726,8.676,9.579,9.58C67.922,43.986,64.745,46.641,60.943,46.641z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _cache[13] || (_cache[13] = _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudMoon" }, [
                    _createElementVNode("g", { "clip-path": "url(#cloudFillClip)" }, [
                      _createElementVNode("g", {
                        class: "climacon_wrapperComponent climacon_wrapperComponent-moon climacon_componentWrap-moon_cloud",
                        "clip-path": "url(#moonCloudFillClip)"
                      }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_moon",
                          d: "M61.023,50.641c-6.627,0-11.999-5.372-11.999-11.998c0-6.627,5.372-11.999,11.999-11.999c0.755,0,1.491,0.078,2.207,0.212c-0.132,0.576-0.208,1.173-0.208,1.788c0,4.418,3.582,7.999,8,7.999c0.614,0,1.212-0.076,1.788-0.208c0.133,0.717,0.211,1.452,0.211,2.208C73.021,45.269,67.649,50.641,61.023,50.641z"
                        })
                      ])
                    ]),
                    _createElementVNode("g", {
                      class: "climacon_wrapperComponent climacon_wrapperComponent-cloud",
                      "clip-path": "url(#cloudFillClip)"
                    }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M44.033,65.641c-8.836,0-15.999-7.162-15.999-15.998c0-8.835,7.163-15.998,15.999-15.998c6.006,0,11.233,3.312,13.969,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,6.625-5.371,11.998-11.998,11.998C57.26,65.641,47.23,65.641,44.033,65.641z"
                      })
                    ])
                  ], -1))
                ]))
              ]),
              _cache[116] || (_cache[116] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_cloudMoonFill",
                  id: "cloudMoonFill",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudMoonFill" }, [
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-moon climacon_componentWrap-moon_cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_moon",
                        d: "M61.023,50.641c-6.627,0-11.999-5.372-11.999-11.998c0-6.627,5.372-11.999,11.999-11.999c0.755,0,1.491,0.078,2.207,0.212c-0.132,0.576-0.208,1.173-0.208,1.788c0,4.418,3.582,7.999,8,7.999c0.614,0,1.212-0.076,1.788-0.208c0.133,0.717,0.211,1.452,0.211,2.208C73.021,45.269,67.649,50.641,61.023,50.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_moon",
                        fill: "#FFFFFF",
                        d: "M59.235,30.851c-3.556,0.813-6.211,3.989-6.211,7.792c0,4.417,3.581,7.999,7.999,7.999c3.802,0,6.979-2.655,7.791-6.211C63.961,39.527,60.139,35.705,59.235,30.851z"
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M44.033,65.641c-8.836,0-15.999-7.162-15.999-15.998c0-8.835,7.163-15.998,15.999-15.998c6.006,0,11.233,3.312,13.969,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,6.625-5.371,11.998-11.998,11.998C57.26,65.641,47.23,65.641,44.033,65.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_cloud",
                        fill: "#FFFFFF",
                        d: "M60.035,61.641c4.418,0,8-3.582,8-7.998c0-4.418-3.582-8-8-8c-1.6,0-3.082,0.481-4.334,1.291c-1.23-5.316-5.976-9.29-11.668-9.29c-6.627,0-11.999,5.372-11.999,11.999c0,6.627,5.372,11.998,11.999,11.998C47.65,61.641,57.016,61.641,60.035,61.641z"
                      })
                    ])
                  ])
                ])
              ], -1)),
              _cache[117] || (_cache[117] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_cloudDrizzle",
                  id: "cloudDrizzle",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudDrizzle" }, [
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-drizzle" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_drizzle climacon_component-stroke_drizzle-left",
                        d: "M42.001,53.644c1.104,0,2,0.896,2,2v3.998c0,1.105-0.896,2-2,2c-1.105,0-2.001-0.895-2.001-2v-3.998C40,54.538,40.896,53.644,42.001,53.644z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_drizzle climacon_component-stroke_drizzle-middle",
                        d: "M49.999,53.644c1.104,0,2,0.896,2,2v4c0,1.104-0.896,2-2,2s-1.998-0.896-1.998-2v-4C48.001,54.54,48.896,53.644,49.999,53.644z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_drizzle climacon_component-stroke_drizzle-right",
                        d: "M57.999,53.644c1.104,0,2,0.896,2,2v3.998c0,1.105-0.896,2-2,2c-1.105,0-2-0.895-2-2v-3.998C55.999,54.538,56.894,53.644,57.999,53.644z"
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M63.999,64.944v-4.381c2.387-1.386,3.998-3.961,3.998-6.92c0-4.418-3.58-8-7.998-8c-1.603,0-3.084,0.481-4.334,1.291c-1.232-5.316-5.973-9.29-11.664-9.29c-6.628,0-11.999,5.372-11.999,12c0,3.549,1.55,6.729,3.998,8.926v4.914c-4.776-2.769-7.998-7.922-7.998-13.84c0-8.836,7.162-15.999,15.999-15.999c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.336-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12C71.997,58.864,68.655,63.296,63.999,64.944z"
                      })
                    ])
                  ])
                ])
              ], -1)),
              _cache[118] || (_cache[118] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_cloudDrizzleFill",
                  id: "cloudDrizzleFill",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudDrizzleFill" }, [
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-drizzle" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_drizzle climacon_component-stroke_drizzle-left",
                        d: "M42.001,53.644c1.104,0,2,0.896,2,2v3.998c0,1.105-0.896,2-2,2c-1.105,0-2.001-0.895-2.001-2v-3.998C40,54.538,40.896,53.644,42.001,53.644z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_drizzle climacon_component-stroke_drizzle-middle",
                        d: "M49.999,53.644c1.104,0,2,0.896,2,2v4c0,1.104-0.896,2-2,2s-1.998-0.896-1.998-2v-4C48.001,54.54,48.896,53.644,49.999,53.644z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_drizzle climacon_component-stroke_drizzle-right",
                        d: "M57.999,53.644c1.104,0,2,0.896,2,2v3.998c0,1.105-0.896,2-2,2c-1.105,0-2-0.895-2-2v-3.998C55.999,54.538,56.894,53.644,57.999,53.644z"
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M43.945,65.639c-8.835,0-15.998-7.162-15.998-15.998c0-8.836,7.163-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,6.625-5.371,11.998-11.998,11.998C57.168,65.639,47.143,65.639,43.945,65.639z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_cloud",
                        fill: "#FFFFFF",
                        d: "M59.943,61.639c4.418,0,8-3.582,8-7.998c0-4.417-3.582-8-8-8c-1.601,0-3.082,0.481-4.334,1.291c-1.23-5.316-5.973-9.29-11.665-9.29c-6.626,0-11.998,5.372-11.998,11.999c0,6.626,5.372,11.998,11.998,11.998C47.562,61.639,56.924,61.639,59.943,61.639z"
                      })
                    ])
                  ])
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_16, [
                (_openBlock(), _createElementBlock("svg", _hoisted_17, [
                  _createVNode(_component_clippath, { id: "cloudFillClipfill2_2" }, {
                    default: _withCtx(() => _cache[14] || (_cache[14] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M59.943,61.639c-3.02,0-12.381,0-15.999,0c-6.626,0-11.998-5.371-11.998-11.998c0-6.627,5.372-11.999,11.998-11.999c5.691,0,10.434,3.974,11.665,9.29c1.252-0.81,2.733-1.291,4.334-1.291c4.418,0,8,3.582,8,8C67.943,58.057,64.361,61.639,59.943,61.639z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_clippath, { id: "sunCloudFillClipfill4" }, {
                    default: _withCtx(() => _cache[15] || (_cache[15] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M57.945,49.641c-4.417,0-8-3.582-8-7.999c0-4.418,3.582-7.999,8-7.999s7.998,3.581,7.998,7.999C65.943,46.059,62.362,49.641,57.945,49.641z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_clippath, { id: "cloudSunFillClip" }, {
                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                      _createElementVNode("path", { d: "M15,15v70h20.947V63.481c-4.778-2.767-8-7.922-8-13.84c0-8.836,7.163-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,5.262-3.394,9.723-8.107,11.341V85H85V15H15z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _cache[17] || (_cache[17] = _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudDrizzleSun" }, [
                    _createElementVNode("g", { "clip-path": "url(#cloudSunFillClip)" }, [
                      _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-sun climacon_componentWrap-sun_cloud" }, [
                        _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_sunSpoke" }, [
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M80.029,43.611h-3.998c-1.105,0-2-0.896-2-1.999s0.895-2,2-2h3.998c1.104,0,2,0.896,2,2S81.135,43.611,80.029,43.611z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M72.174,30.3c-0.781,0.781-2.049,0.781-2.828,0c-0.781-0.781-0.781-2.047,0-2.828l2.828-2.828c0.779-0.781,2.047-0.781,2.828,0c0.779,0.781,0.779,2.047,0,2.828L72.174,30.3z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M58.033,25.614c-1.105,0-2-0.896-2-2v-3.999c0-1.104,0.895-2,2-2c1.104,0,2,0.896,2,2v3.999C60.033,24.718,59.135,25.614,58.033,25.614z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M43.892,30.3l-2.827-2.828c-0.781-0.781-0.781-2.047,0-2.828c0.78-0.781,2.047-0.781,2.827,0l2.827,2.828c0.781,0.781,0.781,2.047,0,2.828C45.939,31.081,44.673,31.081,43.892,30.3z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M42.033,41.612c0,1.104-0.896,1.999-2,1.999h-4c-1.104,0-1.998-0.896-1.998-1.999s0.896-2,1.998-2h4C41.139,39.612,42.033,40.509,42.033,41.612z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M43.892,52.925c0.781-0.78,2.048-0.78,2.827,0c0.781,0.78,0.781,2.047,0,2.828l-2.827,2.827c-0.78,0.781-2.047,0.781-2.827,0c-0.781-0.78-0.781-2.047,0-2.827L43.892,52.925z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M58.033,57.61c1.104,0,2,0.895,2,1.999v4c0,1.104-0.896,2-2,2c-1.105,0-2-0.896-2-2v-4C56.033,58.505,56.928,57.61,58.033,57.61z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M72.174,52.925l2.828,2.828c0.779,0.78,0.779,2.047,0,2.827c-0.781,0.781-2.049,0.781-2.828,0l-2.828-2.827c-0.781-0.781-0.781-2.048,0-2.828C70.125,52.144,71.391,52.144,72.174,52.925z"
                          })
                        ]),
                        _createElementVNode("g", {
                          class: "climacon_wrapperComponent climacon_wrapperComponent-sunBody",
                          "clip-path": "url(#sunCloudFillClip)"
                        }, [
                          _createElementVNode("circle", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                            cx: "58.033",
                            cy: "41.612",
                            r: "11.999"
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-drizzle" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_drizzle climacon_component-stroke_drizzle-left",
                        d: "M42.001,53.644c1.104,0,2,0.896,2,2v3.998c0,1.105-0.896,2-2,2c-1.105,0-2.001-0.895-2.001-2v-3.998C40,54.538,40.896,53.644,42.001,53.644z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_drizzle climacon_component-stroke_drizzle-middle",
                        d: "M49.999,53.644c1.104,0,2,0.896,2,2v4c0,1.104-0.896,2-2,2s-1.998-0.896-1.998-2v-4C48.001,54.54,48.896,53.644,49.999,53.644z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_drizzle climacon_component-stroke_drizzle-right",
                        d: "M57.999,53.644c1.104,0,2,0.896,2,2v3.998c0,1.105-0.896,2-2,2c-1.105,0-2-0.895-2-2v-3.998C55.999,54.538,56.894,53.644,57.999,53.644z"
                      })
                    ]),
                    _createElementVNode("g", {
                      class: "climacon_wrapperComponent climacon_wrapperComponent-cloud",
                      "clip-path": "url(#cloudFillClip)"
                    }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M63.999,64.944v-4.381c2.387-1.386,3.998-3.961,3.998-6.92c0-4.418-3.58-8-7.998-8c-1.603,0-3.084,0.481-4.334,1.291c-1.232-5.316-5.973-9.29-11.664-9.29c-6.628,0-11.999,5.372-11.999,12c0,3.549,1.55,6.729,3.998,8.926v4.914c-4.776-2.769-7.998-7.922-7.998-13.84c0-8.836,7.162-15.999,15.999-15.999c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.336-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12C71.997,58.864,68.655,63.296,63.999,64.944z"
                      })
                    ])
                  ], -1))
                ]))
              ]),
              _cache[119] || (_cache[119] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_cloudDrizzleSunFill",
                  id: "cloudDrizzleSunFill",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudDrizzleSunFill" }, [
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-sun climacon_componentWrap-sun_cloud" }, [
                      _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_sunSpoke" }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M80.029,43.611h-3.998c-1.105,0-2-0.896-2-1.999s0.895-2,2-2h3.998c1.104,0,2,0.896,2,2S81.135,43.611,80.029,43.611z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M72.174,30.3c-0.781,0.781-2.049,0.781-2.828,0c-0.781-0.781-0.781-2.047,0-2.828l2.828-2.828c0.779-0.781,2.047-0.781,2.828,0c0.779,0.781,0.779,2.047,0,2.828L72.174,30.3z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M58.033,25.614c-1.105,0-2-0.896-2-2v-3.999c0-1.104,0.895-2,2-2c1.104,0,2,0.896,2,2v3.999C60.033,24.718,59.135,25.614,58.033,25.614z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M43.892,30.3l-2.827-2.828c-0.781-0.781-0.781-2.047,0-2.828c0.78-0.781,2.047-0.781,2.827,0l2.827,2.828c0.781,0.781,0.781,2.047,0,2.828C45.939,31.081,44.673,31.081,43.892,30.3z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M42.033,41.612c0,1.104-0.896,1.999-2,1.999h-4c-1.104,0-1.998-0.896-1.998-1.999s0.896-2,1.998-2h4C41.139,39.612,42.033,40.509,42.033,41.612z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M43.892,52.925c0.781-0.78,2.048-0.78,2.827,0c0.781,0.78,0.781,2.047,0,2.828l-2.827,2.827c-0.78,0.781-2.047,0.781-2.827,0c-0.781-0.78-0.781-2.047,0-2.827L43.892,52.925z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M58.033,57.61c1.104,0,2,0.895,2,1.999v4c0,1.104-0.896,2-2,2c-1.105,0-2-0.896-2-2v-4C56.033,58.505,56.928,57.61,58.033,57.61z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M72.174,52.925l2.828,2.828c0.779,0.78,0.779,2.047,0,2.827c-0.781,0.781-2.049,0.781-2.828,0l-2.828-2.827c-0.781-0.781-0.781-2.048,0-2.828C70.125,52.144,71.391,52.144,72.174,52.925z"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-sunBody" }, [
                        _createElementVNode("circle", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                          cx: "58.033",
                          cy: "41.612",
                          r: "11.999"
                        }),
                        _createElementVNode("circle", {
                          class: "climacon_component climacon_component-fill climacon_component-fill_sunBody",
                          fill: "#FFFFFF",
                          cx: "58.033",
                          cy: "41.612",
                          r: "7.999"
                        })
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-drizzle" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_drizzle climacon_component-stroke_drizzle-left",
                        d: "M42.001,53.644c1.104,0,2,0.896,2,2v3.998c0,1.105-0.896,2-2,2c-1.105,0-2.001-0.895-2.001-2v-3.998C40,54.538,40.896,53.644,42.001,53.644z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_drizzle climacon_component-stroke_drizzle-middle",
                        d: "M49.999,53.644c1.104,0,2,0.896,2,2v4c0,1.104-0.896,2-2,2s-1.998-0.896-1.998-2v-4C48.001,54.54,48.896,53.644,49.999,53.644z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_drizzle climacon_component-stroke_drizzle-right",
                        d: "M57.999,53.644c1.104,0,2,0.896,2,2v3.998c0,1.105-0.896,2-2,2c-1.105,0-2-0.895-2-2v-3.998C55.999,54.538,56.894,53.644,57.999,53.644z"
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M43.945,65.639c-8.835,0-15.998-7.162-15.998-15.998c0-8.836,7.163-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,6.625-5.371,11.998-11.998,11.998C57.168,65.639,47.143,65.639,43.945,65.639z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_cloud",
                        fill: "#FFFFFF",
                        d: "M59.943,61.639c4.418,0,8-3.582,8-7.998c0-4.417-3.582-8-8-8c-1.601,0-3.082,0.481-4.334,1.291c-1.23-5.316-5.973-9.29-11.665-9.29c-6.626,0-11.998,5.372-11.998,11.999c0,6.626,5.372,11.998,11.998,11.998C47.562,61.639,56.924,61.639,59.943,61.639z"
                      })
                    ])
                  ])
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_18, [
                (_openBlock(), _createElementBlock("svg", _hoisted_19, [
                  _createVNode(_component_clippath, { id: "moonCloudFillClipfill1" }, {
                    default: _withCtx(() => _cache[18] || (_cache[18] = [
                      _createElementVNode("path", { d: "M0,0v100h100V0H0z M60.943,46.641c-4.418,0-7.999-3.582-7.999-7.999c0-3.803,2.655-6.979,6.211-7.792c0.903,4.854,4.726,8.676,9.579,9.58C67.922,43.986,64.745,46.641,60.943,46.641z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_clippath, { id: "cloudFillClipfill11" }, {
                    default: _withCtx(() => _cache[19] || (_cache[19] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M59.943,61.639c-3.02,0-12.381,0-15.999,0c-6.626,0-11.998-5.371-11.998-11.998c0-6.627,5.372-11.999,11.998-11.999c5.691,0,10.434,3.974,11.665,9.29c1.252-0.81,2.733-1.291,4.334-1.291c4.418,0,8,3.582,8,8C67.943,58.057,64.361,61.639,59.943,61.639z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _cache[20] || (_cache[20] = _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudDrizzleMoon" }, [
                    _createElementVNode("g", { "clip-path": "url(#cloudFillClip)" }, [
                      _createElementVNode("g", {
                        class: "climacon_wrapperComponent climacon_wrapperComponent-moon climacon_componentWrap-moon_cloud",
                        "clip-path": "url(#moonCloudFillClip)"
                      }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_moon",
                          d: "M61.023,50.641c-6.627,0-11.999-5.372-11.999-11.998c0-6.627,5.372-11.999,11.999-11.999c0.755,0,1.491,0.078,2.207,0.212c-0.132,0.576-0.208,1.173-0.208,1.788c0,4.418,3.582,7.999,8,7.999c0.614,0,1.212-0.076,1.788-0.208c0.133,0.717,0.211,1.452,0.211,2.208C73.021,45.269,67.649,50.641,61.023,50.641z"
                        })
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-drizzle" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_drizzle climacon_component-stroke_drizzle-left",
                        d: "M42.001,53.644c1.104,0,2,0.896,2,2v3.998c0,1.105-0.896,2-2,2c-1.105,0-2.001-0.895-2.001-2v-3.998C40,54.538,40.896,53.644,42.001,53.644z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_drizzle climacon_component-stroke_drizzle-middle",
                        d: "M49.999,53.644c1.104,0,2,0.896,2,2v4c0,1.104-0.896,2-2,2s-1.998-0.896-1.998-2v-4C48.001,54.54,48.896,53.644,49.999,53.644z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_drizzle climacon_component-stroke_drizzle-right",
                        d: "M57.999,53.644c1.104,0,2,0.896,2,2v3.998c0,1.105-0.896,2-2,2c-1.105,0-2-0.895-2-2v-3.998C55.999,54.538,56.894,53.644,57.999,53.644z"
                      })
                    ]),
                    _createElementVNode("g", {
                      class: "climacon_wrapperComponent climacon_wrapperComponent-cloud",
                      "clip-path": "url(#cloudFillClip)"
                    }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M63.999,64.944v-4.381c2.387-1.386,3.998-3.961,3.998-6.92c0-4.418-3.58-8-7.998-8c-1.603,0-3.084,0.481-4.334,1.291c-1.232-5.316-5.973-9.29-11.664-9.29c-6.628,0-11.999,5.372-11.999,12c0,3.549,1.55,6.729,3.998,8.926v4.914c-4.776-2.769-7.998-7.922-7.998-13.84c0-8.836,7.162-15.999,15.999-15.999c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.336-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12C71.997,58.864,68.655,63.296,63.999,64.944z"
                      })
                    ])
                  ], -1))
                ]))
              ]),
              _cache[120] || (_cache[120] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_cloudDrizzleMoonFill",
                  id: "cloudDrizzleMoonFill",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudDrizzleMoonFill" }, [
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-moon climacon_componentWrap-moon_cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_moon",
                        d: "M61.023,50.641c-6.627,0-11.999-5.372-11.999-11.998c0-6.627,5.372-11.999,11.999-11.999c0.755,0,1.491,0.078,2.207,0.212c-0.132,0.576-0.208,1.173-0.208,1.788c0,4.418,3.582,7.999,8,7.999c0.614,0,1.212-0.076,1.788-0.208c0.133,0.717,0.211,1.452,0.211,2.208C73.021,45.269,67.649,50.641,61.023,50.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_moon",
                        fill: "#FFFFFF",
                        d: "M59.235,30.851c-3.556,0.813-6.211,3.989-6.211,7.792c0,4.417,3.581,7.999,7.999,7.999c3.802,0,6.979-2.655,7.791-6.211C63.961,39.527,60.139,35.705,59.235,30.851z"
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-drizzle" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_drizzle climacon_component-stroke_drizzle-left",
                        d: "M42.001,53.644c1.104,0,2,0.896,2,2v3.998c0,1.105-0.896,2-2,2c-1.105,0-2.001-0.895-2.001-2v-3.998C40,54.538,40.896,53.644,42.001,53.644z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_drizzle climacon_component-stroke_drizzle-middle",
                        d: "M49.999,53.644c1.104,0,2,0.896,2,2v4c0,1.104-0.896,2-2,2s-1.998-0.896-1.998-2v-4C48.001,54.54,48.896,53.644,49.999,53.644z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_drizzle climacon_component-stroke_drizzle-right",
                        d: "M57.999,53.644c1.104,0,2,0.896,2,2v3.998c0,1.105-0.896,2-2,2c-1.105,0-2-0.895-2-2v-3.998C55.999,54.538,56.894,53.644,57.999,53.644z"
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M43.945,65.639c-8.835,0-15.998-7.162-15.998-15.998c0-8.836,7.163-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,6.625-5.371,11.998-11.998,11.998C57.168,65.639,47.143,65.639,43.945,65.639z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_cloud",
                        fill: "#FFFFFF",
                        d: "M59.943,61.639c4.418,0,8-3.582,8-7.998c0-4.417-3.582-8-8-8c-1.601,0-3.082,0.481-4.334,1.291c-1.23-5.316-5.973-9.29-11.665-9.29c-6.626,0-11.998,5.372-11.998,11.999c0,6.626,5.372,11.998,11.998,11.998C47.562,61.639,56.924,61.639,59.943,61.639z"
                      })
                    ])
                  ])
                ])
              ], -1)),
              _cache[121] || (_cache[121] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_cloudDrizzleAlt",
                  id: "cloudDrizzleAlt",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudDrizzleAlt" }, [
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-drizzle" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_drizzle climacon_component-stroke_drizzle-left",
                        id: "Drizzle-Left_1_",
                        d: "M56.969,57.672l-2.121,2.121c-1.172,1.172-1.172,3.072,0,4.242c1.17,1.172,3.07,1.172,4.24,0c1.172-1.17,1.172-3.07,0-4.242L56.969,57.672z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_drizzle climacon_component-stroke_drizzle-middle",
                        d: "M50.088,57.672l-2.119,2.121c-1.174,1.172-1.174,3.07,0,4.242c1.17,1.172,3.068,1.172,4.24,0s1.172-3.07,0-4.242L50.088,57.672z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_drizzle climacon_component-stroke_drizzle-right",
                        d: "M43.033,57.672l-2.121,2.121c-1.172,1.172-1.172,3.07,0,4.242s3.07,1.172,4.244,0c1.172-1.172,1.172-3.07,0-4.242L43.033,57.672z"
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M59.943,41.642c-0.696,0-1.369,0.092-2.033,0.205c-2.736-4.892-7.961-8.203-13.965-8.203c-8.835,0-15.998,7.162-15.998,15.997c0,5.992,3.3,11.207,8.177,13.947c0.276-1.262,0.892-2.465,1.873-3.445l0.057-0.057c-3.644-2.061-6.106-5.963-6.106-10.445c0-6.626,5.372-11.998,11.998-11.998c5.691,0,10.433,3.974,11.666,9.29c1.25-0.81,2.732-1.291,4.332-1.291c4.418,0,8,3.581,8,7.999c0,3.443-2.182,6.371-5.235,7.498c0.788,1.146,1.194,2.471,1.222,3.807c4.666-1.645,8.014-6.077,8.014-11.305C71.941,47.014,66.57,41.642,59.943,41.642z"
                      })
                    ])
                  ])
                ])
              ], -1)),
              _cache[122] || (_cache[122] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_cloudDrizzleFillAlt",
                  id: "cloudDrizzleAltfill1",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudDrizzleFillAlt" }, [
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-drizzle" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_drizzle climacon_component-stroke_drizzle-left",
                        id: "Drizzle-Left_1_1",
                        d: "M56.969,57.672l-2.121,2.121c-1.172,1.172-1.172,3.072,0,4.242c1.17,1.172,3.07,1.172,4.24,0c1.172-1.17,1.172-3.07,0-4.242L56.969,57.672z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_drizzle climacon_component-stroke_drizzle-middle",
                        d: "M50.088,57.672l-2.119,2.121c-1.174,1.172-1.174,3.07,0,4.242c1.17,1.172,3.068,1.172,4.24,0s1.172-3.07,0-4.242L50.088,57.672z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_drizzle climacon_component-stroke_drizzle-right",
                        d: "M43.033,57.672l-2.121,2.121c-1.172,1.172-1.172,3.07,0,4.242s3.07,1.172,4.244,0c1.172-1.172,1.172-3.07,0-4.242L43.033,57.672z"
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M43.945,65.639c-8.835,0-15.998-7.162-15.998-15.998c0-8.836,7.163-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,6.625-5.371,11.998-11.998,11.998C57.168,65.639,47.143,65.639,43.945,65.639z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_cloud",
                        fill: "#FFFFFF",
                        d: "M59.943,61.639c4.418,0,8-3.582,8-7.998c0-4.417-3.582-8-8-8c-1.601,0-3.082,0.481-4.334,1.291c-1.23-5.316-5.973-9.29-11.665-9.29c-6.626,0-11.998,5.372-11.998,11.999c0,6.626,5.372,11.998,11.998,11.998C47.562,61.639,56.924,61.639,59.943,61.639z"
                      })
                    ])
                  ])
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_20, [
                (_openBlock(), _createElementBlock("svg", _hoisted_21, [
                  _createVNode(_component_clippath, { id: "sunCloudFillClipfill1" }, {
                    default: _withCtx(() => _cache[21] || (_cache[21] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M57.945,49.641c-4.417,0-8-3.582-8-7.999c0-4.418,3.582-7.999,8-7.999s7.998,3.581,7.998,7.999C65.943,46.059,62.362,49.641,57.945,49.641z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_clippath, { id: "cloudSunFillClipfill" }, {
                    default: _withCtx(() => _cache[22] || (_cache[22] = [
                      _createElementVNode("path", { d: "M15,15v70h20.947V63.481c-4.778-2.767-8-7.922-8-13.84c0-8.836,7.163-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,5.262-3.394,9.723-8.107,11.341V85H85V15H15z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _cache[23] || (_cache[23] = _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudDrizzleSunAlt" }, [
                    _createElementVNode("g", { "clip-path": "url(#cloudSunFillClip)" }, [
                      _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-sun climacon_componentWrap-sun_cloud" }, [
                        _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_sunSpoke" }, [
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M80.029,43.611h-3.998c-1.105,0-2-0.896-2-1.999s0.895-2,2-2h3.998c1.104,0,2,0.896,2,2S81.135,43.611,80.029,43.611z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M72.174,30.3c-0.781,0.781-2.049,0.781-2.828,0c-0.781-0.781-0.781-2.047,0-2.828l2.828-2.828c0.779-0.781,2.047-0.781,2.828,0c0.779,0.781,0.779,2.047,0,2.828L72.174,30.3z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M58.033,25.614c-1.105,0-2-0.896-2-2v-3.999c0-1.104,0.895-2,2-2c1.104,0,2,0.896,2,2v3.999C60.033,24.718,59.135,25.614,58.033,25.614z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M43.892,30.3l-2.827-2.828c-0.781-0.781-0.781-2.047,0-2.828c0.78-0.781,2.047-0.781,2.827,0l2.827,2.828c0.781,0.781,0.781,2.047,0,2.828C45.939,31.081,44.673,31.081,43.892,30.3z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M42.033,41.612c0,1.104-0.896,1.999-2,1.999h-4c-1.104,0-1.998-0.896-1.998-1.999s0.896-2,1.998-2h4C41.139,39.612,42.033,40.509,42.033,41.612z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M43.892,52.925c0.781-0.78,2.048-0.78,2.827,0c0.781,0.78,0.781,2.047,0,2.828l-2.827,2.827c-0.78,0.781-2.047,0.781-2.827,0c-0.781-0.78-0.781-2.047,0-2.827L43.892,52.925z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M58.033,57.61c1.104,0,2,0.895,2,1.999v4c0,1.104-0.896,2-2,2c-1.105,0-2-0.896-2-2v-4C56.033,58.505,56.928,57.61,58.033,57.61z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M72.174,52.925l2.828,2.828c0.779,0.78,0.779,2.047,0,2.827c-0.781,0.781-2.049,0.781-2.828,0l-2.828-2.827c-0.781-0.781-0.781-2.048,0-2.828C70.125,52.144,71.391,52.144,72.174,52.925z"
                          })
                        ]),
                        _createElementVNode("g", {
                          class: "climacon_wrapperComponent climacon_wrapperComponent-sunBody",
                          "clip-path": "url(#sunCloudFillClip)"
                        }, [
                          _createElementVNode("circle", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                            cx: "58.033",
                            cy: "41.612",
                            r: "11.999"
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-drizzle" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_drizzle climacon_component-stroke_drizzle-left",
                        id: "Drizzle-Left_1_2",
                        d: "M56.969,57.672l-2.121,2.121c-1.172,1.172-1.172,3.072,0,4.242c1.17,1.172,3.07,1.172,4.24,0c1.172-1.17,1.172-3.07,0-4.242L56.969,57.672z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_drizzle climacon_component-stroke_drizzle-middle",
                        d: "M50.088,57.672l-2.119,2.121c-1.174,1.172-1.174,3.07,0,4.242c1.17,1.172,3.068,1.172,4.24,0s1.172-3.07,0-4.242L50.088,57.672z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_drizzle climacon_component-stroke_drizzle-right",
                        d: "M43.033,57.672l-2.121,2.121c-1.172,1.172-1.172,3.07,0,4.242s3.07,1.172,4.244,0c1.172-1.172,1.172-3.07,0-4.242L43.033,57.672z"
                      })
                    ]),
                    _createElementVNode("g", {
                      class: "climacon_wrapperComponent climacon_wrapperComponent-cloud",
                      "clip-path": "url(#cloudFillClip)"
                    }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M63.999,64.944v-4.381c2.387-1.386,3.998-3.961,3.998-6.92c0-4.418-3.58-8-7.998-8c-1.603,0-3.084,0.481-4.334,1.291c-1.232-5.316-5.973-9.29-11.664-9.29c-6.628,0-11.999,5.372-11.999,12c0,3.549,1.55,6.729,3.998,8.926v4.914c-4.776-2.769-7.998-7.922-7.998-13.84c0-8.836,7.162-15.999,15.999-15.999c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.336-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12C71.997,58.864,68.655,63.296,63.999,64.944z"
                      })
                    ])
                  ], -1))
                ]))
              ]),
              _cache[123] || (_cache[123] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_cloudDrizzleSunFillAlt",
                  id: "cloudDrizzleSunFillAlt",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudDrizzleSunFillAlt" }, [
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-sun climacon_componentWrap-sun_cloud" }, [
                      _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_sunSpoke" }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M80.029,43.611h-3.998c-1.105,0-2-0.896-2-1.999s0.895-2,2-2h3.998c1.104,0,2,0.896,2,2S81.135,43.611,80.029,43.611z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M72.174,30.3c-0.781,0.781-2.049,0.781-2.828,0c-0.781-0.781-0.781-2.047,0-2.828l2.828-2.828c0.779-0.781,2.047-0.781,2.828,0c0.779,0.781,0.779,2.047,0,2.828L72.174,30.3z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M58.033,25.614c-1.105,0-2-0.896-2-2v-3.999c0-1.104,0.895-2,2-2c1.104,0,2,0.896,2,2v3.999C60.033,24.718,59.135,25.614,58.033,25.614z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M43.892,30.3l-2.827-2.828c-0.781-0.781-0.781-2.047,0-2.828c0.78-0.781,2.047-0.781,2.827,0l2.827,2.828c0.781,0.781,0.781,2.047,0,2.828C45.939,31.081,44.673,31.081,43.892,30.3z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M42.033,41.612c0,1.104-0.896,1.999-2,1.999h-4c-1.104,0-1.998-0.896-1.998-1.999s0.896-2,1.998-2h4C41.139,39.612,42.033,40.509,42.033,41.612z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M43.892,52.925c0.781-0.78,2.048-0.78,2.827,0c0.781,0.78,0.781,2.047,0,2.828l-2.827,2.827c-0.78,0.781-2.047,0.781-2.827,0c-0.781-0.78-0.781-2.047,0-2.827L43.892,52.925z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M58.033,57.61c1.104,0,2,0.895,2,1.999v4c0,1.104-0.896,2-2,2c-1.105,0-2-0.896-2-2v-4C56.033,58.505,56.928,57.61,58.033,57.61z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M72.174,52.925l2.828,2.828c0.779,0.78,0.779,2.047,0,2.827c-0.781,0.781-2.049,0.781-2.828,0l-2.828-2.827c-0.781-0.781-0.781-2.048,0-2.828C70.125,52.144,71.391,52.144,72.174,52.925z"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-sunBody" }, [
                        _createElementVNode("circle", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                          cx: "58.033",
                          cy: "41.612",
                          r: "11.999"
                        }),
                        _createElementVNode("circle", {
                          class: "climacon_component climacon_component-fill climacon_component-fill_sunBody",
                          fill: "#FFFFFF",
                          cx: "58.033",
                          cy: "41.612",
                          r: "7.999"
                        })
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-drizzle" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_drizzle climacon_component-stroke_drizzle-left",
                        id: "Drizzle-Left_1_3",
                        d: "M56.969,57.672l-2.121,2.121c-1.172,1.172-1.172,3.072,0,4.242c1.17,1.172,3.07,1.172,4.24,0c1.172-1.17,1.172-3.07,0-4.242L56.969,57.672z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_drizzle climacon_component-stroke_drizzle-middle",
                        d: "M50.088,57.672l-2.119,2.121c-1.174,1.172-1.174,3.07,0,4.242c1.17,1.172,3.068,1.172,4.24,0s1.172-3.07,0-4.242L50.088,57.672z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_drizzle climacon_component-stroke_drizzle-right",
                        d: "M43.033,57.672l-2.121,2.121c-1.172,1.172-1.172,3.07,0,4.242s3.07,1.172,4.244,0c1.172-1.172,1.172-3.07,0-4.242L43.033,57.672z"
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M43.945,65.639c-8.835,0-15.998-7.162-15.998-15.998c0-8.836,7.163-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,6.625-5.371,11.998-11.998,11.998C57.168,65.639,47.143,65.639,43.945,65.639z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_cloud",
                        fill: "#FFFFFF",
                        d: "M59.943,61.639c4.418,0,8-3.582,8-7.998c0-4.417-3.582-8-8-8c-1.601,0-3.082,0.481-4.334,1.291c-1.23-5.316-5.973-9.29-11.665-9.29c-6.626,0-11.998,5.372-11.998,11.999c0,6.626,5.372,11.998,11.998,11.998C47.562,61.639,56.924,61.639,59.943,61.639z"
                      })
                    ])
                  ])
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_22, [
                (_openBlock(), _createElementBlock("svg", _hoisted_23, [
                  _createVNode(_component_clippath, { id: "cloudFillClipfill22" }, {
                    default: _withCtx(() => _cache[24] || (_cache[24] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M59.943,61.639c-3.02,0-12.381,0-15.999,0c-6.626,0-11.998-5.371-11.998-11.998c0-6.627,5.372-11.999,11.998-11.999c5.691,0,10.434,3.974,11.665,9.29c1.252-0.81,2.733-1.291,4.334-1.291c4.418,0,8,3.582,8,8C67.943,58.057,64.361,61.639,59.943,61.639z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_clippath, { id: "moonCloudFillClipfill2" }, {
                    default: _withCtx(() => _cache[25] || (_cache[25] = [
                      _createElementVNode("path", { d: "M0,0v100h100V0H0z M60.943,46.641c-4.418,0-7.999-3.582-7.999-7.999c0-3.803,2.655-6.979,6.211-7.792c0.903,4.854,4.726,8.676,9.579,9.58C67.922,43.986,64.745,46.641,60.943,46.641z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _cache[26] || (_cache[26] = _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudDrizzleMoonAlt" }, [
                    _createElementVNode("g", { "clip-path": "url(#cloudFillClip)" }, [
                      _createElementVNode("g", {
                        class: "climacon_wrapperComponent climacon_wrapperComponent-moon climacon_componentWrap-moon_cloud",
                        "clip-path": "url(#moonCloudFillClip)"
                      }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                          d: "M61.023,50.641c-6.627,0-11.999-5.372-11.999-11.998c0-6.627,5.372-11.999,11.999-11.999c0.755,0,1.491,0.078,2.207,0.212c-0.132,0.576-0.208,1.173-0.208,1.788c0,4.418,3.582,7.999,8,7.999c0.614,0,1.212-0.076,1.788-0.208c0.133,0.717,0.211,1.452,0.211,2.208C73.021,45.269,67.649,50.641,61.023,50.641z"
                        })
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-drizzle" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_drizzle climacon_component-stroke_drizzle-left",
                        id: "Drizzle-Left_1_4",
                        d: "M56.969,57.672l-2.121,2.121c-1.172,1.172-1.172,3.072,0,4.242c1.17,1.172,3.07,1.172,4.24,0c1.172-1.17,1.172-3.07,0-4.242L56.969,57.672z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_drizzle climacon_component-stroke_drizzle-middle",
                        d: "M50.088,57.672l-2.119,2.121c-1.174,1.172-1.174,3.07,0,4.242c1.17,1.172,3.068,1.172,4.24,0s1.172-3.07,0-4.242L50.088,57.672z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_drizzle climacon_component-stroke_drizzle-right",
                        d: "M43.033,57.672l-2.121,2.121c-1.172,1.172-1.172,3.07,0,4.242s3.07,1.172,4.244,0c1.172-1.172,1.172-3.07,0-4.242L43.033,57.672z"
                      })
                    ]),
                    _createElementVNode("g", {
                      class: "climacon_wrapperComponent climacon_wrapperComponent-cloud",
                      "clip-path": "url(#cloudFillClip)"
                    }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M59.943,41.642c-0.696,0-1.369,0.092-2.033,0.205c-2.736-4.892-7.961-8.203-13.965-8.203c-8.835,0-15.998,7.162-15.998,15.997c0,5.992,3.3,11.207,8.177,13.947c0.276-1.262,0.892-2.465,1.873-3.445l0.057-0.057c-3.644-2.061-6.106-5.963-6.106-10.445c0-6.626,5.372-11.998,11.998-11.998c5.691,0,10.433,3.974,11.666,9.29c1.25-0.81,2.732-1.291,4.332-1.291c4.418,0,8,3.581,8,7.999c0,3.443-2.182,6.371-5.235,7.498c0.788,1.146,1.194,2.471,1.222,3.807c4.666-1.645,8.014-6.077,8.014-11.305C71.941,47.014,66.57,41.642,59.943,41.642z"
                      })
                    ])
                  ], -1))
                ]))
              ]),
              _cache[124] || (_cache[124] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_cloudDrizzleMoonFillAlt",
                  id: "cloudDrizzleMoonFillAlt",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudDrizzleMoonFillAlt" }, [
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-moon climacon_componentWrap-moon_cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                        d: "M61.023,50.641c-6.627,0-11.999-5.372-11.999-11.998c0-6.627,5.372-11.999,11.999-11.999c0.755,0,1.491,0.078,2.207,0.212c-0.132,0.576-0.208,1.173-0.208,1.788c0,4.418,3.582,7.999,8,7.999c0.614,0,1.212-0.076,1.788-0.208c0.133,0.717,0.211,1.452,0.211,2.208C73.021,45.269,67.649,50.641,61.023,50.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_moon",
                        fill: "#FFFFFF",
                        d: "M59.235,30.851c-3.556,0.813-6.211,3.989-6.211,7.792c0,4.417,3.581,7.999,7.999,7.999c3.802,0,6.979-2.655,7.791-6.211C63.961,39.527,60.139,35.705,59.235,30.851z"
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-drizzle" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_drizzle climacon_component-stroke_drizzle-left",
                        id: "Drizzle-Left_1_6",
                        d: "M56.969,57.672l-2.121,2.121c-1.172,1.172-1.172,3.072,0,4.242c1.17,1.172,3.07,1.172,4.24,0c1.172-1.17,1.172-3.07,0-4.242L56.969,57.672z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_drizzle climacon_component-stroke_drizzle-middle",
                        d: "M50.088,57.672l-2.119,2.121c-1.174,1.172-1.174,3.07,0,4.242c1.17,1.172,3.068,1.172,4.24,0s1.172-3.07,0-4.242L50.088,57.672z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_drizzle climacon_component-stroke_drizzle-right",
                        d: "M43.033,57.672l-2.121,2.121c-1.172,1.172-1.172,3.07,0,4.242s3.07,1.172,4.244,0c1.172-1.172,1.172-3.07,0-4.242L43.033,57.672z"
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M43.945,65.639c-8.835,0-15.998-7.162-15.998-15.998c0-8.836,7.163-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,6.625-5.371,11.998-11.998,11.998C57.168,65.639,47.143,65.639,43.945,65.639z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_cloud",
                        fill: "#FFFFFF",
                        d: "M59.943,61.639c4.418,0,8-3.582,8-7.998c0-4.417-3.582-8-8-8c-1.601,0-3.082,0.481-4.334,1.291c-1.23-5.316-5.973-9.29-11.665-9.29c-6.626,0-11.998,5.372-11.998,11.999c0,6.626,5.372,11.998,11.998,11.998C47.562,61.639,56.924,61.639,59.943,61.639z"
                      })
                    ])
                  ])
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_24, [
                (_openBlock(), _createElementBlock("svg", _hoisted_25, [
                  _createVNode(_component_clippath, { id: "cloudFillClipfill3" }, {
                    default: _withCtx(() => _cache[27] || (_cache[27] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M59.943,61.639c-3.02,0-12.381,0-15.999,0c-6.626,0-11.998-5.371-11.998-11.998c0-6.627,5.372-11.999,11.998-11.999c5.691,0,10.434,3.974,11.665,9.29c1.252-0.81,2.733-1.291,4.334-1.291c4.418,0,8,3.582,8,8C67.943,58.057,64.361,61.639,59.943,61.639z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _cache[28] || (_cache[28] = _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudRain" }, [
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-rain" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- left",
                        d: "M41.946,53.641c1.104,0,1.999,0.896,1.999,2v15.998c0,1.105-0.895,2-1.999,2s-2-0.895-2-2V55.641C39.946,54.537,40.842,53.641,41.946,53.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- middle",
                        d: "M49.945,57.641c1.104,0,2,0.896,2,2v15.998c0,1.104-0.896,2-2,2s-2-0.896-2-2V59.641C47.945,58.535,48.841,57.641,49.945,57.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- right",
                        d: "M57.943,53.641c1.104,0,2,0.896,2,2v15.998c0,1.105-0.896,2-2,2c-1.104,0-2-0.895-2-2V55.641C55.943,54.537,56.84,53.641,57.943,53.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- left",
                        d: "M41.946,53.641c1.104,0,1.999,0.896,1.999,2v15.998c0,1.105-0.895,2-1.999,2s-2-0.895-2-2V55.641C39.946,54.537,40.842,53.641,41.946,53.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- middle",
                        d: "M49.945,57.641c1.104,0,2,0.896,2,2v15.998c0,1.104-0.896,2-2,2s-2-0.896-2-2V59.641C47.945,58.535,48.841,57.641,49.945,57.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- right",
                        d: "M57.943,53.641c1.104,0,2,0.896,2,2v15.998c0,1.105-0.896,2-2,2c-1.104,0-2-0.895-2-2V55.641C55.943,54.537,56.84,53.641,57.943,53.641z"
                      })
                    ]),
                    _createElementVNode("g", {
                      class: "climacon_wrapperComponent climacon_wrapperComponent_cloud",
                      "clip-path": "url(#cloudFillClip)"
                    }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M63.943,64.941v-4.381c2.389-1.384,4-3.961,4-6.92c0-4.417-3.582-8-8-8c-1.601,0-3.082,0.48-4.334,1.291c-1.23-5.317-5.973-9.29-11.665-9.29c-6.626,0-11.998,5.372-11.998,11.998c0,3.549,1.551,6.728,4,8.924v4.916c-4.777-2.768-8-7.922-8-13.84c0-8.835,7.163-15.997,15.998-15.997c6.004,0,11.229,3.311,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.372,11.998,12C71.941,58.863,68.602,63.293,63.943,64.941z"
                      })
                    ])
                  ], -1))
                ]))
              ]),
              _cache[125] || (_cache[125] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_cloudRainFill",
                  id: "cloudRainFill",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudRainFill" }, [
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-rain" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- left",
                        d: "M41.946,53.641c1.104,0,1.999,0.896,1.999,2v15.998c0,1.105-0.895,2-1.999,2s-2-0.895-2-2V55.641C39.946,54.537,40.842,53.641,41.946,53.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- middle",
                        d: "M49.945,57.641c1.104,0,2,0.896,2,2v15.998c0,1.104-0.896,2-2,2s-2-0.896-2-2V59.641C47.945,58.535,48.841,57.641,49.945,57.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- right",
                        d: "M57.943,53.641c1.104,0,2,0.896,2,2v15.998c0,1.105-0.896,2-2,2c-1.104,0-2-0.895-2-2V55.641C55.943,54.537,56.84,53.641,57.943,53.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- left",
                        d: "M41.946,53.641c1.104,0,1.999,0.896,1.999,2v15.998c0,1.105-0.895,2-1.999,2s-2-0.895-2-2V55.641C39.946,54.537,40.842,53.641,41.946,53.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- middle",
                        d: "M49.945,57.641c1.104,0,2,0.896,2,2v15.998c0,1.104-0.896,2-2,2s-2-0.896-2-2V59.641C47.945,58.535,48.841,57.641,49.945,57.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- right",
                        d: "M57.943,53.641c1.104,0,2,0.896,2,2v15.998c0,1.105-0.896,2-2,2c-1.104,0-2-0.895-2-2V55.641C55.943,54.537,56.84,53.641,57.943,53.641z"
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M43.945,65.639c-8.835,0-15.998-7.162-15.998-15.998c0-8.836,7.163-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,6.625-5.371,11.998-11.998,11.998C57.168,65.639,47.143,65.639,43.945,65.639z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_cloud",
                        fill: "#FFFFFF",
                        d: "M59.943,61.639c4.418,0,8-3.582,8-7.998c0-4.417-3.582-8-8-8c-1.601,0-3.082,0.481-4.334,1.291c-1.23-5.316-5.973-9.29-11.665-9.29c-6.626,0-11.998,5.372-11.998,11.999c0,6.626,5.372,11.998,11.998,11.998C47.562,61.639,56.924,61.639,59.943,61.639z"
                      })
                    ])
                  ])
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_26, [
                (_openBlock(), _createElementBlock("svg", _hoisted_27, [
                  _createVNode(_component_clippath, { id: "cloudFillClipfill2" }, {
                    default: _withCtx(() => _cache[29] || (_cache[29] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M59.943,61.639c-3.02,0-12.381,0-15.999,0c-6.626,0-11.998-5.371-11.998-11.998c0-6.627,5.372-11.999,11.998-11.999c5.691,0,10.434,3.974,11.665,9.29c1.252-0.81,2.733-1.291,4.334-1.291c4.418,0,8,3.582,8,8C67.943,58.057,64.361,61.639,59.943,61.639z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_clippath, { id: "sunCloudFillClipfill6" }, {
                    default: _withCtx(() => _cache[30] || (_cache[30] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M57.945,49.641c-4.417,0-8-3.582-8-7.999c0-4.418,3.582-7.999,8-7.999s7.998,3.581,7.998,7.999C65.943,46.059,62.362,49.641,57.945,49.641z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_clippath, { id: "cloudSunFillClipfill2" }, {
                    default: _withCtx(() => _cache[31] || (_cache[31] = [
                      _createElementVNode("path", { d: "M15,15v70h20.947V63.481c-4.778-2.767-8-7.922-8-13.84c0-8.836,7.163-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,5.262-3.394,9.723-8.107,11.341V85H85V15H15z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _cache[32] || (_cache[32] = _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudRainSun" }, [
                    _createElementVNode("g", { "clip-path": "url(#cloudSunFillClip)" }, [
                      _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-sun climacon_componentWrap-sun_cloud" }, [
                        _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_sunSpoke" }, [
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M80.029,43.611h-3.998c-1.105,0-2-0.896-2-1.999s0.895-2,2-2h3.998c1.104,0,2,0.896,2,2S81.135,43.611,80.029,43.611z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M72.174,30.3c-0.781,0.781-2.049,0.781-2.828,0c-0.781-0.781-0.781-2.047,0-2.828l2.828-2.828c0.779-0.781,2.047-0.781,2.828,0c0.779,0.781,0.779,2.047,0,2.828L72.174,30.3z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M58.033,25.614c-1.105,0-2-0.896-2-2v-3.999c0-1.104,0.895-2,2-2c1.104,0,2,0.896,2,2v3.999C60.033,24.718,59.135,25.614,58.033,25.614z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M43.892,30.3l-2.827-2.828c-0.781-0.781-0.781-2.047,0-2.828c0.78-0.781,2.047-0.781,2.827,0l2.827,2.828c0.781,0.781,0.781,2.047,0,2.828C45.939,31.081,44.673,31.081,43.892,30.3z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M42.033,41.612c0,1.104-0.896,1.999-2,1.999h-4c-1.104,0-1.998-0.896-1.998-1.999s0.896-2,1.998-2h4C41.139,39.612,42.033,40.509,42.033,41.612z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M43.892,52.925c0.781-0.78,2.048-0.78,2.827,0c0.781,0.78,0.781,2.047,0,2.828l-2.827,2.827c-0.78,0.781-2.047,0.781-2.827,0c-0.781-0.78-0.781-2.047,0-2.827L43.892,52.925z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M58.033,57.61c1.104,0,2,0.895,2,1.999v4c0,1.104-0.896,2-2,2c-1.105,0-2-0.896-2-2v-4C56.033,58.505,56.928,57.61,58.033,57.61z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M72.174,52.925l2.828,2.828c0.779,0.78,0.779,2.047,0,2.827c-0.781,0.781-2.049,0.781-2.828,0l-2.828-2.827c-0.781-0.781-0.781-2.048,0-2.828C70.125,52.144,71.391,52.144,72.174,52.925z"
                          })
                        ]),
                        _createElementVNode("g", {
                          class: "climacon_wrapperComponent climacon_wrapperComponent-sunBody",
                          "clip-path": "url(#sunCloudFillClip)"
                        }, [
                          _createElementVNode("circle", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                            cx: "58.033",
                            cy: "41.612",
                            r: "11.999"
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-rain" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- left",
                        d: "M41.946,53.641c1.104,0,1.999,0.896,1.999,2v15.998c0,1.105-0.895,2-1.999,2s-2-0.895-2-2V55.641C39.946,54.537,40.842,53.641,41.946,53.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- middle",
                        d: "M49.945,57.641c1.104,0,2,0.896,2,2v15.998c0,1.104-0.896,2-2,2s-2-0.896-2-2V59.641C47.945,58.535,48.841,57.641,49.945,57.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- right",
                        d: "M57.943,53.641c1.104,0,2,0.896,2,2v15.998c0,1.105-0.896,2-2,2c-1.104,0-2-0.895-2-2V55.641C55.943,54.537,56.84,53.641,57.943,53.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- left",
                        d: "M41.946,53.641c1.104,0,1.999,0.896,1.999,2v15.998c0,1.105-0.895,2-1.999,2s-2-0.895-2-2V55.641C39.946,54.537,40.842,53.641,41.946,53.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- middle",
                        d: "M49.945,57.641c1.104,0,2,0.896,2,2v15.998c0,1.104-0.896,2-2,2s-2-0.896-2-2V59.641C47.945,58.535,48.841,57.641,49.945,57.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- right",
                        d: "M57.943,53.641c1.104,0,2,0.896,2,2v15.998c0,1.105-0.896,2-2,2c-1.104,0-2-0.895-2-2V55.641C55.943,54.537,56.84,53.641,57.943,53.641z"
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M63.943,64.941v-4.381c2.389-1.384,4-3.961,4-6.92c0-4.417-3.582-8-8-8c-1.601,0-3.082,0.48-4.334,1.291c-1.23-5.317-5.973-9.29-11.665-9.29c-6.626,0-11.998,5.372-11.998,11.998c0,3.549,1.551,6.728,4,8.924v4.916c-4.777-2.768-8-7.922-8-13.84c0-8.835,7.163-15.997,15.998-15.997c6.004,0,11.229,3.311,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.372,11.998,12C71.941,58.863,68.602,63.293,63.943,64.941z"
                      })
                    ])
                  ], -1))
                ]))
              ]),
              _cache[126] || (_cache[126] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_cloudRainSunFill",
                  id: "cloudRainSunFill",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudRainSunFill" }, [
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-sun climacon_componentWrap-sun_cloud" }, [
                      _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_sunSpoke" }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M80.029,43.611h-3.998c-1.105,0-2-0.896-2-1.999s0.895-2,2-2h3.998c1.104,0,2,0.896,2,2S81.135,43.611,80.029,43.611z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M72.174,30.3c-0.781,0.781-2.049,0.781-2.828,0c-0.781-0.781-0.781-2.047,0-2.828l2.828-2.828c0.779-0.781,2.047-0.781,2.828,0c0.779,0.781,0.779,2.047,0,2.828L72.174,30.3z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M58.033,25.614c-1.105,0-2-0.896-2-2v-3.999c0-1.104,0.895-2,2-2c1.104,0,2,0.896,2,2v3.999C60.033,24.718,59.135,25.614,58.033,25.614z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M43.892,30.3l-2.827-2.828c-0.781-0.781-0.781-2.047,0-2.828c0.78-0.781,2.047-0.781,2.827,0l2.827,2.828c0.781,0.781,0.781,2.047,0,2.828C45.939,31.081,44.673,31.081,43.892,30.3z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M42.033,41.612c0,1.104-0.896,1.999-2,1.999h-4c-1.104,0-1.998-0.896-1.998-1.999s0.896-2,1.998-2h4C41.139,39.612,42.033,40.509,42.033,41.612z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M43.892,52.925c0.781-0.78,2.048-0.78,2.827,0c0.781,0.78,0.781,2.047,0,2.828l-2.827,2.827c-0.78,0.781-2.047,0.781-2.827,0c-0.781-0.78-0.781-2.047,0-2.827L43.892,52.925z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M58.033,57.61c1.104,0,2,0.895,2,1.999v4c0,1.104-0.896,2-2,2c-1.105,0-2-0.896-2-2v-4C56.033,58.505,56.928,57.61,58.033,57.61z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M72.174,52.925l2.828,2.828c0.779,0.78,0.779,2.047,0,2.827c-0.781,0.781-2.049,0.781-2.828,0l-2.828-2.827c-0.781-0.781-0.781-2.048,0-2.828C70.125,52.144,71.391,52.144,72.174,52.925z"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-sunBody" }, [
                        _createElementVNode("circle", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                          cx: "58.033",
                          cy: "41.612",
                          r: "11.999"
                        }),
                        _createElementVNode("circle", {
                          class: "climacon_component climacon_component-fill climacon_component-fill_sunBody",
                          fill: "#FFFFFF",
                          cx: "58.033",
                          cy: "41.612",
                          r: "7.999"
                        })
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-rain" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- left",
                        d: "M41.946,53.641c1.104,0,1.999,0.896,1.999,2v15.998c0,1.105-0.895,2-1.999,2s-2-0.895-2-2V55.641C39.946,54.537,40.842,53.641,41.946,53.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- middle",
                        d: "M49.945,57.641c1.104,0,2,0.896,2,2v15.998c0,1.104-0.896,2-2,2s-2-0.896-2-2V59.641C47.945,58.535,48.841,57.641,49.945,57.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- right",
                        d: "M57.943,53.641c1.104,0,2,0.896,2,2v15.998c0,1.105-0.896,2-2,2c-1.104,0-2-0.895-2-2V55.641C55.943,54.537,56.84,53.641,57.943,53.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- left",
                        d: "M41.946,53.641c1.104,0,1.999,0.896,1.999,2v15.998c0,1.105-0.895,2-1.999,2s-2-0.895-2-2V55.641C39.946,54.537,40.842,53.641,41.946,53.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- middle",
                        d: "M49.945,57.641c1.104,0,2,0.896,2,2v15.998c0,1.104-0.896,2-2,2s-2-0.896-2-2V59.641C47.945,58.535,48.841,57.641,49.945,57.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- right",
                        d: "M57.943,53.641c1.104,0,2,0.896,2,2v15.998c0,1.105-0.896,2-2,2c-1.104,0-2-0.895-2-2V55.641C55.943,54.537,56.84,53.641,57.943,53.641z"
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M43.945,65.639c-8.835,0-15.998-7.162-15.998-15.998c0-8.836,7.163-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,6.625-5.371,11.998-11.998,11.998C57.168,65.639,47.143,65.639,43.945,65.639z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_cloud",
                        fill: "#FFFFFF",
                        d: "M59.943,61.639c4.418,0,8-3.582,8-7.998c0-4.417-3.582-8-8-8c-1.601,0-3.082,0.481-4.334,1.291c-1.23-5.316-5.973-9.29-11.665-9.29c-6.626,0-11.998,5.372-11.998,11.999c0,6.626,5.372,11.998,11.998,11.998C47.562,61.639,56.924,61.639,59.943,61.639z"
                      })
                    ])
                  ])
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_28, [
                (_openBlock(), _createElementBlock("svg", _hoisted_29, [
                  _createVNode(_component_clippath, { id: "cloudFillClipfill4" }, {
                    default: _withCtx(() => _cache[33] || (_cache[33] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M59.943,61.639c-3.02,0-12.381,0-15.999,0c-6.626,0-11.998-5.371-11.998-11.998c0-6.627,5.372-11.999,11.998-11.999c5.691,0,10.434,3.974,11.665,9.29c1.252-0.81,2.733-1.291,4.334-1.291c4.418,0,8,3.582,8,8C67.943,58.057,64.361,61.639,59.943,61.639z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_clippath, { id: "moonCloudFillClipfill3" }, {
                    default: _withCtx(() => _cache[34] || (_cache[34] = [
                      _createElementVNode("path", { d: "M0,0v100h100V0H0z M60.943,46.641c-4.418,0-7.999-3.582-7.999-7.999c0-3.803,2.655-6.979,6.211-7.792c0.903,4.854,4.726,8.676,9.579,9.58C67.922,43.986,64.745,46.641,60.943,46.641z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _cache[35] || (_cache[35] = _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudRainMoon" }, [
                    _createElementVNode("g", { "clip-path": "url(#cloudFillClip)" }, [
                      _createElementVNode("g", {
                        class: "climacon_wrapperComponent climacon_wrapperComponent-moon climacon_componentWrap-moon_cloud",
                        "clip-path": "url(#moonCloudFillClip)"
                      }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                          d: "M61.023,50.641c-6.627,0-11.999-5.372-11.999-11.998c0-6.627,5.372-11.999,11.999-11.999c0.755,0,1.491,0.078,2.207,0.212c-0.132,0.576-0.208,1.173-0.208,1.788c0,4.418,3.582,7.999,8,7.999c0.614,0,1.212-0.076,1.788-0.208c0.133,0.717,0.211,1.452,0.211,2.208C73.021,45.269,67.649,50.641,61.023,50.641z"
                        })
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-rain" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- left",
                        d: "M41.946,53.641c1.104,0,1.999,0.896,1.999,2v15.998c0,1.105-0.895,2-1.999,2s-2-0.895-2-2V55.641C39.946,54.537,40.842,53.641,41.946,53.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- middle",
                        d: "M49.945,57.641c1.104,0,2,0.896,2,2v15.998c0,1.104-0.896,2-2,2s-2-0.896-2-2V59.641C47.945,58.535,48.841,57.641,49.945,57.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- right",
                        d: "M57.943,53.641c1.104,0,2,0.896,2,2v15.998c0,1.105-0.896,2-2,2c-1.104,0-2-0.895-2-2V55.641C55.943,54.537,56.84,53.641,57.943,53.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- left",
                        d: "M41.946,53.641c1.104,0,1.999,0.896,1.999,2v15.998c0,1.105-0.895,2-1.999,2s-2-0.895-2-2V55.641C39.946,54.537,40.842,53.641,41.946,53.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- middle",
                        d: "M49.945,57.641c1.104,0,2,0.896,2,2v15.998c0,1.104-0.896,2-2,2s-2-0.896-2-2V59.641C47.945,58.535,48.841,57.641,49.945,57.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- right",
                        d: "M57.943,53.641c1.104,0,2,0.896,2,2v15.998c0,1.105-0.896,2-2,2c-1.104,0-2-0.895-2-2V55.641C55.943,54.537,56.84,53.641,57.943,53.641z"
                      })
                    ]),
                    _createElementVNode("g", {
                      class: "climacon_wrapperComponent climacon_wrapperComponent-cloud",
                      "clip-path": "url(#cloudFillClip)"
                    }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M59.943,41.642c-0.696,0-1.369,0.092-2.033,0.205c-2.736-4.892-7.961-8.203-13.965-8.203c-8.835,0-15.998,7.162-15.998,15.997c0,5.992,3.3,11.207,8.177,13.947c0.276-1.262,0.892-2.465,1.873-3.445l0.057-0.057c-3.644-2.061-6.106-5.963-6.106-10.445c0-6.626,5.372-11.998,11.998-11.998c5.691,0,10.433,3.974,11.666,9.29c1.25-0.81,2.732-1.291,4.332-1.291c4.418,0,8,3.581,8,7.999c0,3.443-2.182,6.371-5.235,7.498c0.788,1.146,1.194,2.471,1.222,3.807c4.666-1.645,8.014-6.077,8.014-11.305C71.941,47.014,66.57,41.642,59.943,41.642z"
                      })
                    ])
                  ], -1))
                ]))
              ]),
              _cache[127] || (_cache[127] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_cloudRainMoonFill",
                  id: "cloudRainMoonFill",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudRainMoonFill" }, [
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-moon climacon_componentWrap-moon_cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                        d: "M61.023,50.641c-6.627,0-11.999-5.372-11.999-11.998c0-6.627,5.372-11.999,11.999-11.999c0.755,0,1.491,0.078,2.207,0.212c-0.132,0.576-0.208,1.173-0.208,1.788c0,4.418,3.582,7.999,8,7.999c0.614,0,1.212-0.076,1.788-0.208c0.133,0.717,0.211,1.452,0.211,2.208C73.021,45.269,67.649,50.641,61.023,50.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_moon",
                        fill: "#FFFFFF",
                        d: "M59.235,30.851c-3.556,0.813-6.211,3.989-6.211,7.792c0,4.417,3.581,7.999,7.999,7.999c3.802,0,6.979-2.655,7.791-6.211C63.961,39.527,60.139,35.705,59.235,30.851z"
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-rain" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- left",
                        d: "M41.946,53.641c1.104,0,1.999,0.896,1.999,2v15.998c0,1.105-0.895,2-1.999,2s-2-0.895-2-2V55.641C39.946,54.537,40.842,53.641,41.946,53.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- middle",
                        d: "M49.945,57.641c1.104,0,2,0.896,2,2v15.998c0,1.104-0.896,2-2,2s-2-0.896-2-2V59.641C47.945,58.535,48.841,57.641,49.945,57.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- right",
                        d: "M57.943,53.641c1.104,0,2,0.896,2,2v15.998c0,1.105-0.896,2-2,2c-1.104,0-2-0.895-2-2V55.641C55.943,54.537,56.84,53.641,57.943,53.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- left",
                        d: "M41.946,53.641c1.104,0,1.999,0.896,1.999,2v15.998c0,1.105-0.895,2-1.999,2s-2-0.895-2-2V55.641C39.946,54.537,40.842,53.641,41.946,53.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- middle",
                        d: "M49.945,57.641c1.104,0,2,0.896,2,2v15.998c0,1.104-0.896,2-2,2s-2-0.896-2-2V59.641C47.945,58.535,48.841,57.641,49.945,57.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- right",
                        d: "M57.943,53.641c1.104,0,2,0.896,2,2v15.998c0,1.105-0.896,2-2,2c-1.104,0-2-0.895-2-2V55.641C55.943,54.537,56.84,53.641,57.943,53.641z"
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M43.945,65.639c-8.835,0-15.998-7.162-15.998-15.998c0-8.836,7.163-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,6.625-5.371,11.998-11.998,11.998C57.168,65.639,47.143,65.639,43.945,65.639z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_cloud",
                        fill: "#FFFFFF",
                        d: "M59.943,61.639c4.418,0,8-3.582,8-7.998c0-4.417-3.582-8-8-8c-1.601,0-3.082,0.481-4.334,1.291c-1.23-5.316-5.973-9.29-11.665-9.29c-6.626,0-11.998,5.372-11.998,11.999c0,6.626,5.372,11.998,11.998,11.998C47.562,61.639,56.924,61.639,59.943,61.639z"
                      })
                    ])
                  ])
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_30, [
                (_openBlock(), _createElementBlock("svg", _hoisted_31, [
                  _createVNode(_component_clippath, { id: "cloudFillClipfill5" }, {
                    default: _withCtx(() => _cache[36] || (_cache[36] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M59.943,61.639c-3.02,0-12.381,0-15.999,0c-6.626,0-11.998-5.371-11.998-11.998c0-6.627,5.372-11.999,11.998-11.999c5.691,0,10.434,3.974,11.665,9.29c1.252-0.81,2.733-1.291,4.334-1.291c4.418,0,8,3.582,8,8C67.943,58.057,64.361,61.639,59.943,61.639z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _cache[37] || (_cache[37] = _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudRainAlt" }, [
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-rain climacon_wrapperComponent-rain_alt" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- alt",
                        d: "M50.001,58.568l3.535,3.535c1.95,1.953,1.95,5.119,0,7.07c-1.953,1.953-5.119,1.953-7.07,0c-1.953-1.951-1.953-5.117,0-7.07L50.001,58.568z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- alt",
                        d: "M50.001,58.568l3.535,3.535c1.95,1.953,1.95,5.119,0,7.07c-1.953,1.953-5.119,1.953-7.07,0c-1.953-1.951-1.953-5.117,0-7.07L50.001,58.568z"
                      })
                    ]),
                    _createElementVNode("g", {
                      class: "climacon_wrapperComponent climacon_wrapperComponent_cloud",
                      "clip-path": "url(#cloudFillClip)"
                    }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M59.999,65.641c-0.267,0-0.614,0-1,0c0-1.373-0.319-2.742-0.942-4c0.776,0,1.45,0,1.942,0c4.418,0,7.999-3.58,7.999-7.998c0-4.418-3.581-8-7.999-8c-1.601,0-3.083,0.481-4.334,1.29c-1.231-5.316-5.973-9.289-11.664-9.289c-6.627,0-11.998,5.372-11.998,11.998c0,5.953,4.339,10.879,10.023,11.822c-0.637,1.218-0.969,2.55-1.012,3.888c-7.406-1.399-13.012-7.896-13.012-15.709c0-8.835,7.162-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.204c0.664-0.114,1.337-0.205,2.033-0.205c6.627,0,11.998,5.372,11.998,12C71.996,60.27,66.626,65.641,59.999,65.641z"
                      })
                    ])
                  ], -1))
                ]))
              ]),
              _cache[128] || (_cache[128] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_cloudRainAltFill",
                  id: "cloudRainAltFill",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudRainAltFill" }, [
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-rain climacon_wrapperComponent-rain_alt" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- alt",
                        d: "M50.001,58.568l3.535,3.535c1.95,1.953,1.95,5.119,0,7.07c-1.953,1.953-5.119,1.953-7.07,0c-1.953-1.951-1.953-5.117,0-7.07L50.001,58.568z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- alt",
                        d: "M50.001,58.568l3.535,3.535c1.95,1.953,1.95,5.119,0,7.07c-1.953,1.953-5.119,1.953-7.07,0c-1.953-1.951-1.953-5.117,0-7.07L50.001,58.568z"
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M43.945,65.639c-8.835,0-15.998-7.162-15.998-15.998c0-8.836,7.163-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,6.625-5.371,11.998-11.998,11.998C57.168,65.639,47.143,65.639,43.945,65.639z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_cloud",
                        fill: "#FFFFFF",
                        d: "M59.943,61.639c4.418,0,8-3.582,8-7.998c0-4.417-3.582-8-8-8c-1.601,0-3.082,0.481-4.334,1.291c-1.23-5.316-5.973-9.29-11.665-9.29c-6.626,0-11.998,5.372-11.998,11.999c0,6.626,5.372,11.998,11.998,11.998C47.562,61.639,56.924,61.639,59.943,61.639z"
                      })
                    ])
                  ])
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_32, [
                (_openBlock(), _createElementBlock("svg", _hoisted_33, [
                  _createVNode(_component_clippath, { id: "cloudFillClipfill6" }, {
                    default: _withCtx(() => _cache[38] || (_cache[38] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M59.943,61.639c-3.02,0-12.381,0-15.999,0c-6.626,0-11.998-5.371-11.998-11.998c0-6.627,5.372-11.999,11.998-11.999c5.691,0,10.434,3.974,11.665,9.29c1.252-0.81,2.733-1.291,4.334-1.291c4.418,0,8,3.582,8,8C67.943,58.057,64.361,61.639,59.943,61.639z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_clippath, { id: "sunCloudFillClipfill5" }, {
                    default: _withCtx(() => _cache[39] || (_cache[39] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M57.945,49.641c-4.417,0-8-3.582-8-7.999c0-4.418,3.582-7.999,8-7.999s7.998,3.581,7.998,7.999C65.943,46.059,62.362,49.641,57.945,49.641z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_clippath, { id: "cloudSunFillClipfill3" }, {
                    default: _withCtx(() => _cache[40] || (_cache[40] = [
                      _createElementVNode("path", { d: "M15,15v70h20.947V63.481c-4.778-2.767-8-7.922-8-13.84c0-8.836,7.163-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,5.262-3.394,9.723-8.107,11.341V85H85V15H15z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _cache[41] || (_cache[41] = _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudRainSunAlt" }, [
                    _createElementVNode("g", { "clip-path": "url(#cloudSunFillClip)" }, [
                      _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-sun climacon_componentWrap-sun_cloud" }, [
                        _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_sunSpoke" }, [
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M80.029,43.611h-3.998c-1.105,0-2-0.896-2-1.999s0.895-2,2-2h3.998c1.104,0,2,0.896,2,2S81.135,43.611,80.029,43.611z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M72.174,30.3c-0.781,0.781-2.049,0.781-2.828,0c-0.781-0.781-0.781-2.047,0-2.828l2.828-2.828c0.779-0.781,2.047-0.781,2.828,0c0.779,0.781,0.779,2.047,0,2.828L72.174,30.3z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M58.033,25.614c-1.105,0-2-0.896-2-2v-3.999c0-1.104,0.895-2,2-2c1.104,0,2,0.896,2,2v3.999C60.033,24.718,59.135,25.614,58.033,25.614z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M43.892,30.3l-2.827-2.828c-0.781-0.781-0.781-2.047,0-2.828c0.78-0.781,2.047-0.781,2.827,0l2.827,2.828c0.781,0.781,0.781,2.047,0,2.828C45.939,31.081,44.673,31.081,43.892,30.3z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M42.033,41.612c0,1.104-0.896,1.999-2,1.999h-4c-1.104,0-1.998-0.896-1.998-1.999s0.896-2,1.998-2h4C41.139,39.612,42.033,40.509,42.033,41.612z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M43.892,52.925c0.781-0.78,2.048-0.78,2.827,0c0.781,0.78,0.781,2.047,0,2.828l-2.827,2.827c-0.78,0.781-2.047,0.781-2.827,0c-0.781-0.78-0.781-2.047,0-2.827L43.892,52.925z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M58.033,57.61c1.104,0,2,0.895,2,1.999v4c0,1.104-0.896,2-2,2c-1.105,0-2-0.896-2-2v-4C56.033,58.505,56.928,57.61,58.033,57.61z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M72.174,52.925l2.828,2.828c0.779,0.78,0.779,2.047,0,2.827c-0.781,0.781-2.049,0.781-2.828,0l-2.828-2.827c-0.781-0.781-0.781-2.048,0-2.828C70.125,52.144,71.391,52.144,72.174,52.925z"
                          })
                        ]),
                        _createElementVNode("g", {
                          class: "climacon_wrapperComponent climacon_wrapperComponent-sunBody",
                          "clip-path": "url(#sunCloudFillClip)"
                        }, [
                          _createElementVNode("circle", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                            cx: "58.033",
                            cy: "41.612",
                            r: "11.999"
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-rain climacon_wrapperComponent-rain_alt" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- alt",
                        d: "M50.001,58.568l3.535,3.535c1.95,1.953,1.95,5.119,0,7.07c-1.953,1.953-5.119,1.953-7.07,0c-1.953-1.951-1.953-5.117,0-7.07L50.001,58.568z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- alt",
                        d: "M50.001,58.568l3.535,3.535c1.95,1.953,1.95,5.119,0,7.07c-1.953,1.953-5.119,1.953-7.07,0c-1.953-1.951-1.953-5.117,0-7.07L50.001,58.568z"
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M59.999,65.641c-0.267,0-0.614,0-1,0c0-1.373-0.319-2.742-0.942-4c0.776,0,1.45,0,1.942,0c4.418,0,7.999-3.58,7.999-7.998c0-4.418-3.581-8-7.999-8c-1.601,0-3.083,0.481-4.334,1.29c-1.231-5.316-5.973-9.289-11.664-9.289c-6.627,0-11.998,5.372-11.998,11.998c0,5.953,4.339,10.879,10.023,11.822c-0.637,1.218-0.969,2.55-1.012,3.888c-7.406-1.399-13.012-7.896-13.012-15.709c0-8.835,7.162-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.204c0.664-0.114,1.337-0.205,2.033-0.205c6.627,0,11.998,5.372,11.998,12C71.996,60.27,66.626,65.641,59.999,65.641z"
                      })
                    ])
                  ], -1))
                ]))
              ]),
              _cache[129] || (_cache[129] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_cloudSunRainAltFill",
                  id: "cloudRainSunAltFill",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudRainSunAltFill" }, [
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-sun climacon_componentWrap-sun_cloud" }, [
                      _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_sunSpoke" }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M80.029,43.611h-3.998c-1.105,0-2-0.896-2-1.999s0.895-2,2-2h3.998c1.104,0,2,0.896,2,2S81.135,43.611,80.029,43.611z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M72.174,30.3c-0.781,0.781-2.049,0.781-2.828,0c-0.781-0.781-0.781-2.047,0-2.828l2.828-2.828c0.779-0.781,2.047-0.781,2.828,0c0.779,0.781,0.779,2.047,0,2.828L72.174,30.3z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M58.033,25.614c-1.105,0-2-0.896-2-2v-3.999c0-1.104,0.895-2,2-2c1.104,0,2,0.896,2,2v3.999C60.033,24.718,59.135,25.614,58.033,25.614z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M43.892,30.3l-2.827-2.828c-0.781-0.781-0.781-2.047,0-2.828c0.78-0.781,2.047-0.781,2.827,0l2.827,2.828c0.781,0.781,0.781,2.047,0,2.828C45.939,31.081,44.673,31.081,43.892,30.3z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M42.033,41.612c0,1.104-0.896,1.999-2,1.999h-4c-1.104,0-1.998-0.896-1.998-1.999s0.896-2,1.998-2h4C41.139,39.612,42.033,40.509,42.033,41.612z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M43.892,52.925c0.781-0.78,2.048-0.78,2.827,0c0.781,0.78,0.781,2.047,0,2.828l-2.827,2.827c-0.78,0.781-2.047,0.781-2.827,0c-0.781-0.78-0.781-2.047,0-2.827L43.892,52.925z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M58.033,57.61c1.104,0,2,0.895,2,1.999v4c0,1.104-0.896,2-2,2c-1.105,0-2-0.896-2-2v-4C56.033,58.505,56.928,57.61,58.033,57.61z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M72.174,52.925l2.828,2.828c0.779,0.78,0.779,2.047,0,2.827c-0.781,0.781-2.049,0.781-2.828,0l-2.828-2.827c-0.781-0.781-0.781-2.048,0-2.828C70.125,52.144,71.391,52.144,72.174,52.925z"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-sunBody" }, [
                        _createElementVNode("circle", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                          cx: "58.033",
                          cy: "41.612",
                          r: "11.999"
                        }),
                        _createElementVNode("circle", {
                          class: "climacon_component climacon_component-fill climacon_component-fill_sunBody",
                          fill: "#FFFFFF",
                          cx: "58.033",
                          cy: "41.612",
                          r: "7.999"
                        })
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-rain climacon_wrapperComponent-rain_alt" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- alt",
                        d: "M50.001,58.568l3.535,3.535c1.95,1.953,1.95,5.119,0,7.07c-1.953,1.953-5.119,1.953-7.07,0c-1.953-1.951-1.953-5.117,0-7.07L50.001,58.568z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- alt",
                        d: "M50.001,58.568l3.535,3.535c1.95,1.953,1.95,5.119,0,7.07c-1.953,1.953-5.119,1.953-7.07,0c-1.953-1.951-1.953-5.117,0-7.07L50.001,58.568z"
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M43.945,65.639c-8.835,0-15.998-7.162-15.998-15.998c0-8.836,7.163-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,6.625-5.371,11.998-11.998,11.998C57.168,65.639,47.143,65.639,43.945,65.639z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_cloud",
                        fill: "#FFFFFF",
                        d: "M59.943,61.639c4.418,0,8-3.582,8-7.998c0-4.417-3.582-8-8-8c-1.601,0-3.082,0.481-4.334,1.291c-1.23-5.316-5.973-9.29-11.665-9.29c-6.626,0-11.998,5.372-11.998,11.999c0,6.626,5.372,11.998,11.998,11.998C47.562,61.639,56.924,61.639,59.943,61.639z"
                      })
                    ])
                  ])
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_34, [
                (_openBlock(), _createElementBlock("svg", _hoisted_35, [
                  _createVNode(_component_clippath, { id: "cloudFillClipfill7" }, {
                    default: _withCtx(() => _cache[42] || (_cache[42] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M59.943,61.639c-3.02,0-12.381,0-15.999,0c-6.626,0-11.998-5.371-11.998-11.998c0-6.627,5.372-11.999,11.998-11.999c5.691,0,10.434,3.974,11.665,9.29c1.252-0.81,2.733-1.291,4.334-1.291c4.418,0,8,3.582,8,8C67.943,58.057,64.361,61.639,59.943,61.639z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_clippath, { id: "moonCloudFillClipfill4" }, {
                    default: _withCtx(() => _cache[43] || (_cache[43] = [
                      _createElementVNode("path", { d: "M0,0v100h100V0H0z M60.943,46.641c-4.418,0-7.999-3.582-7.999-7.999c0-3.803,2.655-6.979,6.211-7.792c0.903,4.854,4.726,8.676,9.579,9.58C67.922,43.986,64.745,46.641,60.943,46.641z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _cache[44] || (_cache[44] = _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudRainMoonAlt" }, [
                    _createElementVNode("g", { "clip-path": "url(#cloudFillClip)" }, [
                      _createElementVNode("g", {
                        class: "climacon_wrapperComponent climacon_wrapperComponent-moon climacon_componentWrap-moon_cloud",
                        "clip-path": "url(#moonCloudFillClip)"
                      }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                          d: "M61.023,50.641c-6.627,0-11.999-5.372-11.999-11.998c0-6.627,5.372-11.999,11.999-11.999c0.755,0,1.491,0.078,2.207,0.212c-0.132,0.576-0.208,1.173-0.208,1.788c0,4.418,3.582,7.999,8,7.999c0.614,0,1.212-0.076,1.788-0.208c0.133,0.717,0.211,1.452,0.211,2.208C73.021,45.269,67.649,50.641,61.023,50.641z"
                        })
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-rain climacon_wrapperComponent-rain_alt" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- alt",
                        d: "M50.001,58.568l3.535,3.535c1.95,1.953,1.95,5.119,0,7.07c-1.953,1.953-5.119,1.953-7.07,0c-1.953-1.951-1.953-5.117,0-7.07L50.001,58.568z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- alt",
                        d: "M50.001,58.568l3.535,3.535c1.95,1.953,1.95,5.119,0,7.07c-1.953,1.953-5.119,1.953-7.07,0c-1.953-1.951-1.953-5.117,0-7.07L50.001,58.568z"
                      })
                    ]),
                    _createElementVNode("g", {
                      class: "climacon_wrapperComponent climacon_wrapperComponent_cloud",
                      "clip-path": "url(#cloudFillClip)"
                    }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M59.999,65.641c-0.267,0-0.614,0-1,0c0-1.373-0.319-2.742-0.942-4c0.776,0,1.45,0,1.942,0c4.418,0,7.999-3.58,7.999-7.998c0-4.418-3.581-8-7.999-8c-1.601,0-3.083,0.481-4.334,1.29c-1.231-5.316-5.973-9.289-11.664-9.289c-6.627,0-11.998,5.372-11.998,11.998c0,5.953,4.339,10.879,10.023,11.822c-0.637,1.218-0.969,2.55-1.012,3.888c-7.406-1.399-13.012-7.896-13.012-15.709c0-8.835,7.162-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.204c0.664-0.114,1.337-0.205,2.033-0.205c6.627,0,11.998,5.372,11.998,12C71.996,60.27,66.626,65.641,59.999,65.641z"
                      })
                    ])
                  ], -1))
                ]))
              ]),
              _cache[130] || (_cache[130] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_cloudMoonRainAltFill",
                  id: "cloudRainMoonAltFill",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudRainSunAlt" }, [
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-moon climacon_componentWrap-moon_cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                        d: "M61.023,50.641c-6.627,0-11.999-5.372-11.999-11.998c0-6.627,5.372-11.999,11.999-11.999c0.755,0,1.491,0.078,2.207,0.212c-0.132,0.576-0.208,1.173-0.208,1.788c0,4.418,3.582,7.999,8,7.999c0.614,0,1.212-0.076,1.788-0.208c0.133,0.717,0.211,1.452,0.211,2.208C73.021,45.269,67.649,50.641,61.023,50.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_moon",
                        fill: "#FFFFFF",
                        d: "M59.235,30.851c-3.556,0.813-6.211,3.989-6.211,7.792c0,4.417,3.581,7.999,7.999,7.999c3.802,0,6.979-2.655,7.791-6.211C63.961,39.527,60.139,35.705,59.235,30.851z"
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-rain climacon_wrapperComponent-rain_alt" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- alt",
                        d: "M50.001,58.568l3.535,3.535c1.95,1.953,1.95,5.119,0,7.07c-1.953,1.953-5.119,1.953-7.07,0c-1.953-1.951-1.953-5.117,0-7.07L50.001,58.568z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_rain climacon_component-stroke_rain- alt",
                        d: "M50.001,58.568l3.535,3.535c1.95,1.953,1.95,5.119,0,7.07c-1.953,1.953-5.119,1.953-7.07,0c-1.953-1.951-1.953-5.117,0-7.07L50.001,58.568z"
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M43.945,65.639c-8.835,0-15.998-7.162-15.998-15.998c0-8.836,7.163-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,6.625-5.371,11.998-11.998,11.998C57.168,65.639,47.143,65.639,43.945,65.639z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_cloud",
                        fill: "#FFFFFF",
                        d: "M59.943,61.639c4.418,0,8-3.582,8-7.998c0-4.417-3.582-8-8-8c-1.601,0-3.082,0.481-4.334,1.291c-1.23-5.316-5.973-9.29-11.665-9.29c-6.626,0-11.998,5.372-11.998,11.999c0,6.626,5.372,11.998,11.998,11.998C47.562,61.639,56.924,61.639,59.943,61.639z"
                      })
                    ])
                  ])
                ])
              ], -1)),
              _cache[131] || (_cache[131] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_cloudHailAlt",
                  id: "cloudHailAlt",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudHailAlt" }, [
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-hailAlt" }, [
                      _createElementVNode("g", { class: "climacon_component climacon_component-stroke climacon_component-stroke_hailAlt climacon_component-stroke_hailAlt-left" }, [
                        _createElementVNode("circle", {
                          cx: "42",
                          cy: "65.498",
                          r: "2"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_component climacon_component-stroke climacon_component-stroke_hailAlt climacon_component-stroke_hailAlt-middle" }, [
                        _createElementVNode("circle", {
                          cx: "49.999",
                          cy: "65.498",
                          r: "2"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_component climacon_component-stroke climacon_component-stroke_hailAlt climacon_component-stroke_hailAlt-right" }, [
                        _createElementVNode("circle", {
                          cx: "57.998",
                          cy: "65.498",
                          r: "2"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_component climacon_component-stroke climacon_component-stroke_hailAlt climacon_component-stroke_hailAlt-left" }, [
                        _createElementVNode("circle", {
                          cx: "42",
                          cy: "65.498",
                          r: "2"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_component climacon_component-stroke climacon_component-stroke_hailAlt climacon_component-stroke_hailAlt-middle" }, [
                        _createElementVNode("circle", {
                          cx: "49.999",
                          cy: "65.498",
                          r: "2"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_component climacon_component-stroke climacon_component-stroke_hailAlt climacon_component-stroke_hailAlt-right" }, [
                        _createElementVNode("circle", {
                          cx: "57.998",
                          cy: "65.498",
                          r: "2"
                        })
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M63.999,64.941v-4.381c2.39-1.384,3.999-3.961,3.999-6.92c0-4.417-3.581-8-7.998-8c-1.602,0-3.084,0.48-4.334,1.291c-1.23-5.317-5.974-9.29-11.665-9.29c-6.626,0-11.998,5.372-11.998,11.998c0,3.549,1.55,6.728,3.999,8.924v4.916c-4.776-2.768-7.998-7.922-7.998-13.84c0-8.835,7.162-15.997,15.997-15.997c6.004,0,11.229,3.311,13.966,8.203c0.663-0.113,1.336-0.205,2.033-0.205c6.626,0,11.998,5.372,11.998,12C71.998,58.863,68.656,63.293,63.999,64.941z"
                      })
                    ])
                  ])
                ])
              ], -1)),
              _cache[132] || (_cache[132] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_cloudHailAltFill",
                  id: "cloudHailAltFill",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudHailAltFill" }, [
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-hailAlt" }, [
                      _createElementVNode("g", { class: "climacon_component climacon_component-stroke climacon_component-stroke_hailAlt climacon_component-stroke_hailAlt-left" }, [
                        _createElementVNode("circle", {
                          cx: "42",
                          cy: "65.498",
                          r: "2"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_component climacon_component-stroke climacon_component-stroke_hailAlt climacon_component-stroke_hailAlt-middle" }, [
                        _createElementVNode("circle", {
                          cx: "49.999",
                          cy: "65.498",
                          r: "2"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_component climacon_component-stroke climacon_component-stroke_hailAlt climacon_component-stroke_hailAlt-right" }, [
                        _createElementVNode("circle", {
                          cx: "57.998",
                          cy: "65.498",
                          r: "2"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_component climacon_component-stroke climacon_component-stroke_hailAlt climacon_component-stroke_hailAlt-left" }, [
                        _createElementVNode("circle", {
                          cx: "42",
                          cy: "65.498",
                          r: "2"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_component climacon_component-stroke climacon_component-stroke_hailAlt climacon_component-stroke_hailAlt-middle" }, [
                        _createElementVNode("circle", {
                          cx: "49.999",
                          cy: "65.498",
                          r: "2"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_component climacon_component-stroke climacon_component-stroke_hailAlt climacon_component-stroke_hailAlt-right" }, [
                        _createElementVNode("circle", {
                          cx: "57.998",
                          cy: "65.498",
                          r: "2"
                        })
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M43.945,65.639c-8.835,0-15.998-7.162-15.998-15.998c0-8.836,7.163-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,6.625-5.371,11.998-11.998,11.998C57.168,65.639,47.143,65.639,43.945,65.639z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_cloud",
                        fill: "#FFFFFF",
                        d: "M59.943,61.639c4.418,0,8-3.582,8-7.998c0-4.417-3.582-8-8-8c-1.601,0-3.082,0.481-4.334,1.291c-1.23-5.316-5.973-9.29-11.665-9.29c-6.626,0-11.998,5.372-11.998,11.999c0,6.626,5.372,11.998,11.998,11.998C47.562,61.639,56.924,61.639,59.943,61.639z"
                      })
                    ])
                  ])
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_36, [
                (_openBlock(), _createElementBlock("svg", _hoisted_37, [
                  _createVNode(_component_clippath, { id: "cloudFillClipfill8" }, {
                    default: _withCtx(() => _cache[45] || (_cache[45] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M59.943,61.639c-3.02,0-12.381,0-15.999,0c-6.626,0-11.998-5.371-11.998-11.998c0-6.627,5.372-11.999,11.998-11.999c5.691,0,10.434,3.974,11.665,9.29c1.252-0.81,2.733-1.291,4.334-1.291c4.418,0,8,3.582,8,8C67.943,58.057,64.361,61.639,59.943,61.639z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_clippath, { id: "sunCloudFillClipfill1_1" }, {
                    default: _withCtx(() => _cache[46] || (_cache[46] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M57.945,49.641c-4.417,0-8-3.582-8-7.999c0-4.418,3.582-7.999,8-7.999s7.998,3.581,7.998,7.999C65.943,46.059,62.362,49.641,57.945,49.641z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_clippath, { id: "cloudSunFillClipfill4" }, {
                    default: _withCtx(() => _cache[47] || (_cache[47] = [
                      _createElementVNode("path", { d: "M15,15v70h20.947V63.481c-4.778-2.767-8-7.922-8-13.84c0-8.836,7.163-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,5.262-3.394,9.723-8.107,11.341V85H85V15H15z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _cache[48] || (_cache[48] = _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudHailAltSun" }, [
                    _createElementVNode("g", { "clip-path": "url(#cloudSunFillClip)" }, [
                      _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-sun climacon_componentWrap-sun_cloud" }, [
                        _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_sunSpoke" }, [
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M80.029,43.611h-3.998c-1.105,0-2-0.896-2-1.999s0.895-2,2-2h3.998c1.104,0,2,0.896,2,2S81.135,43.611,80.029,43.611z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M72.174,30.3c-0.781,0.781-2.049,0.781-2.828,0c-0.781-0.781-0.781-2.047,0-2.828l2.828-2.828c0.779-0.781,2.047-0.781,2.828,0c0.779,0.781,0.779,2.047,0,2.828L72.174,30.3z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M58.033,25.614c-1.105,0-2-0.896-2-2v-3.999c0-1.104,0.895-2,2-2c1.104,0,2,0.896,2,2v3.999C60.033,24.718,59.135,25.614,58.033,25.614z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M43.892,30.3l-2.827-2.828c-0.781-0.781-0.781-2.047,0-2.828c0.78-0.781,2.047-0.781,2.827,0l2.827,2.828c0.781,0.781,0.781,2.047,0,2.828C45.939,31.081,44.673,31.081,43.892,30.3z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M42.033,41.612c0,1.104-0.896,1.999-2,1.999h-4c-1.104,0-1.998-0.896-1.998-1.999s0.896-2,1.998-2h4C41.139,39.612,42.033,40.509,42.033,41.612z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M43.892,52.925c0.781-0.78,2.048-0.78,2.827,0c0.781,0.78,0.781,2.047,0,2.828l-2.827,2.827c-0.78,0.781-2.047,0.781-2.827,0c-0.781-0.78-0.781-2.047,0-2.827L43.892,52.925z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M58.033,57.61c1.104,0,2,0.895,2,1.999v4c0,1.104-0.896,2-2,2c-1.105,0-2-0.896-2-2v-4C56.033,58.505,56.928,57.61,58.033,57.61z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M72.174,52.925l2.828,2.828c0.779,0.78,0.779,2.047,0,2.827c-0.781,0.781-2.049,0.781-2.828,0l-2.828-2.827c-0.781-0.781-0.781-2.048,0-2.828C70.125,52.144,71.391,52.144,72.174,52.925z"
                          })
                        ]),
                        _createElementVNode("g", {
                          class: "climacon_wrapperComponent climacon_wrapperComponent-sunBody",
                          "clip-path": "url(#sunCloudFillClip)"
                        }, [
                          _createElementVNode("circle", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                            cx: "58.033",
                            cy: "41.612",
                            r: "11.999"
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-hailAlt" }, [
                      _createElementVNode("g", { class: "climacon_component climacon_component-stroke climacon_component-stroke_hailAlt climacon_component-stroke_hailAlt-left" }, [
                        _createElementVNode("circle", {
                          cx: "42",
                          cy: "65.498",
                          r: "2"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_component climacon_component-stroke climacon_component-stroke_hailAlt climacon_component-stroke_hailAlt-middle" }, [
                        _createElementVNode("circle", {
                          cx: "49.999",
                          cy: "65.498",
                          r: "2"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_component climacon_component-stroke climacon_component-stroke_hailAlt climacon_component-stroke_hailAlt-right" }, [
                        _createElementVNode("circle", {
                          cx: "57.998",
                          cy: "65.498",
                          r: "2"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_component climacon_component-stroke climacon_component-stroke_hailAlt climacon_component-stroke_hailAlt-left" }, [
                        _createElementVNode("circle", {
                          cx: "42",
                          cy: "65.498",
                          r: "2"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_component climacon_component-stroke climacon_component-stroke_hailAlt climacon_component-stroke_hailAlt-middle" }, [
                        _createElementVNode("circle", {
                          cx: "49.999",
                          cy: "65.498",
                          r: "2"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_component climacon_component-stroke climacon_component-stroke_hailAlt climacon_component-stroke_hailAlt-right" }, [
                        _createElementVNode("circle", {
                          cx: "57.998",
                          cy: "65.498",
                          r: "2"
                        })
                      ])
                    ]),
                    _createElementVNode("g", {
                      class: "climacon_wrapperComponent climacon_wrapperComponent-cloud",
                      "clip-path": "url(#cloudFillClip)"
                    }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M63.999,64.941v-4.381c2.39-1.384,3.999-3.961,3.999-6.92c0-4.417-3.581-8-7.998-8c-1.602,0-3.084,0.48-4.334,1.291c-1.23-5.317-5.974-9.29-11.665-9.29c-6.626,0-11.998,5.372-11.998,11.998c0,3.549,1.55,6.728,3.999,8.924v4.916c-4.776-2.768-7.998-7.922-7.998-13.84c0-8.835,7.162-15.997,15.997-15.997c6.004,0,11.229,3.311,13.966,8.203c0.663-0.113,1.336-0.205,2.033-0.205c6.626,0,11.998,5.372,11.998,12C71.998,58.863,68.656,63.293,63.999,64.941z"
                      })
                    ])
                  ], -1))
                ]))
              ]),
              _cache[133] || (_cache[133] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_cloudHailAltSun",
                  id: "cloudHailAltSunalt",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudHailAltSun" }, [
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-sun climacon_componentWrap-sun_cloud" }, [
                      _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_sunSpoke" }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M80.029,43.611h-3.998c-1.105,0-2-0.896-2-1.999s0.895-2,2-2h3.998c1.104,0,2,0.896,2,2S81.135,43.611,80.029,43.611z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M72.174,30.3c-0.781,0.781-2.049,0.781-2.828,0c-0.781-0.781-0.781-2.047,0-2.828l2.828-2.828c0.779-0.781,2.047-0.781,2.828,0c0.779,0.781,0.779,2.047,0,2.828L72.174,30.3z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M58.033,25.614c-1.105,0-2-0.896-2-2v-3.999c0-1.104,0.895-2,2-2c1.104,0,2,0.896,2,2v3.999C60.033,24.718,59.135,25.614,58.033,25.614z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M43.892,30.3l-2.827-2.828c-0.781-0.781-0.781-2.047,0-2.828c0.78-0.781,2.047-0.781,2.827,0l2.827,2.828c0.781,0.781,0.781,2.047,0,2.828C45.939,31.081,44.673,31.081,43.892,30.3z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M42.033,41.612c0,1.104-0.896,1.999-2,1.999h-4c-1.104,0-1.998-0.896-1.998-1.999s0.896-2,1.998-2h4C41.139,39.612,42.033,40.509,42.033,41.612z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M43.892,52.925c0.781-0.78,2.048-0.78,2.827,0c0.781,0.78,0.781,2.047,0,2.828l-2.827,2.827c-0.78,0.781-2.047,0.781-2.827,0c-0.781-0.78-0.781-2.047,0-2.827L43.892,52.925z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M58.033,57.61c1.104,0,2,0.895,2,1.999v4c0,1.104-0.896,2-2,2c-1.105,0-2-0.896-2-2v-4C56.033,58.505,56.928,57.61,58.033,57.61z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M72.174,52.925l2.828,2.828c0.779,0.78,0.779,2.047,0,2.827c-0.781,0.781-2.049,0.781-2.828,0l-2.828-2.827c-0.781-0.781-0.781-2.048,0-2.828C70.125,52.144,71.391,52.144,72.174,52.925z"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-sunBody" }, [
                        _createElementVNode("circle", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                          cx: "58.033",
                          cy: "41.612",
                          r: "11.999"
                        }),
                        _createElementVNode("circle", {
                          class: "climacon_component climacon_component-fill climacon_component-fill_sunBody",
                          fill: "#FFFFFF",
                          cx: "58.033",
                          cy: "41.612",
                          r: "7.999"
                        })
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-hailAlt" }, [
                      _createElementVNode("g", { class: "climacon_component climacon_component-stroke climacon_component-stroke_hailAlt climacon_component-stroke_hailAlt-left" }, [
                        _createElementVNode("circle", {
                          cx: "42",
                          cy: "65.498",
                          r: "2"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_component climacon_component-stroke climacon_component-stroke_hailAlt climacon_component-stroke_hailAlt-middle" }, [
                        _createElementVNode("circle", {
                          cx: "49.999",
                          cy: "65.498",
                          r: "2"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_component climacon_component-stroke climacon_component-stroke_hailAlt climacon_component-stroke_hailAlt-right" }, [
                        _createElementVNode("circle", {
                          cx: "57.998",
                          cy: "65.498",
                          r: "2"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_component climacon_component-stroke climacon_component-stroke_hailAlt climacon_component-stroke_hailAlt-left" }, [
                        _createElementVNode("circle", {
                          cx: "42",
                          cy: "65.498",
                          r: "2"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_component climacon_component-stroke climacon_component-stroke_hailAlt climacon_component-stroke_hailAlt-middle" }, [
                        _createElementVNode("circle", {
                          cx: "49.999",
                          cy: "65.498",
                          r: "2"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_component climacon_component-stroke climacon_component-stroke_hailAlt climacon_component-stroke_hailAlt-right" }, [
                        _createElementVNode("circle", {
                          cx: "57.998",
                          cy: "65.498",
                          r: "2"
                        })
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M43.945,65.639c-8.835,0-15.998-7.162-15.998-15.998c0-8.836,7.163-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,6.625-5.371,11.998-11.998,11.998C57.168,65.639,47.143,65.639,43.945,65.639z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_cloud",
                        fill: "#FFFFFF",
                        d: "M59.943,61.639c4.418,0,8-3.582,8-7.998c0-4.417-3.582-8-8-8c-1.601,0-3.082,0.481-4.334,1.291c-1.23-5.316-5.973-9.29-11.665-9.29c-6.626,0-11.998,5.372-11.998,11.999c0,6.626,5.372,11.998,11.998,11.998C47.562,61.639,56.924,61.639,59.943,61.639z"
                      })
                    ])
                  ])
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_38, [
                (_openBlock(), _createElementBlock("svg", _hoisted_39, [
                  _createVNode(_component_clippath, { id: "cloudFillClipfill9" }, {
                    default: _withCtx(() => _cache[49] || (_cache[49] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M59.943,61.639c-3.02,0-12.381,0-15.999,0c-6.626,0-11.998-5.371-11.998-11.998c0-6.627,5.372-11.999,11.998-11.999c5.691,0,10.434,3.974,11.665,9.29c1.252-0.81,2.733-1.291,4.334-1.291c4.418,0,8,3.582,8,8C67.943,58.057,64.361,61.639,59.943,61.639z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_clippath, { id: "moonCloudFillClipfill5" }, {
                    default: _withCtx(() => _cache[50] || (_cache[50] = [
                      _createElementVNode("path", { d: "M0,0v100h100V0H0z M60.943,46.641c-4.418,0-7.999-3.582-7.999-7.999c0-3.803,2.655-6.979,6.211-7.792c0.903,4.854,4.726,8.676,9.579,9.58C67.922,43.986,64.745,46.641,60.943,46.641z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _cache[51] || (_cache[51] = _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudHailAltMoon" }, [
                    _createElementVNode("g", { "clip-path": "url(#cloudFillClip)" }, [
                      _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-moon climacon_componentWrap-moon_cloud" }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                          d: "M61.023,50.641c-6.627,0-11.999-5.372-11.999-11.998c0-6.627,5.372-11.999,11.999-11.999c0.755,0,1.491,0.078,2.207,0.212c-0.132,0.576-0.208,1.173-0.208,1.788c0,4.418,3.582,7.999,8,7.999c0.614,0,1.212-0.076,1.788-0.208c0.133,0.717,0.211,1.452,0.211,2.208C73.021,45.269,67.649,50.641,61.023,50.641z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-fill climacon_component-fill_moon",
                          fill: "#FFFFFF",
                          d: "M59.235,30.851c-3.556,0.813-6.211,3.989-6.211,7.792c0,4.417,3.581,7.999,7.999,7.999c3.802,0,6.979-2.655,7.791-6.211C63.961,39.527,60.139,35.705,59.235,30.851z"
                        })
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-hailAlt" }, [
                      _createElementVNode("g", { class: "climacon_component climacon_component-stroke climacon_component-stroke_hailAlt climacon_component-stroke_hailAlt-left" }, [
                        _createElementVNode("circle", {
                          cx: "42",
                          cy: "65.498",
                          r: "2"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_component climacon_component-stroke climacon_component-stroke_hailAlt climacon_component-stroke_hailAlt-middle" }, [
                        _createElementVNode("circle", {
                          cx: "49.999",
                          cy: "65.498",
                          r: "2"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_component climacon_component-stroke climacon_component-stroke_hailAlt climacon_component-stroke_hailAlt-right" }, [
                        _createElementVNode("circle", {
                          cx: "57.998",
                          cy: "65.498",
                          r: "2"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_component climacon_component-stroke climacon_component-stroke_hailAlt climacon_component-stroke_hailAlt-left" }, [
                        _createElementVNode("circle", {
                          cx: "42",
                          cy: "65.498",
                          r: "2"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_component climacon_component-stroke climacon_component-stroke_hailAlt climacon_component-stroke_hailAlt-middle" }, [
                        _createElementVNode("circle", {
                          cx: "49.999",
                          cy: "65.498",
                          r: "2"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_component climacon_component-stroke climacon_component-stroke_hailAlt climacon_component-stroke_hailAlt-right" }, [
                        _createElementVNode("circle", {
                          cx: "57.998",
                          cy: "65.498",
                          r: "2"
                        })
                      ])
                    ]),
                    _createElementVNode("g", {
                      class: "climacon_wrapperComponent climacon_wrapperComponent-cloud",
                      "clip-path": "url(#cloudFillClip)"
                    }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M63.999,64.941v-4.381c2.39-1.384,3.999-3.961,3.999-6.92c0-4.417-3.581-8-7.998-8c-1.602,0-3.084,0.48-4.334,1.291c-1.23-5.317-5.974-9.29-11.665-9.29c-6.626,0-11.998,5.372-11.998,11.998c0,3.549,1.55,6.728,3.999,8.924v4.916c-4.776-2.768-7.998-7.922-7.998-13.84c0-8.835,7.162-15.997,15.997-15.997c6.004,0,11.229,3.311,13.966,8.203c0.663-0.113,1.336-0.205,2.033-0.205c6.626,0,11.998,5.372,11.998,12C71.998,58.863,68.656,63.293,63.999,64.941z"
                      })
                    ])
                  ], -1))
                ]))
              ]),
              _cache[134] || (_cache[134] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_cloudHailAltMoonFill",
                  id: "cloudHailAltMoonFill",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudHailAltMoon" }, [
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-moon climacon_componentWrap-moon_cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                        d: "M61.023,50.641c-6.627,0-11.999-5.372-11.999-11.998c0-6.627,5.372-11.999,11.999-11.999c0.755,0,1.491,0.078,2.207,0.212c-0.132,0.576-0.208,1.173-0.208,1.788c0,4.418,3.582,7.999,8,7.999c0.614,0,1.212-0.076,1.788-0.208c0.133,0.717,0.211,1.452,0.211,2.208C73.021,45.269,67.649,50.641,61.023,50.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_moon",
                        fill: "#FFFFFF",
                        d: "M59.235,30.851c-3.556,0.813-6.211,3.989-6.211,7.792c0,4.417,3.581,7.999,7.999,7.999c3.802,0,6.979-2.655,7.791-6.211C63.961,39.527,60.139,35.705,59.235,30.851z"
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-hailAlt" }, [
                      _createElementVNode("g", { class: "climacon_component climacon_component-stroke climacon_component-stroke_hailAlt climacon_component-stroke_hailAlt-left" }, [
                        _createElementVNode("circle", {
                          cx: "42",
                          cy: "65.498",
                          r: "2"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_component climacon_component-stroke climacon_component-stroke_hailAlt climacon_component-stroke_hailAlt-middle" }, [
                        _createElementVNode("circle", {
                          cx: "49.999",
                          cy: "65.498",
                          r: "2"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_component climacon_component-stroke climacon_component-stroke_hailAlt climacon_component-stroke_hailAlt-right" }, [
                        _createElementVNode("circle", {
                          cx: "57.998",
                          cy: "65.498",
                          r: "2"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_component climacon_component-stroke climacon_component-stroke_hailAlt climacon_component-stroke_hailAlt-left" }, [
                        _createElementVNode("circle", {
                          cx: "42",
                          cy: "65.498",
                          r: "2"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_component climacon_component-stroke climacon_component-stroke_hailAlt climacon_component-stroke_hailAlt-middle" }, [
                        _createElementVNode("circle", {
                          cx: "49.999",
                          cy: "65.498",
                          r: "2"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_component climacon_component-stroke climacon_component-stroke_hailAlt climacon_component-stroke_hailAlt-right" }, [
                        _createElementVNode("circle", {
                          cx: "57.998",
                          cy: "65.498",
                          r: "2"
                        })
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M43.945,65.639c-8.835,0-15.998-7.162-15.998-15.998c0-8.836,7.163-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,6.625-5.371,11.998-11.998,11.998C57.168,65.639,47.143,65.639,43.945,65.639z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_cloud",
                        fill: "#FFFFFF",
                        d: "M59.943,61.639c4.418,0,8-3.582,8-7.998c0-4.417-3.582-8-8-8c-1.601,0-3.082,0.481-4.334,1.291c-1.23-5.316-5.973-9.29-11.665-9.29c-6.626,0-11.998,5.372-11.998,11.999c0,6.626,5.372,11.998,11.998,11.998C47.562,61.639,56.924,61.639,59.943,61.639z"
                      })
                    ])
                  ])
                ])
              ], -1)),
              _cache[135] || (_cache[135] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_cloudSnow",
                  id: "cloudSnow",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudSnow" }, [
                    _createElementVNode("g", {
                      class: "climacon_wrapperComponent climacon_wrapperComponent-snow",
                      "clip-path": "url(#snowFillClip)"
                    }, [
                      _createElementVNode("circle", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_snow climacon_component-stroke_snow-left",
                        cx: "42.001",
                        cy: "59.641",
                        r: "2"
                      }),
                      _createElementVNode("circle", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_snow climacon_component-stroke_snow-middle",
                        cx: "50.001",
                        cy: "59.641",
                        r: "2"
                      }),
                      _createElementVNode("circle", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_snow climacon_component-stroke_snow-right",
                        cx: "57.999",
                        cy: "59.641",
                        r: "2"
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M63.999,64.943v-4.381c2.39-1.386,3.999-3.963,3.999-6.922c0-4.417-3.581-7.999-7.999-7.999c-1.601,0-3.083,0.48-4.333,1.291c-1.23-5.317-5.974-9.291-11.665-9.291c-6.627,0-11.998,5.373-11.998,12c0,3.549,1.55,6.729,4,8.924v4.916c-4.777-2.769-8-7.922-8-13.84c0-8.836,7.163-15.999,15.998-15.999c6.004,0,11.229,3.312,13.965,8.204c0.664-0.113,1.337-0.205,2.033-0.205c6.627,0,11.999,5.373,11.999,11.999C71.998,58.863,68.654,63.293,63.999,64.943z"
                      })
                    ])
                  ])
                ])
              ], -1)),
              _cache[136] || (_cache[136] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_cloudSnowFill",
                  id: "cloudSnowFill",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudSnowFill" }, [
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-snow" }, [
                      _createElementVNode("circle", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_snow climacon_component-stroke_snow-left",
                        cx: "42.001",
                        cy: "59.641",
                        r: "2"
                      }),
                      _createElementVNode("circle", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_snow climacon_component-stroke_snow-middle",
                        cx: "50.001",
                        cy: "59.641",
                        r: "2"
                      }),
                      _createElementVNode("circle", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_snow climacon_component-stroke_snow-right",
                        cx: "57.999",
                        cy: "59.641",
                        r: "2"
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M43.945,65.639c-8.835,0-15.998-7.162-15.998-15.998c0-8.836,7.163-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,6.625-5.371,11.998-11.998,11.998C57.168,65.639,47.143,65.639,43.945,65.639z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_cloud",
                        fill: "#FFFFFF",
                        d: "M59.943,61.639c4.418,0,8-3.582,8-7.998c0-4.417-3.582-8-8-8c-1.601,0-3.082,0.481-4.334,1.291c-1.23-5.316-5.973-9.29-11.665-9.29c-6.626,0-11.998,5.372-11.998,11.999c0,6.626,5.372,11.998,11.998,11.998C47.562,61.639,56.924,61.639,59.943,61.639z"
                      })
                    ])
                  ])
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_40, [
                (_openBlock(), _createElementBlock("svg", _hoisted_41, [
                  _createVNode(_component_clippath, { id: "cloudFillClipfill10" }, {
                    default: _withCtx(() => _cache[52] || (_cache[52] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M59.943,61.639c-3.02,0-12.381,0-15.999,0c-6.626,0-11.998-5.371-11.998-11.998c0-6.627,5.372-11.999,11.998-11.999c5.691,0,10.434,3.974,11.665,9.29c1.252-0.81,2.733-1.291,4.334-1.291c4.418,0,8,3.582,8,8C67.943,58.057,64.361,61.639,59.943,61.639z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_clippath, { id: "sunCloudFillClipfill2" }, {
                    default: _withCtx(() => _cache[53] || (_cache[53] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M57.945,49.641c-4.417,0-8-3.582-8-7.999c0-4.418,3.582-7.999,8-7.999s7.998,3.581,7.998,7.999C65.943,46.059,62.362,49.641,57.945,49.641z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_clippath, { id: "cloudSunFillClipfill5" }, {
                    default: _withCtx(() => _cache[54] || (_cache[54] = [
                      _createElementVNode("path", { d: "M15,15v70h20.947V63.481c-4.778-2.767-8-7.922-8-13.84c0-8.836,7.163-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,5.262-3.394,9.723-8.107,11.341V85H85V15H15z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _cache[55] || (_cache[55] = _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudSnowSun" }, [
                    _createElementVNode("g", { "clip-path": "url(#cloudSunFillClip)" }, [
                      _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-sun climacon_componentWrap-sun_cloud" }, [
                        _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_sunSpoke" }, [
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M80.029,43.611h-3.998c-1.105,0-2-0.896-2-1.999s0.895-2,2-2h3.998c1.104,0,2,0.896,2,2S81.135,43.611,80.029,43.611z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M72.174,30.3c-0.781,0.781-2.049,0.781-2.828,0c-0.781-0.781-0.781-2.047,0-2.828l2.828-2.828c0.779-0.781,2.047-0.781,2.828,0c0.779,0.781,0.779,2.047,0,2.828L72.174,30.3z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M58.033,25.614c-1.105,0-2-0.896-2-2v-3.999c0-1.104,0.895-2,2-2c1.104,0,2,0.896,2,2v3.999C60.033,24.718,59.135,25.614,58.033,25.614z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M43.892,30.3l-2.827-2.828c-0.781-0.781-0.781-2.047,0-2.828c0.78-0.781,2.047-0.781,2.827,0l2.827,2.828c0.781,0.781,0.781,2.047,0,2.828C45.939,31.081,44.673,31.081,43.892,30.3z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M42.033,41.612c0,1.104-0.896,1.999-2,1.999h-4c-1.104,0-1.998-0.896-1.998-1.999s0.896-2,1.998-2h4C41.139,39.612,42.033,40.509,42.033,41.612z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M43.892,52.925c0.781-0.78,2.048-0.78,2.827,0c0.781,0.78,0.781,2.047,0,2.828l-2.827,2.827c-0.78,0.781-2.047,0.781-2.827,0c-0.781-0.78-0.781-2.047,0-2.827L43.892,52.925z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M58.033,57.61c1.104,0,2,0.895,2,1.999v4c0,1.104-0.896,2-2,2c-1.105,0-2-0.896-2-2v-4C56.033,58.505,56.928,57.61,58.033,57.61z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M72.174,52.925l2.828,2.828c0.779,0.78,0.779,2.047,0,2.827c-0.781,0.781-2.049,0.781-2.828,0l-2.828-2.827c-0.781-0.781-0.781-2.048,0-2.828C70.125,52.144,71.391,52.144,72.174,52.925z"
                          })
                        ]),
                        _createElementVNode("g", {
                          class: "climacon_wrapperComponent climacon_wrapperComponent-sunBody",
                          "clip-path": "url(#sunCloudFillClip)"
                        }, [
                          _createElementVNode("circle", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                            cx: "58.033",
                            cy: "41.612",
                            r: "11.999"
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-snow" }, [
                      _createElementVNode("circle", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_snow climacon_component-stroke_snow-left",
                        cx: "42.001",
                        cy: "59.641",
                        r: "2"
                      }),
                      _createElementVNode("circle", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_snow climacon_component-stroke_snow-middle",
                        cx: "50.001",
                        cy: "59.641",
                        r: "2"
                      }),
                      _createElementVNode("circle", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_snow climacon_component-stroke_snow-right",
                        cx: "57.999",
                        cy: "59.641",
                        r: "2"
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M63.999,64.943v-4.381c2.39-1.386,3.999-3.963,3.999-6.922c0-4.417-3.581-7.999-7.999-7.999c-1.601,0-3.083,0.48-4.333,1.291c-1.23-5.317-5.974-9.291-11.665-9.291c-6.627,0-11.998,5.373-11.998,12c0,3.549,1.55,6.729,4,8.924v4.916c-4.777-2.769-8-7.922-8-13.84c0-8.836,7.163-15.999,15.998-15.999c6.004,0,11.229,3.312,13.965,8.204c0.664-0.113,1.337-0.205,2.033-0.205c6.627,0,11.999,5.373,11.999,11.999C71.998,58.863,68.654,63.293,63.999,64.943z"
                      })
                    ])
                  ], -1))
                ]))
              ]),
              _cache[137] || (_cache[137] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_cloudSnowSunFill",
                  id: "cloudSnowSunFill",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudSnowSunFill" }, [
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-sun climacon_componentWrap-sun_cloud" }, [
                      _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_sunSpoke" }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M80.029,43.611h-3.998c-1.105,0-2-0.896-2-1.999s0.895-2,2-2h3.998c1.104,0,2,0.896,2,2S81.135,43.611,80.029,43.611z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M72.174,30.3c-0.781,0.781-2.049,0.781-2.828,0c-0.781-0.781-0.781-2.047,0-2.828l2.828-2.828c0.779-0.781,2.047-0.781,2.828,0c0.779,0.781,0.779,2.047,0,2.828L72.174,30.3z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M58.033,25.614c-1.105,0-2-0.896-2-2v-3.999c0-1.104,0.895-2,2-2c1.104,0,2,0.896,2,2v3.999C60.033,24.718,59.135,25.614,58.033,25.614z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M43.892,30.3l-2.827-2.828c-0.781-0.781-0.781-2.047,0-2.828c0.78-0.781,2.047-0.781,2.827,0l2.827,2.828c0.781,0.781,0.781,2.047,0,2.828C45.939,31.081,44.673,31.081,43.892,30.3z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M42.033,41.612c0,1.104-0.896,1.999-2,1.999h-4c-1.104,0-1.998-0.896-1.998-1.999s0.896-2,1.998-2h4C41.139,39.612,42.033,40.509,42.033,41.612z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M43.892,52.925c0.781-0.78,2.048-0.78,2.827,0c0.781,0.78,0.781,2.047,0,2.828l-2.827,2.827c-0.78,0.781-2.047,0.781-2.827,0c-0.781-0.78-0.781-2.047,0-2.827L43.892,52.925z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M58.033,57.61c1.104,0,2,0.895,2,1.999v4c0,1.104-0.896,2-2,2c-1.105,0-2-0.896-2-2v-4C56.033,58.505,56.928,57.61,58.033,57.61z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M72.174,52.925l2.828,2.828c0.779,0.78,0.779,2.047,0,2.827c-0.781,0.781-2.049,0.781-2.828,0l-2.828-2.827c-0.781-0.781-0.781-2.048,0-2.828C70.125,52.144,71.391,52.144,72.174,52.925z"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-sunBody" }, [
                        _createElementVNode("circle", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                          cx: "58.033",
                          cy: "41.612",
                          r: "11.999"
                        }),
                        _createElementVNode("circle", {
                          class: "climacon_component climacon_component-fill climacon_component-fill_sunBody",
                          fill: "#FFFFFF",
                          cx: "58.033",
                          cy: "41.612",
                          r: "7.999"
                        })
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-snow" }, [
                      _createElementVNode("circle", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_snow climacon_component-stroke_snow-left",
                        cx: "42.001",
                        cy: "59.641",
                        r: "2"
                      }),
                      _createElementVNode("circle", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_snow climacon_component-stroke_snow-middle",
                        cx: "50.001",
                        cy: "59.641",
                        r: "2"
                      }),
                      _createElementVNode("circle", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_snow climacon_component-stroke_snow-right",
                        cx: "57.999",
                        cy: "59.641",
                        r: "2"
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M43.945,65.639c-8.835,0-15.998-7.162-15.998-15.998c0-8.836,7.163-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,6.625-5.371,11.998-11.998,11.998C57.168,65.639,47.143,65.639,43.945,65.639z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_cloud",
                        fill: "#FFFFFF",
                        d: "M59.943,61.639c4.418,0,8-3.582,8-7.998c0-4.417-3.582-8-8-8c-1.601,0-3.082,0.481-4.334,1.291c-1.23-5.316-5.973-9.29-11.665-9.29c-6.626,0-11.998,5.372-11.998,11.999c0,6.626,5.372,11.998,11.998,11.998C47.562,61.639,56.924,61.639,59.943,61.639z"
                      })
                    ])
                  ])
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_42, [
                (_openBlock(), _createElementBlock("svg", _hoisted_43, [
                  _createVNode(_component_clippath, { id: "moonCloudFillClipfill6" }, {
                    default: _withCtx(() => _cache[56] || (_cache[56] = [
                      _createElementVNode("path", { d: "M0,0v100h100V0H0z M60.943,46.641c-4.418,0-7.999-3.582-7.999-7.999c0-3.803,2.655-6.979,6.211-7.792c0.903,4.854,4.726,8.676,9.579,9.58C67.922,43.986,64.745,46.641,60.943,46.641z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_clippath, { id: "cloudFillClipfill11_1" }, {
                    default: _withCtx(() => _cache[57] || (_cache[57] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M59.943,61.639c-3.02,0-12.381,0-15.999,0c-6.626,0-11.998-5.371-11.998-11.998c0-6.627,5.372-11.999,11.998-11.999c5.691,0,10.434,3.974,11.665,9.29c1.252-0.81,2.733-1.291,4.334-1.291c4.418,0,8,3.582,8,8C67.943,58.057,64.361,61.639,59.943,61.639z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _cache[58] || (_cache[58] = _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudSnowMoon" }, [
                    _createElementVNode("g", { "clip-path": "url(#cloudFillClip)" }, [
                      _createElementVNode("g", {
                        class: "climacon_wrapperComponent climacon_wrapperComponent-moon climacon_componentWrap-moon_cloud",
                        "clip-path": "url(#moonCloudFillClip)"
                      }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                          d: "M61.023,50.641c-6.627,0-11.999-5.372-11.999-11.998c0-6.627,5.372-11.999,11.999-11.999c0.755,0,1.491,0.078,2.207,0.212c-0.132,0.576-0.208,1.173-0.208,1.788c0,4.418,3.582,7.999,8,7.999c0.614,0,1.212-0.076,1.788-0.208c0.133,0.717,0.211,1.452,0.211,2.208C73.021,45.269,67.649,50.641,61.023,50.641z"
                        })
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-snow" }, [
                      _createElementVNode("circle", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_snow climacon_component-stroke_snow-left",
                        cx: "42.001",
                        cy: "59.641",
                        r: "2"
                      }),
                      _createElementVNode("circle", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_snow climacon_component-stroke_snow-middle",
                        cx: "50.001",
                        cy: "59.641",
                        r: "2"
                      }),
                      _createElementVNode("circle", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_snow climacon_component-stroke_snow-right",
                        cx: "57.999",
                        cy: "59.641",
                        r: "2"
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M63.999,64.943v-4.381c2.39-1.386,3.999-3.963,3.999-6.922c0-4.417-3.581-7.999-7.999-7.999c-1.601,0-3.083,0.48-4.333,1.291c-1.23-5.317-5.974-9.291-11.665-9.291c-6.627,0-11.998,5.373-11.998,12c0,3.549,1.55,6.729,4,8.924v4.916c-4.777-2.769-8-7.922-8-13.84c0-8.836,7.163-15.999,15.998-15.999c6.004,0,11.229,3.312,13.965,8.204c0.664-0.113,1.337-0.205,2.033-0.205c6.627,0,11.999,5.373,11.999,11.999C71.998,58.863,68.654,63.293,63.999,64.943z"
                      })
                    ])
                  ], -1))
                ]))
              ]),
              _cache[138] || (_cache[138] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_cloudSnowMoonFill",
                  id: "cloudSnowMoonFill",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudSnowMoonFill" }, [
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-moon climacon_componentWrap-moon_cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                        d: "M61.023,50.641c-6.627,0-11.999-5.372-11.999-11.998c0-6.627,5.372-11.999,11.999-11.999c0.755,0,1.491,0.078,2.207,0.212c-0.132,0.576-0.208,1.173-0.208,1.788c0,4.418,3.582,7.999,8,7.999c0.614,0,1.212-0.076,1.788-0.208c0.133,0.717,0.211,1.452,0.211,2.208C73.021,45.269,67.649,50.641,61.023,50.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_moon",
                        fill: "#FFFFFF",
                        d: "M59.235,30.851c-3.556,0.813-6.211,3.989-6.211,7.792c0,4.417,3.581,7.999,7.999,7.999c3.802,0,6.979-2.655,7.791-6.211C63.961,39.527,60.139,35.705,59.235,30.851z"
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-snow" }, [
                      _createElementVNode("circle", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_snow climacon_component-stroke_snow-left",
                        cx: "42.001",
                        cy: "59.641",
                        r: "2"
                      }),
                      _createElementVNode("circle", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_snow climacon_component-stroke_snow-middle",
                        cx: "50.001",
                        cy: "59.641",
                        r: "2"
                      }),
                      _createElementVNode("circle", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_snow climacon_component-stroke_snow-right",
                        cx: "57.999",
                        cy: "59.641",
                        r: "2"
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M43.945,65.639c-8.835,0-15.998-7.162-15.998-15.998c0-8.836,7.163-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,6.625-5.371,11.998-11.998,11.998C57.168,65.639,47.143,65.639,43.945,65.639z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_cloud",
                        fill: "#FFFFFF",
                        d: "M59.943,61.639c4.418,0,8-3.582,8-7.998c0-4.417-3.582-8-8-8c-1.601,0-3.082,0.481-4.334,1.291c-1.23-5.316-5.973-9.29-11.665-9.29c-6.626,0-11.998,5.372-11.998,11.999c0,6.626,5.372,11.998,11.998,11.998C47.562,61.639,56.924,61.639,59.943,61.639z"
                      })
                    ])
                  ])
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_44, [
                (_openBlock(), _createElementBlock("svg", _hoisted_45, [
                  _createVNode(_component_clippath, { id: "snowFillClip" }, {
                    default: _withCtx(() => _cache[59] || (_cache[59] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M50,65.641c-1.104,0-2-0.896-2-2c0-1.104,0.896-2,2-2c1.104,0,2,0.896,2,2S51.104,65.641,50,65.641z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _cache[60] || (_cache[60] = _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudSnowAlt" }, [
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-snowAlt" }, [
                      _createElementVNode("g", {
                        class: "climacon_component climacon_component climacon_component-snowAlt",
                        "clip-path": "url(#snowFillClip)"
                      }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_snowAlt",
                          d: "M43.072,59.641c0.553-0.957,1.775-1.283,2.732-0.731L48,60.176v-2.535c0-1.104,0.896-2,2-2c1.104,0,2,0.896,2,2v2.535l2.195-1.268c0.957-0.551,2.18-0.225,2.73,0.732c0.553,0.957,0.225,2.18-0.73,2.731l-2.196,1.269l2.196,1.268c0.955,0.553,1.283,1.775,0.73,2.732c-0.552,0.954-1.773,1.282-2.73,0.729L52,67.104v2.535c0,1.105-0.896,2-2,2c-1.104,0-2-0.895-2-2v-2.535l-2.195,1.269c-0.957,0.553-2.18,0.226-2.732-0.729c-0.552-0.957-0.225-2.181,0.732-2.732L46,63.641l-2.195-1.268C42.848,61.82,42.521,60.598,43.072,59.641z"
                        })
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M61.998,65.461v-4.082c3.447-0.891,6-4.012,6-7.738c0-4.417-3.582-7.999-7.999-7.999c-1.601,0-3.084,0.48-4.334,1.291c-1.231-5.317-5.973-9.291-11.664-9.291c-6.627,0-11.999,5.373-11.999,12c0,4.438,2.417,8.305,5.999,10.379v4.444c-5.86-2.375-9.998-8.112-9.998-14.825c0-8.835,7.162-15.999,15.998-15.999c6.004,0,11.229,3.312,13.965,8.204c0.664-0.113,1.336-0.205,2.033-0.205c6.626,0,11.998,5.373,11.998,11.998C71.997,59.586,67.671,64.506,61.998,65.461z"
                      })
                    ])
                  ], -1))
                ]))
              ]),
              _cache[139] || (_cache[139] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_cloudSnowAltFill",
                  id: "cloudSnowAltFill",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudSnowAltFill" }, [
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-snowAlt" }, [
                      _createElementVNode("g", { class: "climacon_component climacon_component climacon_component-snowAlt" }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_snowAlt",
                          d: "M43.072,59.641c0.553-0.957,1.775-1.283,2.732-0.731L48,60.176v-2.535c0-1.104,0.896-2,2-2c1.104,0,2,0.896,2,2v2.535l2.195-1.268c0.957-0.551,2.18-0.225,2.73,0.732c0.553,0.957,0.225,2.18-0.73,2.731l-2.196,1.269l2.196,1.268c0.955,0.553,1.283,1.775,0.73,2.732c-0.552,0.954-1.773,1.282-2.73,0.729L52,67.104v2.535c0,1.105-0.896,2-2,2c-1.104,0-2-0.895-2-2v-2.535l-2.195,1.269c-0.957,0.553-2.18,0.226-2.732-0.729c-0.552-0.957-0.225-2.181,0.732-2.732L46,63.641l-2.195-1.268C42.848,61.82,42.521,60.598,43.072,59.641z"
                        }),
                        _createElementVNode("circle", {
                          class: "climacon_component climacon_component-fill climacon_component-fill_snowAlt",
                          fill: "#FFFFFF",
                          cx: "50",
                          cy: "63.641",
                          r: "2"
                        })
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M43.945,65.639c-8.835,0-15.998-7.162-15.998-15.998c0-8.836,7.163-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,6.625-5.371,11.998-11.998,11.998C57.168,65.639,47.143,65.639,43.945,65.639z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_cloud",
                        fill: "#FFFFFF",
                        d: "M59.943,61.639c4.418,0,8-3.582,8-7.998c0-4.417-3.582-8-8-8c-1.601,0-3.082,0.481-4.334,1.291c-1.23-5.316-5.973-9.29-11.665-9.29c-6.626,0-11.998,5.372-11.998,11.999c0,6.626,5.372,11.998,11.998,11.998C47.562,61.639,56.924,61.639,59.943,61.639z"
                      })
                    ])
                  ])
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_46, [
                (_openBlock(), _createElementBlock("svg", _hoisted_47, [
                  _createVNode(_component_clippath, { id: "cloudFillClipfill12" }, {
                    default: _withCtx(() => _cache[61] || (_cache[61] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M59.943,61.639c-3.02,0-12.381,0-15.999,0c-6.626,0-11.998-5.371-11.998-11.998c0-6.627,5.372-11.999,11.998-11.999c5.691,0,10.434,3.974,11.665,9.29c1.252-0.81,2.733-1.291,4.334-1.291c4.418,0,8,3.582,8,8C67.943,58.057,64.361,61.639,59.943,61.639z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_clippath, { id: "sunCloudFillClipfill3" }, {
                    default: _withCtx(() => _cache[62] || (_cache[62] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M57.945,49.641c-4.417,0-8-3.582-8-7.999c0-4.418,3.582-7.999,8-7.999s7.998,3.581,7.998,7.999C65.943,46.059,62.362,49.641,57.945,49.641z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_clippath, { id: "cloudSunFillClipfill6" }, {
                    default: _withCtx(() => _cache[63] || (_cache[63] = [
                      _createElementVNode("path", { d: "M15,15v70h20.947V63.481c-4.778-2.767-8-7.922-8-13.84c0-8.836,7.163-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,5.262-3.394,9.723-8.107,11.341V85H85V15H15z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_clippath, { id: "snowFillClipfill1" }, {
                    default: _withCtx(() => _cache[64] || (_cache[64] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M50,65.641c-1.104,0-2-0.896-2-2c0-1.104,0.896-2,2-2c1.104,0,2,0.896,2,2S51.104,65.641,50,65.641z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _cache[65] || (_cache[65] = _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudSnowSunAlt" }, [
                    _createElementVNode("g", { "clip-path": "url(#cloudSunFillClip)" }, [
                      _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-sun climacon_componentWrap-sun_cloud" }, [
                        _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_sunSpoke" }, [
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M80.029,43.611h-3.998c-1.105,0-2-0.896-2-1.999s0.895-2,2-2h3.998c1.104,0,2,0.896,2,2S81.135,43.611,80.029,43.611z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M72.174,30.3c-0.781,0.781-2.049,0.781-2.828,0c-0.781-0.781-0.781-2.047,0-2.828l2.828-2.828c0.779-0.781,2.047-0.781,2.828,0c0.779,0.781,0.779,2.047,0,2.828L72.174,30.3z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M58.033,25.614c-1.105,0-2-0.896-2-2v-3.999c0-1.104,0.895-2,2-2c1.104,0,2,0.896,2,2v3.999C60.033,24.718,59.135,25.614,58.033,25.614z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M43.892,30.3l-2.827-2.828c-0.781-0.781-0.781-2.047,0-2.828c0.78-0.781,2.047-0.781,2.827,0l2.827,2.828c0.781,0.781,0.781,2.047,0,2.828C45.939,31.081,44.673,31.081,43.892,30.3z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M42.033,41.612c0,1.104-0.896,1.999-2,1.999h-4c-1.104,0-1.998-0.896-1.998-1.999s0.896-2,1.998-2h4C41.139,39.612,42.033,40.509,42.033,41.612z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M43.892,52.925c0.781-0.78,2.048-0.78,2.827,0c0.781,0.78,0.781,2.047,0,2.828l-2.827,2.827c-0.78,0.781-2.047,0.781-2.827,0c-0.781-0.78-0.781-2.047,0-2.827L43.892,52.925z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M58.033,57.61c1.104,0,2,0.895,2,1.999v4c0,1.104-0.896,2-2,2c-1.105,0-2-0.896-2-2v-4C56.033,58.505,56.928,57.61,58.033,57.61z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M72.174,52.925l2.828,2.828c0.779,0.78,0.779,2.047,0,2.827c-0.781,0.781-2.049,0.781-2.828,0l-2.828-2.827c-0.781-0.781-0.781-2.048,0-2.828C70.125,52.144,71.391,52.144,72.174,52.925z"
                          })
                        ]),
                        _createElementVNode("g", {
                          class: "climacon_wrapperComponent climacon_wrapperComponent-sunBody",
                          "clip-path": "url(#sunCloudFillClip)"
                        }, [
                          _createElementVNode("circle", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                            cx: "58.033",
                            cy: "41.612",
                            r: "11.999"
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-snowAlt" }, [
                      _createElementVNode("g", {
                        class: "climacon_component climacon_component climacon_component-snowAlt",
                        "clip-path": "url(#snowFillClip)"
                      }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_snowAlt",
                          d: "M43.072,59.641c0.553-0.957,1.775-1.283,2.732-0.731L48,60.176v-2.535c0-1.104,0.896-2,2-2c1.104,0,2,0.896,2,2v2.535l2.195-1.268c0.957-0.551,2.18-0.225,2.73,0.732c0.553,0.957,0.225,2.18-0.73,2.731l-2.196,1.269l2.196,1.268c0.955,0.553,1.283,1.775,0.73,2.732c-0.552,0.954-1.773,1.282-2.73,0.729L52,67.104v2.535c0,1.105-0.896,2-2,2c-1.104,0-2-0.895-2-2v-2.535l-2.195,1.269c-0.957,0.553-2.18,0.226-2.732-0.729c-0.552-0.957-0.225-2.181,0.732-2.732L46,63.641l-2.195-1.268C42.848,61.82,42.521,60.598,43.072,59.641z"
                        })
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M61.998,65.461v-4.082c3.447-0.891,6-4.012,6-7.738c0-4.417-3.582-7.999-7.999-7.999c-1.601,0-3.084,0.48-4.334,1.291c-1.231-5.317-5.973-9.291-11.664-9.291c-6.627,0-11.999,5.373-11.999,12c0,4.438,2.417,8.305,5.999,10.379v4.444c-5.86-2.375-9.998-8.112-9.998-14.825c0-8.835,7.162-15.999,15.998-15.999c6.004,0,11.229,3.312,13.965,8.204c0.664-0.113,1.336-0.205,2.033-0.205c6.626,0,11.998,5.373,11.998,11.998C71.997,59.586,67.671,64.506,61.998,65.461z"
                      })
                    ])
                  ], -1))
                ]))
              ]),
              _cache[140] || (_cache[140] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_cloudSnowSunAltFill",
                  id: "cloudSnowSunAltFill",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudSnowSunAltFill" }, [
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-sun climacon_componentWrap-sun_cloud" }, [
                      _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_sunSpoke" }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M80.029,43.611h-3.998c-1.105,0-2-0.896-2-1.999s0.895-2,2-2h3.998c1.104,0,2,0.896,2,2S81.135,43.611,80.029,43.611z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M72.174,30.3c-0.781,0.781-2.049,0.781-2.828,0c-0.781-0.781-0.781-2.047,0-2.828l2.828-2.828c0.779-0.781,2.047-0.781,2.828,0c0.779,0.781,0.779,2.047,0,2.828L72.174,30.3z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M58.033,25.614c-1.105,0-2-0.896-2-2v-3.999c0-1.104,0.895-2,2-2c1.104,0,2,0.896,2,2v3.999C60.033,24.718,59.135,25.614,58.033,25.614z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M43.892,30.3l-2.827-2.828c-0.781-0.781-0.781-2.047,0-2.828c0.78-0.781,2.047-0.781,2.827,0l2.827,2.828c0.781,0.781,0.781,2.047,0,2.828C45.939,31.081,44.673,31.081,43.892,30.3z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M42.033,41.612c0,1.104-0.896,1.999-2,1.999h-4c-1.104,0-1.998-0.896-1.998-1.999s0.896-2,1.998-2h4C41.139,39.612,42.033,40.509,42.033,41.612z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M43.892,52.925c0.781-0.78,2.048-0.78,2.827,0c0.781,0.78,0.781,2.047,0,2.828l-2.827,2.827c-0.78,0.781-2.047,0.781-2.827,0c-0.781-0.78-0.781-2.047,0-2.827L43.892,52.925z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M58.033,57.61c1.104,0,2,0.895,2,1.999v4c0,1.104-0.896,2-2,2c-1.105,0-2-0.896-2-2v-4C56.033,58.505,56.928,57.61,58.033,57.61z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M72.174,52.925l2.828,2.828c0.779,0.78,0.779,2.047,0,2.827c-0.781,0.781-2.049,0.781-2.828,0l-2.828-2.827c-0.781-0.781-0.781-2.048,0-2.828C70.125,52.144,71.391,52.144,72.174,52.925z"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-sunBody" }, [
                        _createElementVNode("circle", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                          cx: "58.033",
                          cy: "41.612",
                          r: "11.999"
                        }),
                        _createElementVNode("circle", {
                          class: "climacon_component climacon_component-fill climacon_component-fill_sunBody",
                          fill: "#FFFFFF",
                          cx: "58.033",
                          cy: "41.612",
                          r: "7.999"
                        })
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-snowAlt" }, [
                      _createElementVNode("g", { class: "climacon_component climacon_component climacon_component-snowAlt" }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_snowAlt",
                          d: "M43.072,59.641c0.553-0.957,1.775-1.283,2.732-0.731L48,60.176v-2.535c0-1.104,0.896-2,2-2c1.104,0,2,0.896,2,2v2.535l2.195-1.268c0.957-0.551,2.18-0.225,2.73,0.732c0.553,0.957,0.225,2.18-0.73,2.731l-2.196,1.269l2.196,1.268c0.955,0.553,1.283,1.775,0.73,2.732c-0.552,0.954-1.773,1.282-2.73,0.729L52,67.104v2.535c0,1.105-0.896,2-2,2c-1.104,0-2-0.895-2-2v-2.535l-2.195,1.269c-0.957,0.553-2.18,0.226-2.732-0.729c-0.552-0.957-0.225-2.181,0.732-2.732L46,63.641l-2.195-1.268C42.848,61.82,42.521,60.598,43.072,59.641z"
                        }),
                        _createElementVNode("circle", {
                          class: "climacon_component climacon_component-fill climacon_component-fill_snowAlt",
                          fill: "#FFFFFF",
                          cx: "50",
                          cy: "63.641",
                          r: "2"
                        })
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M43.945,65.639c-8.835,0-15.998-7.162-15.998-15.998c0-8.836,7.163-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,6.625-5.371,11.998-11.998,11.998C57.168,65.639,47.143,65.639,43.945,65.639z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_cloud",
                        fill: "#FFFFFF",
                        d: "M59.943,61.639c4.418,0,8-3.582,8-7.998c0-4.417-3.582-8-8-8c-1.601,0-3.082,0.481-4.334,1.291c-1.23-5.316-5.973-9.29-11.665-9.29c-6.626,0-11.998,5.372-11.998,11.999c0,6.626,5.372,11.998,11.998,11.998C47.562,61.639,56.924,61.639,59.943,61.639z"
                      })
                    ])
                  ])
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_48, [
                (_openBlock(), _createElementBlock("svg", _hoisted_49, [
                  _createVNode(_component_clippath, { id: "moonCloudFillClipfill7" }, {
                    default: _withCtx(() => _cache[66] || (_cache[66] = [
                      _createElementVNode("path", { d: "M0,0v100h100V0H0z M60.943,46.641c-4.418,0-7.999-3.582-7.999-7.999c0-3.803,2.655-6.979,6.211-7.792c0.903,4.854,4.726,8.676,9.579,9.58C67.922,43.986,64.745,46.641,60.943,46.641z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_clippath, { id: "cloudFillClipfill13" }, {
                    default: _withCtx(() => _cache[67] || (_cache[67] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M59.943,61.639c-3.02,0-12.381,0-15.999,0c-6.626,0-11.998-5.371-11.998-11.998c0-6.627,5.372-11.999,11.998-11.999c5.691,0,10.434,3.974,11.665,9.29c1.252-0.81,2.733-1.291,4.334-1.291c4.418,0,8,3.582,8,8C67.943,58.057,64.361,61.639,59.943,61.639z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_clippath, { id: "snowFillClipfill2" }, {
                    default: _withCtx(() => _cache[68] || (_cache[68] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M50,65.641c-1.104,0-2-0.896-2-2c0-1.104,0.896-2,2-2c1.104,0,2,0.896,2,2S51.104,65.641,50,65.641z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _cache[69] || (_cache[69] = _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudSnowAlt" }, [
                    _createElementVNode("g", { "clip-path": "url(#cloudFillClip)" }, [
                      _createElementVNode("g", {
                        class: "climacon_wrapperComponent climacon_wrapperComponent-moon climacon_componentWrap-moon_cloud",
                        "clip-path": "url(#moonCloudFillClip)"
                      }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                          d: "M61.023,50.641c-6.627,0-11.999-5.372-11.999-11.998c0-6.627,5.372-11.999,11.999-11.999c0.755,0,1.491,0.078,2.207,0.212c-0.132,0.576-0.208,1.173-0.208,1.788c0,4.418,3.582,7.999,8,7.999c0.614,0,1.212-0.076,1.788-0.208c0.133,0.717,0.211,1.452,0.211,2.208C73.021,45.269,67.649,50.641,61.023,50.641z"
                        })
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-snowAlt" }, [
                      _createElementVNode("g", {
                        class: "climacon_component climacon_component climacon_component-snowAlt",
                        "clip-path": "url(#snowFillClip)"
                      }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_snowAlt",
                          d: "M43.072,59.641c0.553-0.957,1.775-1.283,2.732-0.731L48,60.176v-2.535c0-1.104,0.896-2,2-2c1.104,0,2,0.896,2,2v2.535l2.195-1.268c0.957-0.551,2.18-0.225,2.73,0.732c0.553,0.957,0.225,2.18-0.73,2.731l-2.196,1.269l2.196,1.268c0.955,0.553,1.283,1.775,0.73,2.732c-0.552,0.954-1.773,1.282-2.73,0.729L52,67.104v2.535c0,1.105-0.896,2-2,2c-1.104,0-2-0.895-2-2v-2.535l-2.195,1.269c-0.957,0.553-2.18,0.226-2.732-0.729c-0.552-0.957-0.225-2.181,0.732-2.732L46,63.641l-2.195-1.268C42.848,61.82,42.521,60.598,43.072,59.641z"
                        })
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M61.998,65.461v-4.082c3.447-0.891,6-4.012,6-7.738c0-4.417-3.582-7.999-7.999-7.999c-1.601,0-3.084,0.48-4.334,1.291c-1.231-5.317-5.973-9.291-11.664-9.291c-6.627,0-11.999,5.373-11.999,12c0,4.438,2.417,8.305,5.999,10.379v4.444c-5.86-2.375-9.998-8.112-9.998-14.825c0-8.835,7.162-15.999,15.998-15.999c6.004,0,11.229,3.312,13.965,8.204c0.664-0.113,1.336-0.205,2.033-0.205c6.626,0,11.998,5.373,11.998,11.998C71.997,59.586,67.671,64.506,61.998,65.461z"
                      })
                    ])
                  ], -1))
                ]))
              ]),
              _cache[141] || (_cache[141] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_cloudSnowAltFill",
                  id: "cloudSnowAltFill1",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudSnowAltFill" }, [
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-moon climacon_componentWrap-moon_cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                        d: "M61.023,50.641c-6.627,0-11.999-5.372-11.999-11.998c0-6.627,5.372-11.999,11.999-11.999c0.755,0,1.491,0.078,2.207,0.212c-0.132,0.576-0.208,1.173-0.208,1.788c0,4.418,3.582,7.999,8,7.999c0.614,0,1.212-0.076,1.788-0.208c0.133,0.717,0.211,1.452,0.211,2.208C73.021,45.269,67.649,50.641,61.023,50.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_moon",
                        fill: "#FFFFFF",
                        d: "M59.235,30.851c-3.556,0.813-6.211,3.989-6.211,7.792c0,4.417,3.581,7.999,7.999,7.999c3.802,0,6.979-2.655,7.791-6.211C63.961,39.527,60.139,35.705,59.235,30.851z"
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-snowAlt" }, [
                      _createElementVNode("g", { class: "climacon_component climacon_component climacon_component-snowAlt" }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_snowAlt",
                          d: "M43.072,59.641c0.553-0.957,1.775-1.283,2.732-0.731L48,60.176v-2.535c0-1.104,0.896-2,2-2c1.104,0,2,0.896,2,2v2.535l2.195-1.268c0.957-0.551,2.18-0.225,2.73,0.732c0.553,0.957,0.225,2.18-0.73,2.731l-2.196,1.269l2.196,1.268c0.955,0.553,1.283,1.775,0.73,2.732c-0.552,0.954-1.773,1.282-2.73,0.729L52,67.104v2.535c0,1.105-0.896,2-2,2c-1.104,0-2-0.895-2-2v-2.535l-2.195,1.269c-0.957,0.553-2.18,0.226-2.732-0.729c-0.552-0.957-0.225-2.181,0.732-2.732L46,63.641l-2.195-1.268C42.848,61.82,42.521,60.598,43.072,59.641z"
                        }),
                        _createElementVNode("circle", {
                          class: "climacon_component climacon_component-fill climacon_component-fill_snowAlt",
                          fill: "#FFFFFF",
                          cx: "50",
                          cy: "63.641",
                          r: "2"
                        })
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M43.945,65.639c-8.835,0-15.998-7.162-15.998-15.998c0-8.836,7.163-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,6.625-5.371,11.998-11.998,11.998C57.168,65.639,47.143,65.639,43.945,65.639z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_cloud",
                        fill: "#FFFFFF",
                        d: "M59.943,61.639c4.418,0,8-3.582,8-7.998c0-4.417-3.582-8-8-8c-1.601,0-3.082,0.481-4.334,1.291c-1.23-5.316-5.973-9.29-11.665-9.29c-6.626,0-11.998,5.372-11.998,11.999c0,6.626,5.372,11.998,11.998,11.998C47.562,61.639,56.924,61.639,59.943,61.639z"
                      })
                    ])
                  ])
                ])
              ], -1)),
              _cache[142] || (_cache[142] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_cloudFog",
                  id: "cloudFog",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudFog" }, [
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-Fog" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine climacon_component-stroke_fogLine-top",
                        d: "M69.998,57.641H30.003c-1.104,0-2-0.895-2-2c0-1.104,0.896-2,2-2h39.995c1.104,0,2,0.896,2,2C71.998,56.746,71.104,57.641,69.998,57.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine climacon_component-stroke_fogLine-middle",
                        d: "M69.998,65.641H30.003c-1.104,0-2-0.896-2-2s0.896-2,2-2h39.995c1.104,0,2,0.896,2,2C71.998,64.744,71.104,65.641,69.998,65.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine climacon_component-stroke_fogLine-bottom",
                        d: "M30.003,69.639h39.995c1.104,0,2,0.896,2,2c0,1.105-0.896,2-2,2H30.003c-1.104,0-2-0.895-2-2C28.003,70.535,28.898,69.639,30.003,69.639z"
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M59.999,45.643c-1.601,0-3.083,0.48-4.333,1.291c-1.232-5.317-5.974-9.291-11.665-9.291c-6.626,0-11.998,5.373-11.998,12h-4c0-8.835,7.163-15.999,15.998-15.999c6.004,0,11.229,3.312,13.965,8.204c0.664-0.113,1.337-0.205,2.033-0.205c5.222,0,9.651,3.342,11.301,8h-4.381C65.535,47.253,62.958,45.643,59.999,45.643z"
                      })
                    ])
                  ])
                ])
              ], -1)),
              _cache[143] || (_cache[143] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_cloudFogFill",
                  id: "cloudFogFill",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudFog" }, [
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-Fog" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine climacon_component-stroke_fogLine-top",
                        d: "M69.998,57.641H30.003c-1.104,0-2-0.895-2-2c0-1.104,0.896-2,2-2h39.995c1.104,0,2,0.896,2,2C71.998,56.746,71.104,57.641,69.998,57.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine climacon_component-stroke_fogLine-middle",
                        d: "M69.998,65.641H30.003c-1.104,0-2-0.896-2-2s0.896-2,2-2h39.995c1.104,0,2,0.896,2,2C71.998,64.744,71.104,65.641,69.998,65.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine climacon_component-stroke_fogLine-bottom",
                        d: "M30.003,69.639h39.995c1.104,0,2,0.896,2,2c0,1.105-0.896,2-2,2H30.003c-1.104,0-2-0.895-2-2C28.003,70.535,28.898,69.639,30.003,69.639z"
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M59.999,45.643c-1.601,0-3.083,0.48-4.333,1.291c-1.232-5.317-5.974-9.291-11.665-9.291c-6.626,0-11.998,5.373-11.998,12h-4c0-8.835,7.163-15.999,15.998-15.999c6.004,0,11.229,3.312,13.965,8.204c0.664-0.113,1.337-0.205,2.033-0.205c5.222,0,9.651,3.342,11.301,8h-4.381C65.535,47.253,62.958,45.643,59.999,45.643z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M71.287,49.355c-1.659-4.632-6.08-7.954-11.289-7.954c-0.695,0-1.369,0.091-2.033,0.205C55.229,36.72,50.004,33.413,44,33.413c-8.824,0-15.977,7.134-15.996,15.942H71.287z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_cloud",
                        fill: "#FFFFFF",
                        d: "M66.897,49.376c-1.389-2.369-3.955-3.965-6.899-3.965c-1.602,0-3.082,0.48-4.334,1.291c-1.23-5.316-5.973-9.291-11.664-9.291c-6.615,0-11.977,5.354-11.996,11.965H66.897z"
                      })
                    ])
                  ])
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_50, [
                (_openBlock(), _createElementBlock("svg", _hoisted_51, [
                  _createVNode(_component_clippath, { id: "cloudFillClipfill14" }, {
                    default: _withCtx(() => _cache[70] || (_cache[70] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M59.943,61.639c-3.02,0-12.381,0-15.999,0c-6.626,0-11.998-5.371-11.998-11.998c0-6.627,5.372-11.999,11.998-11.999c5.691,0,10.434,3.974,11.665,9.29c1.252-0.81,2.733-1.291,4.334-1.291c4.418,0,8,3.582,8,8C67.943,58.057,64.361,61.639,59.943,61.639z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_clippath, { id: "sunCloudFillClipfill" }, {
                    default: _withCtx(() => _cache[71] || (_cache[71] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M57.945,49.641c-4.417,0-8-3.582-8-7.999c0-4.418,3.582-7.999,8-7.999s7.998,3.581,7.998,7.999C65.943,46.059,62.362,49.641,57.945,49.641z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_clippath, { id: "cloudSunFillClipfill7" }, {
                    default: _withCtx(() => _cache[72] || (_cache[72] = [
                      _createElementVNode("path", { d: "M15,15v70h20.947V63.481c-4.778-2.767-8-7.922-8-13.84c0-8.836,7.163-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,5.262-3.394,9.723-8.107,11.341V85H85V15H15z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _cache[73] || (_cache[73] = _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudFogSun" }, [
                    _createElementVNode("g", { "clip-path": "url(#cloudSunFillClip)" }, [
                      _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-sun climacon_componentWrap-sun_cloud" }, [
                        _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_sunSpoke" }, [
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M80.029,43.611h-3.998c-1.105,0-2-0.896-2-1.999s0.895-2,2-2h3.998c1.104,0,2,0.896,2,2S81.135,43.611,80.029,43.611z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M72.174,30.3c-0.781,0.781-2.049,0.781-2.828,0c-0.781-0.781-0.781-2.047,0-2.828l2.828-2.828c0.779-0.781,2.047-0.781,2.828,0c0.779,0.781,0.779,2.047,0,2.828L72.174,30.3z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M58.033,25.614c-1.105,0-2-0.896-2-2v-3.999c0-1.104,0.895-2,2-2c1.104,0,2,0.896,2,2v3.999C60.033,24.718,59.135,25.614,58.033,25.614z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M43.892,30.3l-2.827-2.828c-0.781-0.781-0.781-2.047,0-2.828c0.78-0.781,2.047-0.781,2.827,0l2.827,2.828c0.781,0.781,0.781,2.047,0,2.828C45.939,31.081,44.673,31.081,43.892,30.3z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M42.033,41.612c0,1.104-0.896,1.999-2,1.999h-4c-1.104,0-1.998-0.896-1.998-1.999s0.896-2,1.998-2h4C41.139,39.612,42.033,40.509,42.033,41.612z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M43.892,52.925c0.781-0.78,2.048-0.78,2.827,0c0.781,0.78,0.781,2.047,0,2.828l-2.827,2.827c-0.78,0.781-2.047,0.781-2.827,0c-0.781-0.78-0.781-2.047,0-2.827L43.892,52.925z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M58.033,57.61c1.104,0,2,0.895,2,1.999v4c0,1.104-0.896,2-2,2c-1.105,0-2-0.896-2-2v-4C56.033,58.505,56.928,57.61,58.033,57.61z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M72.174,52.925l2.828,2.828c0.779,0.78,0.779,2.047,0,2.827c-0.781,0.781-2.049,0.781-2.828,0l-2.828-2.827c-0.781-0.781-0.781-2.048,0-2.828C70.125,52.144,71.391,52.144,72.174,52.925z"
                          })
                        ]),
                        _createElementVNode("g", {
                          class: "climacon_wrapperComponent climacon_wrapperComponent-sunBody",
                          "clip-path": "url(#sunCloudFillClip)"
                        }, [
                          _createElementVNode("circle", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                            cx: "58.033",
                            cy: "41.612",
                            r: "11.999"
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-Fog" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine climacon_component-stroke_fogLine-top",
                        d: "M69.998,57.641H30.003c-1.104,0-2-0.895-2-2c0-1.104,0.896-2,2-2h39.995c1.104,0,2,0.896,2,2C71.998,56.746,71.104,57.641,69.998,57.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine climacon_component-stroke_fogLine-middle",
                        d: "M69.998,65.641H30.003c-1.104,0-2-0.896-2-2s0.896-2,2-2h39.995c1.104,0,2,0.896,2,2C71.998,64.744,71.104,65.641,69.998,65.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine climacon_component-stroke_fogLine-bottom",
                        d: "M30.003,69.639h39.995c1.104,0,2,0.896,2,2c0,1.105-0.896,2-2,2H30.003c-1.104,0-2-0.895-2-2C28.003,70.535,28.898,69.639,30.003,69.639z"
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M59.999,45.643c-1.601,0-3.083,0.48-4.333,1.291c-1.232-5.317-5.974-9.291-11.665-9.291c-6.626,0-11.998,5.373-11.998,12h-4c0-8.835,7.163-15.999,15.998-15.999c6.004,0,11.229,3.312,13.965,8.204c0.664-0.113,1.337-0.205,2.033-0.205c5.222,0,9.651,3.342,11.301,8h-4.381C65.535,47.253,62.958,45.643,59.999,45.643z"
                      })
                    ])
                  ], -1))
                ]))
              ]),
              _createElementVNode("div", _hoisted_52, [
                (_openBlock(), _createElementBlock("svg", _hoisted_53, [
                  _createVNode(_component_clippath, { id: "cloudFillClipfill15" }, {
                    default: _withCtx(() => _cache[74] || (_cache[74] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M59.943,61.639c-3.02,0-12.381,0-15.999,0c-6.626,0-11.998-5.371-11.998-11.998c0-6.627,5.372-11.999,11.998-11.999c5.691,0,10.434,3.974,11.665,9.29c1.252-0.81,2.733-1.291,4.334-1.291c4.418,0,8,3.582,8,8C67.943,58.057,64.361,61.639,59.943,61.639z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_clippath, { id: "sunCloudFillClipfills1" }, {
                    default: _withCtx(() => _cache[75] || (_cache[75] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M57.945,49.641c-4.417,0-8-3.582-8-7.999c0-4.418,3.582-7.999,8-7.999s7.998,3.581,7.998,7.999C65.943,46.059,62.362,49.641,57.945,49.641z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_clippath, { id: "cloudSunFillClipfill8" }, {
                    default: _withCtx(() => _cache[76] || (_cache[76] = [
                      _createElementVNode("path", { d: "M15,15v70h20.947V63.481c-4.778-2.767-8-7.922-8-13.84c0-8.836,7.163-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,5.262-3.394,9.723-8.107,11.341V85H85V15H15z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _cache[77] || (_cache[77] = _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudFogSunFill" }, [
                    _createElementVNode("g", { "clip-path": "url(#cloudSunFillClip)" }, [
                      _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-sun climacon_componentWrap-sun_cloud" }, [
                        _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_sunSpoke" }, [
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M80.029,43.611h-3.998c-1.105,0-2-0.896-2-1.999s0.895-2,2-2h3.998c1.104,0,2,0.896,2,2S81.135,43.611,80.029,43.611z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M72.174,30.3c-0.781,0.781-2.049,0.781-2.828,0c-0.781-0.781-0.781-2.047,0-2.828l2.828-2.828c0.779-0.781,2.047-0.781,2.828,0c0.779,0.781,0.779,2.047,0,2.828L72.174,30.3z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M58.033,25.614c-1.105,0-2-0.896-2-2v-3.999c0-1.104,0.895-2,2-2c1.104,0,2,0.896,2,2v3.999C60.033,24.718,59.135,25.614,58.033,25.614z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M43.892,30.3l-2.827-2.828c-0.781-0.781-0.781-2.047,0-2.828c0.78-0.781,2.047-0.781,2.827,0l2.827,2.828c0.781,0.781,0.781,2.047,0,2.828C45.939,31.081,44.673,31.081,43.892,30.3z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M42.033,41.612c0,1.104-0.896,1.999-2,1.999h-4c-1.104,0-1.998-0.896-1.998-1.999s0.896-2,1.998-2h4C41.139,39.612,42.033,40.509,42.033,41.612z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M43.892,52.925c0.781-0.78,2.048-0.78,2.827,0c0.781,0.78,0.781,2.047,0,2.828l-2.827,2.827c-0.78,0.781-2.047,0.781-2.827,0c-0.781-0.78-0.781-2.047,0-2.827L43.892,52.925z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M58.033,57.61c1.104,0,2,0.895,2,1.999v4c0,1.104-0.896,2-2,2c-1.105,0-2-0.896-2-2v-4C56.033,58.505,56.928,57.61,58.033,57.61z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M72.174,52.925l2.828,2.828c0.779,0.78,0.779,2.047,0,2.827c-0.781,0.781-2.049,0.781-2.828,0l-2.828-2.827c-0.781-0.781-0.781-2.048,0-2.828C70.125,52.144,71.391,52.144,72.174,52.925z"
                          })
                        ]),
                        _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-sunBody" }, [
                          _createElementVNode("circle", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                            cx: "58.033",
                            cy: "41.612",
                            r: "11.999"
                          }),
                          _createElementVNode("circle", {
                            class: "climacon_component climacon_component-fill climacon_component-fill_sunBody",
                            fill: "#FFFFFF",
                            cx: "58.033",
                            cy: "41.612",
                            r: "7.999"
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-Fog" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine climacon_component-stroke_fogLine-top",
                        d: "M69.998,57.641H30.003c-1.104,0-2-0.895-2-2c0-1.104,0.896-2,2-2h39.995c1.104,0,2,0.896,2,2C71.998,56.746,71.104,57.641,69.998,57.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine climacon_component-stroke_fogLine-middle",
                        d: "M69.998,65.641H30.003c-1.104,0-2-0.896-2-2s0.896-2,2-2h39.995c1.104,0,2,0.896,2,2C71.998,64.744,71.104,65.641,69.998,65.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine climacon_component-stroke_fogLine-bottom",
                        d: "M30.003,69.639h39.995c1.104,0,2,0.896,2,2c0,1.105-0.896,2-2,2H30.003c-1.104,0-2-0.895-2-2C28.003,70.535,28.898,69.639,30.003,69.639z"
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M59.999,45.643c-1.601,0-3.083,0.48-4.333,1.291c-1.232-5.317-5.974-9.291-11.665-9.291c-6.626,0-11.998,5.373-11.998,12h-4c0-8.835,7.163-15.999,15.998-15.999c6.004,0,11.229,3.312,13.965,8.204c0.664-0.113,1.337-0.205,2.033-0.205c5.222,0,9.651,3.342,11.301,8h-4.381C65.535,47.253,62.958,45.643,59.999,45.643z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M71.287,49.355c-1.659-4.632-6.08-7.954-11.289-7.954c-0.695,0-1.369,0.091-2.033,0.205C55.229,36.72,50.004,33.413,44,33.413c-8.824,0-15.977,7.134-15.996,15.942H71.287z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_cloud",
                        fill: "#FFFFFF",
                        d: "M66.897,49.376c-1.389-2.369-3.955-3.965-6.899-3.965c-1.602,0-3.082,0.48-4.334,1.291c-1.23-5.316-5.973-9.291-11.664-9.291c-6.615,0-11.977,5.354-11.996,11.965H66.897z"
                      })
                    ])
                  ], -1))
                ]))
              ]),
              _createElementVNode("div", _hoisted_54, [
                (_openBlock(), _createElementBlock("svg", _hoisted_55, [
                  _createVNode(_component_clippath, { id: "moonCloudFillClipfill8" }, {
                    default: _withCtx(() => _cache[78] || (_cache[78] = [
                      _createElementVNode("path", { d: "M0,0v100h100V0H0z M60.943,46.641c-4.418,0-7.999-3.582-7.999-7.999c0-3.803,2.655-6.979,6.211-7.792c0.903,4.854,4.726,8.676,9.579,9.58C67.922,43.986,64.745,46.641,60.943,46.641z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_clippath, { id: "cloudFillClipfill16" }, {
                    default: _withCtx(() => _cache[79] || (_cache[79] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M59.943,61.639c-3.02,0-12.381,0-15.999,0c-6.626,0-11.998-5.371-11.998-11.998c0-6.627,5.372-11.999,11.998-11.999c5.691,0,10.434,3.974,11.665,9.29c1.252-0.81,2.733-1.291,4.334-1.291c4.418,0,8,3.582,8,8C67.943,58.057,64.361,61.639,59.943,61.639z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _cache[80] || (_cache[80] = _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudFogMoon" }, [
                    _createElementVNode("g", { "clip-path": "url(#cloudFillClip)" }, [
                      _createElementVNode("g", {
                        class: "climacon_wrapperComponent climacon_wrapperComponent-moon climacon_componentWrap-moon_cloud",
                        "clip-path": "url(#moonCloudFillClip)"
                      }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                          d: "M61.023,50.641c-6.627,0-11.999-5.372-11.999-11.998c0-6.627,5.372-11.999,11.999-11.999c0.755,0,1.491,0.078,2.207,0.212c-0.132,0.576-0.208,1.173-0.208,1.788c0,4.418,3.582,7.999,8,7.999c0.614,0,1.212-0.076,1.788-0.208c0.133,0.717,0.211,1.452,0.211,2.208C73.021,45.269,67.649,50.641,61.023,50.641z"
                        })
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-Fog" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine climacon_component-stroke_fogLine-top",
                        d: "M69.998,57.641H30.003c-1.104,0-2-0.895-2-2c0-1.104,0.896-2,2-2h39.995c1.104,0,2,0.896,2,2C71.998,56.746,71.104,57.641,69.998,57.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine climacon_component-stroke_fogLine-middle",
                        d: "M69.998,65.641H30.003c-1.104,0-2-0.896-2-2s0.896-2,2-2h39.995c1.104,0,2,0.896,2,2C71.998,64.744,71.104,65.641,69.998,65.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine climacon_component-stroke_fogLine-bottom",
                        d: "M30.003,69.639h39.995c1.104,0,2,0.896,2,2c0,1.105-0.896,2-2,2H30.003c-1.104,0-2-0.895-2-2C28.003,70.535,28.898,69.639,30.003,69.639z"
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M59.999,45.643c-1.601,0-3.083,0.48-4.333,1.291c-1.232-5.317-5.974-9.291-11.665-9.291c-6.626,0-11.998,5.373-11.998,12h-4c0-8.835,7.163-15.999,15.998-15.999c6.004,0,11.229,3.312,13.965,8.204c0.664-0.113,1.337-0.205,2.033-0.205c5.222,0,9.651,3.342,11.301,8h-4.381C65.535,47.253,62.958,45.643,59.999,45.643z"
                      })
                    ])
                  ], -1))
                ]))
              ]),
              _createElementVNode("div", _hoisted_56, [
                (_openBlock(), _createElementBlock("svg", _hoisted_57, [
                  _createVNode(_component_clippath, { id: "moonCloudFillClipfill9" }, {
                    default: _withCtx(() => _cache[81] || (_cache[81] = [
                      _createElementVNode("path", { d: "M0,0v100h100V0H0z M60.943,46.641c-4.418,0-7.999-3.582-7.999-7.999c0-3.803,2.655-6.979,6.211-7.792c0.903,4.854,4.726,8.676,9.579,9.58C67.922,43.986,64.745,46.641,60.943,46.641z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _cache[82] || (_cache[82] = _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudFogMoonFill" }, [
                    _createElementVNode("g", { "clip-path": "url(#cloudFillClip)" }, [
                      _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-moon climacon_componentWrap-moon_cloud" }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                          d: "M61.023,50.641c-6.627,0-11.999-5.372-11.999-11.998c0-6.627,5.372-11.999,11.999-11.999c0.755,0,1.491,0.078,2.207,0.212c-0.132,0.576-0.208,1.173-0.208,1.788c0,4.418,3.582,7.999,8,7.999c0.614,0,1.212-0.076,1.788-0.208c0.133,0.717,0.211,1.452,0.211,2.208C73.021,45.269,67.649,50.641,61.023,50.641z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-fill climacon_component-fill_moon",
                          fill: "#FFFFFF",
                          d: "M59.235,30.851c-3.556,0.813-6.211,3.989-6.211,7.792c0,4.417,3.581,7.999,7.999,7.999c3.802,0,6.979-2.655,7.791-6.211C63.961,39.527,60.139,35.705,59.235,30.851z"
                        })
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-Fog" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine climacon_component-stroke_fogLine-top",
                        d: "M69.998,57.641H30.003c-1.104,0-2-0.895-2-2c0-1.104,0.896-2,2-2h39.995c1.104,0,2,0.896,2,2C71.998,56.746,71.104,57.641,69.998,57.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine climacon_component-stroke_fogLine-middle",
                        d: "M69.998,65.641H30.003c-1.104,0-2-0.896-2-2s0.896-2,2-2h39.995c1.104,0,2,0.896,2,2C71.998,64.744,71.104,65.641,69.998,65.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine climacon_component-stroke_fogLine-bottom",
                        d: "M30.003,69.639h39.995c1.104,0,2,0.896,2,2c0,1.105-0.896,2-2,2H30.003c-1.104,0-2-0.895-2-2C28.003,70.535,28.898,69.639,30.003,69.639z"
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M59.999,45.643c-1.601,0-3.083,0.48-4.333,1.291c-1.232-5.317-5.974-9.291-11.665-9.291c-6.626,0-11.998,5.373-11.998,12h-4c0-8.835,7.163-15.999,15.998-15.999c6.004,0,11.229,3.312,13.965,8.204c0.664-0.113,1.337-0.205,2.033-0.205c5.222,0,9.651,3.342,11.301,8h-4.381C65.535,47.253,62.958,45.643,59.999,45.643z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M71.287,49.355c-1.659-4.632-6.08-7.954-11.289-7.954c-0.695,0-1.369,0.091-2.033,0.205C55.229,36.72,50.004,33.413,44,33.413c-8.824,0-15.977,7.134-15.996,15.942H71.287z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_cloud",
                        fill: "#FFFFFF",
                        d: "M66.897,49.376c-1.389-2.369-3.955-3.965-6.899-3.965c-1.602,0-3.082,0.48-4.334,1.291c-1.23-5.316-5.973-9.291-11.664-9.291c-6.615,0-11.977,5.354-11.996,11.965H66.897z"
                      })
                    ])
                  ], -1))
                ]))
              ]),
              _cache[144] || (_cache[144] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_cloudFogAlt",
                  id: "cloudFogAlt",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudFogAlt" }, [
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-Fog" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M29.177,55.641c-0.262-0.646-0.473-1.314-0.648-2h43.47c0,0.685-0.069,1.349-0.181,2H29.177z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M36.263,35.643c2.294-1.271,4.93-1.999,7.738-1.999c2.806,0,5.436,0.73,7.728,1.999H36.263z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M28.142,47.642c0.085-0.682,0.218-1.347,0.387-1.999h40.396c0.552,0.613,1.039,1.281,1.455,1.999H28.142z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M29.177,43.643c0.281-0.693,0.613-1.359,0.984-2h27.682c0.04,0.068,0.084,0.135,0.123,0.205c0.664-0.114,1.339-0.205,2.033-0.205c2.451,0,4.729,0.738,6.627,2H29.177z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M31.524,39.643c0.58-0.723,1.225-1.388,1.92-2h21.123c0.689,0.61,1.326,1.28,1.902,2H31.524z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M71.816,51.641H28.142c-0.082-0.656-0.139-1.32-0.139-1.999h43.298C71.527,50.285,71.702,50.953,71.816,51.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M71.301,57.641c-0.246,0.699-0.555,1.367-0.921,2H31.524c-0.505-0.629-0.957-1.299-1.363-2H71.301z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M33.444,61.641h35.48c-0.68,0.758-1.447,1.435-2.299,2H36.263C35.247,63.078,34.309,62.4,33.444,61.641z"
                      })
                    ])
                  ])
                ])
              ], -1)),
              _cache[145] || (_cache[145] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_cloudFogAltFill",
                  id: "cloudFogAltFill",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudFogAltFill" }, [
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-Fog" }, [
                      _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_cloud" }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-fill climacon_component-fill_cloud",
                          fill: "#FFFFFF",
                          d: "M43.945,65.639c-8.835,0-15.998-7.162-15.998-15.998c0-8.836,7.163-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,6.625-5.371,11.998-11.998,11.998C57.168,65.639,47.143,65.639,43.945,65.639z"
                        })
                      ]),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M29.177,55.641c-0.262-0.646-0.473-1.314-0.648-2h43.47c0,0.685-0.069,1.349-0.181,2H29.177z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M36.263,35.643c2.294-1.271,4.93-1.999,7.738-1.999c2.806,0,5.436,0.73,7.728,1.999H36.263z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M28.142,47.642c0.085-0.682,0.218-1.347,0.387-1.999h40.396c0.552,0.613,1.039,1.281,1.455,1.999H28.142z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M29.177,43.643c0.281-0.693,0.613-1.359,0.984-2h27.682c0.04,0.068,0.084,0.135,0.123,0.205c0.664-0.114,1.339-0.205,2.033-0.205c2.451,0,4.729,0.738,6.627,2H29.177z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M31.524,39.643c0.58-0.723,1.225-1.388,1.92-2h21.123c0.689,0.61,1.326,1.28,1.902,2H31.524z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M71.816,51.641H28.142c-0.082-0.656-0.139-1.32-0.139-1.999h43.298C71.527,50.285,71.702,50.953,71.816,51.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M71.301,57.641c-0.246,0.699-0.555,1.367-0.921,2H31.524c-0.505-0.629-0.957-1.299-1.363-2H71.301z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M33.444,61.641h35.48c-0.68,0.758-1.447,1.435-2.299,2H36.263C35.247,63.078,34.309,62.4,33.444,61.641z"
                      })
                    ])
                  ])
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_58, [
                (_openBlock(), _createElementBlock("svg", _hoisted_59, [
                  _createVNode(_component_clippath, { id: "cloudFillClipfill17" }, {
                    default: _withCtx(() => _cache[83] || (_cache[83] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M59.943,61.639c-3.02,0-12.381,0-15.999,0c-6.626,0-11.998-5.371-11.998-11.998c0-6.627,5.372-11.999,11.998-11.999c5.691,0,10.434,3.974,11.665,9.29c1.252-0.81,2.733-1.291,4.334-1.291c4.418,0,8,3.582,8,8C67.943,58.057,64.361,61.639,59.943,61.639z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_clippath, { id: "sunCloudFillClipfills2" }, {
                    default: _withCtx(() => _cache[84] || (_cache[84] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M57.945,49.641c-4.417,0-8-3.582-8-7.999c0-4.418,3.582-7.999,8-7.999s7.998,3.581,7.998,7.999C65.943,46.059,62.362,49.641,57.945,49.641z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_clippath, { id: "cloudSunFillClipfill9" }, {
                    default: _withCtx(() => _cache[85] || (_cache[85] = [
                      _createElementVNode("path", { d: "M15,15v70h20.947V63.481c-4.778-2.767-8-7.922-8-13.84c0-8.836,7.163-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,5.262-3.394,9.723-8.107,11.341V85H85V15H15z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _cache[86] || (_cache[86] = _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudFogSunAlt" }, [
                    _createElementVNode("g", { "clip-path": "url(#cloudSunFillClip)" }, [
                      _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-sun climacon_componentWrap-sun_cloud" }, [
                        _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_sunSpoke" }, [
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M80.029,43.611h-3.998c-1.105,0-2-0.896-2-1.999s0.895-2,2-2h3.998c1.104,0,2,0.896,2,2S81.135,43.611,80.029,43.611z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M72.174,30.3c-0.781,0.781-2.049,0.781-2.828,0c-0.781-0.781-0.781-2.047,0-2.828l2.828-2.828c0.779-0.781,2.047-0.781,2.828,0c0.779,0.781,0.779,2.047,0,2.828L72.174,30.3z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M58.033,25.614c-1.105,0-2-0.896-2-2v-3.999c0-1.104,0.895-2,2-2c1.104,0,2,0.896,2,2v3.999C60.033,24.718,59.135,25.614,58.033,25.614z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M43.892,30.3l-2.827-2.828c-0.781-0.781-0.781-2.047,0-2.828c0.78-0.781,2.047-0.781,2.827,0l2.827,2.828c0.781,0.781,0.781,2.047,0,2.828C45.939,31.081,44.673,31.081,43.892,30.3z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M42.033,41.612c0,1.104-0.896,1.999-2,1.999h-4c-1.104,0-1.998-0.896-1.998-1.999s0.896-2,1.998-2h4C41.139,39.612,42.033,40.509,42.033,41.612z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M43.892,52.925c0.781-0.78,2.048-0.78,2.827,0c0.781,0.78,0.781,2.047,0,2.828l-2.827,2.827c-0.78,0.781-2.047,0.781-2.827,0c-0.781-0.78-0.781-2.047,0-2.827L43.892,52.925z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M58.033,57.61c1.104,0,2,0.895,2,1.999v4c0,1.104-0.896,2-2,2c-1.105,0-2-0.896-2-2v-4C56.033,58.505,56.928,57.61,58.033,57.61z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M72.174,52.925l2.828,2.828c0.779,0.78,0.779,2.047,0,2.827c-0.781,0.781-2.049,0.781-2.828,0l-2.828-2.827c-0.781-0.781-0.781-2.048,0-2.828C70.125,52.144,71.391,52.144,72.174,52.925z"
                          })
                        ]),
                        _createElementVNode("g", {
                          class: "climacon_wrapperComponent climacon_wrapperComponent-sunBody",
                          "clip-path": "url(#sunCloudFillClip)"
                        }, [
                          _createElementVNode("circle", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                            cx: "58.033",
                            cy: "41.612",
                            r: "11.999"
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-Fog" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M29.177,55.641c-0.262-0.646-0.473-1.314-0.648-2h43.47c0,0.685-0.069,1.349-0.181,2H29.177z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M36.263,35.643c2.294-1.271,4.93-1.999,7.738-1.999c2.806,0,5.436,0.73,7.728,1.999H36.263z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M28.142,47.642c0.085-0.682,0.218-1.347,0.387-1.999h40.396c0.552,0.613,1.039,1.281,1.455,1.999H28.142z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M29.177,43.643c0.281-0.693,0.613-1.359,0.984-2h27.682c0.04,0.068,0.084,0.135,0.123,0.205c0.664-0.114,1.339-0.205,2.033-0.205c2.451,0,4.729,0.738,6.627,2H29.177z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M31.524,39.643c0.58-0.723,1.225-1.388,1.92-2h21.123c0.689,0.61,1.326,1.28,1.902,2H31.524z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M71.816,51.641H28.142c-0.082-0.656-0.139-1.32-0.139-1.999h43.298C71.527,50.285,71.702,50.953,71.816,51.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M71.301,57.641c-0.246,0.699-0.555,1.367-0.921,2H31.524c-0.505-0.629-0.957-1.299-1.363-2H71.301z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M33.444,61.641h35.48c-0.68,0.758-1.447,1.435-2.299,2H36.263C35.247,63.078,34.309,62.4,33.444,61.641z"
                      })
                    ])
                  ], -1))
                ]))
              ]),
              _createElementVNode("div", _hoisted_60, [
                (_openBlock(), _createElementBlock("svg", _hoisted_61, [
                  _createVNode(_component_clippath, { id: "cloudSunFillClipfill10" }, {
                    default: _withCtx(() => _cache[87] || (_cache[87] = [
                      _createElementVNode("path", { d: "M15,15v70h20.947V63.481c-4.778-2.767-8-7.922-8-13.84c0-8.836,7.163-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,5.262-3.394,9.723-8.107,11.341V85H85V15H15z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _cache[88] || (_cache[88] = _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudFogSunAlt" }, [
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_cloud",
                        fill: "#FFFFFF",
                        d: "M43.945,65.639c-8.835,0-15.998-7.162-15.998-15.998c0-8.836,7.163-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,6.625-5.371,11.998-11.998,11.998C57.168,65.639,47.143,65.639,43.945,65.639z"
                      })
                    ]),
                    _createElementVNode("g", { "clip-path": "url(#cloudSunFillClip)" }, [
                      _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-sun climacon_componentWrap-sun_cloud" }, [
                        _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_sunSpoke" }, [
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M80.029,43.611h-3.998c-1.105,0-2-0.896-2-1.999s0.895-2,2-2h3.998c1.104,0,2,0.896,2,2S81.135,43.611,80.029,43.611z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M72.174,30.3c-0.781,0.781-2.049,0.781-2.828,0c-0.781-0.781-0.781-2.047,0-2.828l2.828-2.828c0.779-0.781,2.047-0.781,2.828,0c0.779,0.781,0.779,2.047,0,2.828L72.174,30.3z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M58.033,25.614c-1.105,0-2-0.896-2-2v-3.999c0-1.104,0.895-2,2-2c1.104,0,2,0.896,2,2v3.999C60.033,24.718,59.135,25.614,58.033,25.614z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M43.892,30.3l-2.827-2.828c-0.781-0.781-0.781-2.047,0-2.828c0.78-0.781,2.047-0.781,2.827,0l2.827,2.828c0.781,0.781,0.781,2.047,0,2.828C45.939,31.081,44.673,31.081,43.892,30.3z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M42.033,41.612c0,1.104-0.896,1.999-2,1.999h-4c-1.104,0-1.998-0.896-1.998-1.999s0.896-2,1.998-2h4C41.139,39.612,42.033,40.509,42.033,41.612z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M43.892,52.925c0.781-0.78,2.048-0.78,2.827,0c0.781,0.78,0.781,2.047,0,2.828l-2.827,2.827c-0.78,0.781-2.047,0.781-2.827,0c-0.781-0.78-0.781-2.047,0-2.827L43.892,52.925z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M58.033,57.61c1.104,0,2,0.895,2,1.999v4c0,1.104-0.896,2-2,2c-1.105,0-2-0.896-2-2v-4C56.033,58.505,56.928,57.61,58.033,57.61z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M72.174,52.925l2.828,2.828c0.779,0.78,0.779,2.047,0,2.827c-0.781,0.781-2.049,0.781-2.828,0l-2.828-2.827c-0.781-0.781-0.781-2.048,0-2.828C70.125,52.144,71.391,52.144,72.174,52.925z"
                          })
                        ]),
                        _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-sunBody" }, [
                          _createElementVNode("circle", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                            cx: "58.033",
                            cy: "41.612",
                            r: "11.999"
                          }),
                          _createElementVNode("circle", {
                            class: "climacon_component climacon_component-fill climacon_component-fill_sunBody",
                            fill: "#FFFFFF",
                            cx: "58.033",
                            cy: "41.612",
                            r: "7.999"
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-Fog" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M29.177,55.641c-0.262-0.646-0.473-1.314-0.648-2h43.47c0,0.685-0.069,1.349-0.181,2H29.177z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M36.263,35.643c2.294-1.271,4.93-1.999,7.738-1.999c2.806,0,5.436,0.73,7.728,1.999H36.263z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M28.142,47.642c0.085-0.682,0.218-1.347,0.387-1.999h40.396c0.552,0.613,1.039,1.281,1.455,1.999H28.142z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M29.177,43.643c0.281-0.693,0.613-1.359,0.984-2h27.682c0.04,0.068,0.084,0.135,0.123,0.205c0.664-0.114,1.339-0.205,2.033-0.205c2.451,0,4.729,0.738,6.627,2H29.177z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M31.524,39.643c0.58-0.723,1.225-1.388,1.92-2h21.123c0.689,0.61,1.326,1.28,1.902,2H31.524z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M71.816,51.641H28.142c-0.082-0.656-0.139-1.32-0.139-1.999h43.298C71.527,50.285,71.702,50.953,71.816,51.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M71.301,57.641c-0.246,0.699-0.555,1.367-0.921,2H31.524c-0.505-0.629-0.957-1.299-1.363-2H71.301z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M33.444,61.641h35.48c-0.68,0.758-1.447,1.435-2.299,2H36.263C35.247,63.078,34.309,62.4,33.444,61.641z"
                      })
                    ])
                  ], -1))
                ]))
              ]),
              _createElementVNode("div", _hoisted_62, [
                (_openBlock(), _createElementBlock("svg", _hoisted_63, [
                  _createVNode(_component_clippath, { id: "moonCloudFillClipfill10" }, {
                    default: _withCtx(() => _cache[89] || (_cache[89] = [
                      _createElementVNode("path", { d: "M0,0v100h100V0H0z M60.943,46.641c-4.418,0-7.999-3.582-7.999-7.999c0-3.803,2.655-6.979,6.211-7.792c0.903,4.854,4.726,8.676,9.579,9.58C67.922,43.986,64.745,46.641,60.943,46.641z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_clippath, { id: "newMoonCloudFillClip" }, {
                    default: _withCtx(() => _cache[90] || (_cache[90] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M59.943,65.638c-2.775,0-12.801,0-15.998,0c-8.836,0-15.998-7.162-15.998-15.998c0-8.835,7.162-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12C71.941,60.265,66.57,65.638,59.943,65.638z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _cache[91] || (_cache[91] = _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudFogMoon" }, [
                    _createElementVNode("g", { "clip-path": "url(#newMoonCloudFillClip)" }, [
                      _createElementVNode("g", {
                        class: "climacon_wrapperComponent climacon_wrapperComponent-moon climacon_componentWrap-moon_cloud",
                        "clip-path": "url(#moonCloudFillClip)"
                      }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                          d: "M61.023,50.641c-6.627,0-11.999-5.372-11.999-11.998c0-6.627,5.372-11.999,11.999-11.999c0.755,0,1.491,0.078,2.207,0.212c-0.132,0.576-0.208,1.173-0.208,1.788c0,4.418,3.582,7.999,8,7.999c0.614,0,1.212-0.076,1.788-0.208c0.133,0.717,0.211,1.452,0.211,2.208C73.021,45.269,67.649,50.641,61.023,50.641z"
                        })
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-Fog" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M29.177,55.641c-0.262-0.646-0.473-1.314-0.648-2h43.47c0,0.685-0.069,1.349-0.181,2H29.177z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M36.263,35.643c2.294-1.271,4.93-1.999,7.738-1.999c2.806,0,5.436,0.73,7.728,1.999H36.263z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M28.142,47.642c0.085-0.682,0.218-1.347,0.387-1.999h40.396c0.552,0.613,1.039,1.281,1.455,1.999H28.142z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M29.177,43.643c0.281-0.693,0.613-1.359,0.984-2h27.682c0.04,0.068,0.084,0.135,0.123,0.205c0.664-0.114,1.339-0.205,2.033-0.205c2.451,0,4.729,0.738,6.627,2H29.177z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M31.524,39.643c0.58-0.723,1.225-1.388,1.92-2h21.123c0.689,0.61,1.326,1.28,1.902,2H31.524z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M71.816,51.641H28.142c-0.082-0.656-0.139-1.32-0.139-1.999h43.298C71.527,50.285,71.702,50.953,71.816,51.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M71.301,57.641c-0.246,0.699-0.555,1.367-0.921,2H31.524c-0.505-0.629-0.957-1.299-1.363-2H71.301z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M33.444,61.641h35.48c-0.68,0.758-1.447,1.435-2.299,2H36.263C35.247,63.078,34.309,62.4,33.444,61.641z"
                      })
                    ])
                  ], -1))
                ]))
              ]),
              _createElementVNode("div", _hoisted_64, [
                (_openBlock(), _createElementBlock("svg", _hoisted_65, [
                  _createVNode(_component_clippath, { id: "newMoonCloudFillClipfill1" }, {
                    default: _withCtx(() => _cache[92] || (_cache[92] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M59.943,65.638c-2.775,0-12.801,0-15.998,0c-8.836,0-15.998-7.162-15.998-15.998c0-8.835,7.162-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12C71.941,60.265,66.57,65.638,59.943,65.638z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _cache[93] || (_cache[93] = _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudFogMoonAltFill" }, [
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_cloud",
                        fill: "#FFFFFF",
                        d: "M43.945,65.639c-8.835,0-15.998-7.162-15.998-15.998c0-8.836,7.163-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,6.625-5.371,11.998-11.998,11.998C57.168,65.639,47.143,65.639,43.945,65.639z"
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-Fog" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M29.177,55.641c-0.262-0.646-0.473-1.314-0.648-2h43.47c0,0.685-0.069,1.349-0.181,2H29.177z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M36.263,35.643c2.294-1.271,4.93-1.999,7.738-1.999c2.806,0,5.436,0.73,7.728,1.999H36.263z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M28.142,47.642c0.085-0.682,0.218-1.347,0.387-1.999h40.396c0.552,0.613,1.039,1.281,1.455,1.999H28.142z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M29.177,43.643c0.281-0.693,0.613-1.359,0.984-2h27.682c0.04,0.068,0.084,0.135,0.123,0.205c0.664-0.114,1.339-0.205,2.033-0.205c2.451,0,4.729,0.738,6.627,2H29.177z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M31.524,39.643c0.58-0.723,1.225-1.388,1.92-2h21.123c0.689,0.61,1.326,1.28,1.902,2H31.524z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M71.816,51.641H28.142c-0.082-0.656-0.139-1.32-0.139-1.999h43.298C71.527,50.285,71.702,50.953,71.816,51.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M71.301,57.641c-0.246,0.699-0.555,1.367-0.921,2H31.524c-0.505-0.629-0.957-1.299-1.363-2H71.301z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_fogLine",
                        d: "M33.444,61.641h35.48c-0.68,0.758-1.447,1.435-2.299,2H36.263C35.247,63.078,34.309,62.4,33.444,61.641z"
                      })
                    ]),
                    _createElementVNode("g", { "clip-path": "url(#newMoonCloudFillClip)" }, [
                      _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-moon climacon_componentWrap-moon_cloud" }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_moonBody",
                          d: "M61.023,50.641c-6.627,0-11.999-5.372-11.999-11.998c0-6.627,5.372-11.999,11.999-11.999c0.755,0,1.491,0.078,2.207,0.212c-0.132,0.576-0.208,1.173-0.208,1.788c0,4.418,3.582,7.999,8,7.999c0.614,0,1.212-0.076,1.788-0.208c0.133,0.717,0.211,1.452,0.211,2.208C73.021,45.269,67.649,50.641,61.023,50.641z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-fill climacon_component-fill_moon",
                          fill: "#FFFFFF",
                          d: "M59.235,30.851c-3.556,0.813-6.211,3.989-6.211,7.792c0,4.417,3.581,7.999,7.999,7.999c3.802,0,6.979-2.655,7.791-6.211C63.961,39.527,60.139,35.705,59.235,30.851z"
                        })
                      ])
                    ])
                  ], -1))
                ]))
              ]),
              _cache[146] || (_cache[146] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_cloudLightning",
                  id: "cloudLightningfill2",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudLightning" }, [
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-lightning" }, [
                      _createElementVNode("polygon", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_lightning",
                        points: "48.001,51.641 57.999,51.641 52,61.641 58.999,61.641 46.001,77.639 49.601,65.641 43.001,65.641 "
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M59.999,65.641c-0.28,0-0.649,0-1.062,0l3.584-4.412c3.182-1.057,5.478-4.053,5.478-7.588c0-4.417-3.581-7.998-7.999-7.998c-1.602,0-3.083,0.48-4.333,1.29c-1.231-5.316-5.974-9.29-11.665-9.29c-6.626,0-11.998,5.372-11.998,12c0,5.446,3.632,10.039,8.604,11.503l-1.349,3.777c-6.52-2.021-11.255-8.098-11.255-15.282c0-8.835,7.163-15.999,15.998-15.999c6.004,0,11.229,3.312,13.965,8.204c0.664-0.114,1.338-0.205,2.033-0.205c6.627,0,11.999,5.371,11.999,11.999C71.999,60.268,66.626,65.641,59.999,65.641z"
                      })
                    ])
                  ])
                ])
              ], -1)),
              _cache[147] || (_cache[147] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_cloudLightningFill",
                  id: "cloudLightningFill",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudLightningFill" }, [
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-lightning" }, [
                      _createElementVNode("polygon", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_lightning",
                        points: "48.001,51.641 57.999,51.641 52,61.641 58.999,61.641 46.001,77.639 49.601,65.641 43.001,65.641 "
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M43.945,65.639c-8.835,0-15.998-7.162-15.998-15.998c0-8.836,7.163-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,6.625-5.371,11.998-11.998,11.998C57.168,65.639,47.143,65.639,43.945,65.639z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_cloud",
                        fill: "#FFFFFF",
                        d: "M59.943,61.639c4.418,0,8-3.582,8-7.998c0-4.417-3.582-8-8-8c-1.601,0-3.082,0.481-4.334,1.291c-1.23-5.316-5.973-9.29-11.665-9.29c-6.626,0-11.998,5.372-11.998,11.999c0,6.626,5.372,11.998,11.998,11.998C47.562,61.639,56.924,61.639,59.943,61.639z"
                      })
                    ])
                  ])
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_66, [
                (_openBlock(), _createElementBlock("svg", _hoisted_67, [
                  _createVNode(_component_clippath, { id: "cloudFillClipfill18" }, {
                    default: _withCtx(() => _cache[94] || (_cache[94] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M59.943,61.639c-3.02,0-12.381,0-15.999,0c-6.626,0-11.998-5.371-11.998-11.998c0-6.627,5.372-11.999,11.998-11.999c5.691,0,10.434,3.974,11.665,9.29c1.252-0.81,2.733-1.291,4.334-1.291c4.418,0,8,3.582,8,8C67.943,58.057,64.361,61.639,59.943,61.639z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_clippath, { id: "sunCloudFillClipfills3" }, {
                    default: _withCtx(() => _cache[95] || (_cache[95] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M57.945,49.641c-4.417,0-8-3.582-8-7.999c0-4.418,3.582-7.999,8-7.999s7.998,3.581,7.998,7.999C65.943,46.059,62.362,49.641,57.945,49.641z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_clippath, { id: "cloudSunFillClipfill11" }, {
                    default: _withCtx(() => _cache[96] || (_cache[96] = [
                      _createElementVNode("path", { d: "M15,15v70h20.947V63.481c-4.778-2.767-8-7.922-8-13.84c0-8.836,7.163-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,5.262-3.394,9.723-8.107,11.341V85H85V15H15z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _cache[97] || (_cache[97] = _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudLightning" }, [
                    _createElementVNode("g", { "clip-path": "url(#cloudSunFillClip)" }, [
                      _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-sun climacon_componentWrap-sun_cloud" }, [
                        _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_sunSpoke" }, [
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M80.029,43.611h-3.998c-1.105,0-2-0.896-2-1.999s0.895-2,2-2h3.998c1.104,0,2,0.896,2,2S81.135,43.611,80.029,43.611z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M72.174,30.3c-0.781,0.781-2.049,0.781-2.828,0c-0.781-0.781-0.781-2.047,0-2.828l2.828-2.828c0.779-0.781,2.047-0.781,2.828,0c0.779,0.781,0.779,2.047,0,2.828L72.174,30.3z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M58.033,25.614c-1.105,0-2-0.896-2-2v-3.999c0-1.104,0.895-2,2-2c1.104,0,2,0.896,2,2v3.999C60.033,24.718,59.135,25.614,58.033,25.614z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M43.892,30.3l-2.827-2.828c-0.781-0.781-0.781-2.047,0-2.828c0.78-0.781,2.047-0.781,2.827,0l2.827,2.828c0.781,0.781,0.781,2.047,0,2.828C45.939,31.081,44.673,31.081,43.892,30.3z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M42.033,41.612c0,1.104-0.896,1.999-2,1.999h-4c-1.104,0-1.998-0.896-1.998-1.999s0.896-2,1.998-2h4C41.139,39.612,42.033,40.509,42.033,41.612z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M43.892,52.925c0.781-0.78,2.048-0.78,2.827,0c0.781,0.78,0.781,2.047,0,2.828l-2.827,2.827c-0.78,0.781-2.047,0.781-2.827,0c-0.781-0.78-0.781-2.047,0-2.827L43.892,52.925z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M58.033,57.61c1.104,0,2,0.895,2,1.999v4c0,1.104-0.896,2-2,2c-1.105,0-2-0.896-2-2v-4C56.033,58.505,56.928,57.61,58.033,57.61z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M72.174,52.925l2.828,2.828c0.779,0.78,0.779,2.047,0,2.827c-0.781,0.781-2.049,0.781-2.828,0l-2.828-2.827c-0.781-0.781-0.781-2.048,0-2.828C70.125,52.144,71.391,52.144,72.174,52.925z"
                          })
                        ]),
                        _createElementVNode("g", {
                          class: "climacon_wrapperComponent climacon_wrapperComponent-sunBody",
                          "clip-path": "url(#sunCloudFillClip)"
                        }, [
                          _createElementVNode("circle", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                            cx: "58.033",
                            cy: "41.612",
                            r: "11.999"
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-lightning" }, [
                      _createElementVNode("polygon", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_lightning",
                        points: "48.001,51.641 57.999,51.641 52,61.641 58.999,61.641 46.001,77.639 49.601,65.641 43.001,65.641 "
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M59.999,65.641c-0.28,0-0.649,0-1.062,0l3.584-4.412c3.182-1.057,5.478-4.053,5.478-7.588c0-4.417-3.581-7.998-7.999-7.998c-1.602,0-3.083,0.48-4.333,1.29c-1.231-5.316-5.974-9.29-11.665-9.29c-6.626,0-11.998,5.372-11.998,12c0,5.446,3.632,10.039,8.604,11.503l-1.349,3.777c-6.52-2.021-11.255-8.098-11.255-15.282c0-8.835,7.163-15.999,15.998-15.999c6.004,0,11.229,3.312,13.965,8.204c0.664-0.114,1.338-0.205,2.033-0.205c6.627,0,11.999,5.371,11.999,11.999C71.999,60.268,66.626,65.641,59.999,65.641z"
                      })
                    ])
                  ], -1))
                ]))
              ]),
              _cache[148] || (_cache[148] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_cloudLightningSunFill",
                  id: "cloudLightningSunFill",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudLightning" }, [
                    _createElementVNode("g", { "clip-path": "url(#clip)" }, [
                      _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-sun climacon_componentWrap-sun_cloud" }, [
                        _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_sunSpoke" }, [
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M80.029,43.611h-3.998c-1.105,0-2-0.896-2-1.999s0.895-2,2-2h3.998c1.104,0,2,0.896,2,2S81.135,43.611,80.029,43.611z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M72.174,30.3c-0.781,0.781-2.049,0.781-2.828,0c-0.781-0.781-0.781-2.047,0-2.828l2.828-2.828c0.779-0.781,2.047-0.781,2.828,0c0.779,0.781,0.779,2.047,0,2.828L72.174,30.3z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M58.033,25.614c-1.105,0-2-0.896-2-2v-3.999c0-1.104,0.895-2,2-2c1.104,0,2,0.896,2,2v3.999C60.033,24.718,59.135,25.614,58.033,25.614z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M43.892,30.3l-2.827-2.828c-0.781-0.781-0.781-2.047,0-2.828c0.78-0.781,2.047-0.781,2.827,0l2.827,2.828c0.781,0.781,0.781,2.047,0,2.828C45.939,31.081,44.673,31.081,43.892,30.3z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M42.033,41.612c0,1.104-0.896,1.999-2,1.999h-4c-1.104,0-1.998-0.896-1.998-1.999s0.896-2,1.998-2h4C41.139,39.612,42.033,40.509,42.033,41.612z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M43.892,52.925c0.781-0.78,2.048-0.78,2.827,0c0.781,0.78,0.781,2.047,0,2.828l-2.827,2.827c-0.78,0.781-2.047,0.781-2.827,0c-0.781-0.78-0.781-2.047,0-2.827L43.892,52.925z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M58.033,57.61c1.104,0,2,0.895,2,1.999v4c0,1.104-0.896,2-2,2c-1.105,0-2-0.896-2-2v-4C56.033,58.505,56.928,57.61,58.033,57.61z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M72.174,52.925l2.828,2.828c0.779,0.78,0.779,2.047,0,2.827c-0.781,0.781-2.049,0.781-2.828,0l-2.828-2.827c-0.781-0.781-0.781-2.048,0-2.828C70.125,52.144,71.391,52.144,72.174,52.925z"
                          })
                        ]),
                        _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-sunBody" }, [
                          _createElementVNode("circle", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                            cx: "58.033",
                            cy: "41.612",
                            r: "11.999"
                          }),
                          _createElementVNode("circle", {
                            class: "climacon_component climacon_component-fill climacon_component-fill_sunBody",
                            fill: "#FFFFFF",
                            cx: "58.033",
                            cy: "41.612",
                            r: "7.999"
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-lightning" }, [
                      _createElementVNode("polygon", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_lightning",
                        points: "48.001,51.641 57.999,51.641 52,61.641 58.999,61.641 46.001,77.639 49.601,65.641 43.001,65.641 "
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M43.945,65.639c-8.835,0-15.998-7.162-15.998-15.998c0-8.836,7.163-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,6.625-5.371,11.998-11.998,11.998C57.168,65.639,47.143,65.639,43.945,65.639z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_cloud",
                        fill: "#FFFFFF",
                        d: "M59.943,61.639c4.418,0,8-3.582,8-7.998c0-4.417-3.582-8-8-8c-1.601,0-3.082,0.481-4.334,1.291c-1.23-5.316-5.973-9.29-11.665-9.29c-6.626,0-11.998,5.372-11.998,11.999c0,6.626,5.372,11.998,11.998,11.998C47.562,61.639,56.924,61.639,59.943,61.639z"
                      })
                    ])
                  ])
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_68, [
                (_openBlock(), _createElementBlock("svg", _hoisted_69, [
                  _createVNode(_component_clippath, { id: "moonCloudFillClipfill11" }, {
                    default: _withCtx(() => _cache[98] || (_cache[98] = [
                      _createElementVNode("path", { d: "M0,0v100h100V0H0z M60.943,46.641c-4.418,0-7.999-3.582-7.999-7.999c0-3.803,2.655-6.979,6.211-7.792c0.903,4.854,4.726,8.676,9.579,9.58C67.922,43.986,64.745,46.641,60.943,46.641z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_clippath, { id: "cloudFillClipfill19" }, {
                    default: _withCtx(() => _cache[99] || (_cache[99] = [
                      _createElementVNode("path", { d: "M15,15v70h70V15H15z M59.943,61.639c-3.02,0-12.381,0-15.999,0c-6.626,0-11.998-5.371-11.998-11.998c0-6.627,5.372-11.999,11.998-11.999c5.691,0,10.434,3.974,11.665,9.29c1.252-0.81,2.733-1.291,4.334-1.291c4.418,0,8,3.582,8,8C67.943,58.057,64.361,61.639,59.943,61.639z" }, null, -1)
                    ])),
                    _: 1
                  }),
                  _cache[100] || (_cache[100] = _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudLightningMoon" }, [
                    _createElementVNode("g", { "clip-path": "url(#cloudFillClip)" }, [
                      _createElementVNode("g", {
                        class: "climacon_wrapperComponent climacon_wrapperComponent-moon climacon_componentWrap-moon_cloud",
                        "clip-path": "url(#moonCloudFillClip)"
                      }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                          d: "M61.023,50.641c-6.627,0-11.999-5.372-11.999-11.998c0-6.627,5.372-11.999,11.999-11.999c0.755,0,1.491,0.078,2.207,0.212c-0.132,0.576-0.208,1.173-0.208,1.788c0,4.418,3.582,7.999,8,7.999c0.614,0,1.212-0.076,1.788-0.208c0.133,0.717,0.211,1.452,0.211,2.208C73.021,45.269,67.649,50.641,61.023,50.641z"
                        })
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-lightning" }, [
                      _createElementVNode("polygon", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_lightning",
                        points: "48.001,51.641 57.999,51.641 52,61.641 58.999,61.641 46.001,77.639 49.601,65.641 43.001,65.641 "
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M59.999,65.641c-0.28,0-0.649,0-1.062,0l3.584-4.412c3.182-1.057,5.478-4.053,5.478-7.588c0-4.417-3.581-7.998-7.999-7.998c-1.602,0-3.083,0.48-4.333,1.29c-1.231-5.316-5.974-9.29-11.665-9.29c-6.626,0-11.998,5.372-11.998,12c0,5.446,3.632,10.039,8.604,11.503l-1.349,3.777c-6.52-2.021-11.255-8.098-11.255-15.282c0-8.835,7.163-15.999,15.998-15.999c6.004,0,11.229,3.312,13.965,8.204c0.664-0.114,1.338-0.205,2.033-0.205c6.627,0,11.999,5.371,11.999,11.999C71.999,60.268,66.626,65.641,59.999,65.641z"
                      })
                    ])
                  ], -1))
                ]))
              ]),
              _cache[149] || (_cache[149] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_cloudLightningMoonFill",
                  id: "cloudLightningMoonFill",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-cloudLightningMoonFill" }, [
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-moon climacon_componentWrap-moon_cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                        d: "M61.023,50.641c-6.627,0-11.999-5.372-11.999-11.998c0-6.627,5.372-11.999,11.999-11.999c0.755,0,1.491,0.078,2.207,0.212c-0.132,0.576-0.208,1.173-0.208,1.788c0,4.418,3.582,7.999,8,7.999c0.614,0,1.212-0.076,1.788-0.208c0.133,0.717,0.211,1.452,0.211,2.208C73.021,45.269,67.649,50.641,61.023,50.641z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_moon",
                        fill: "#FFFFFF",
                        d: "M59.235,30.851c-3.556,0.813-6.211,3.989-6.211,7.792c0,4.417,3.581,7.999,7.999,7.999c3.802,0,6.979-2.655,7.791-6.211C63.961,39.527,60.139,35.705,59.235,30.851z"
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-lightning" }, [
                      _createElementVNode("polygon", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_lightning",
                        points: "48.001,51.641 57.999,51.641 52,61.641 58.999,61.641 46.001,77.639 49.601,65.641 43.001,65.641 "
                      })
                    ]),
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap_cloud" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_cloud",
                        d: "M43.945,65.639c-8.835,0-15.998-7.162-15.998-15.998c0-8.836,7.163-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,6.625-5.371,11.998-11.998,11.998C57.168,65.639,47.143,65.639,43.945,65.639z"
                      }),
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-fill climacon_component-fill_cloud",
                        fill: "#FFFFFF",
                        d: "M59.943,61.639c4.418,0,8-3.582,8-7.998c0-4.417-3.582-8-8-8c-1.601,0-3.082,0.481-4.334,1.291c-1.23-5.316-5.973-9.29-11.665-9.29c-6.626,0-11.998,5.372-11.998,11.999c0,6.626,5.372,11.998,11.998,11.998C47.562,61.639,56.924,61.639,59.943,61.639z"
                      })
                    ])
                  ])
                ])
              ], -1)),
              _cache[150] || (_cache[150] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_sunrise",
                  id: "sunrise",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-sunrise" }, [
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-sunrise" }, [
                      _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-sunSpoke" }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-east",
                          d: "M32.003,54h-4c-1.104,0-2,0.896-2,2s0.896,2,2,2h4c1.104,0,2-0.896,2-2S33.106,54,32.003,54z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-northEast",
                          d: "M38.688,41.859l-2.828-2.828c-0.781-0.78-2.047-0.78-2.828,0c-0.781,0.781-0.781,2.047,0,2.828l2.828,2.828c0.781,0.781,2.047,0.781,2.828,0C39.469,43.906,39.469,42.641,38.688,41.859z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M50.001,40.002c1.104,0,1.999-0.896,1.999-2v-3.999c0-1.104-0.896-2-1.999-2c-1.105,0-2,0.896-2,2v3.999C48.001,39.106,48.896,40.002,50.001,40.002z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-northWest",
                          d: "M66.969,39.031c-0.779-0.78-2.048-0.78-2.828,0l-2.828,2.828c-0.779,0.781-0.779,2.047,0,2.828c0.781,0.781,2.049,0.781,2.828,0l2.828-2.828C67.749,41.078,67.749,39.812,66.969,39.031z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-west",
                          d: "M71.997,54h-3.999c-1.104,0-1.999,0.896-1.999,2s0.896,2,1.999,2h3.999c1.104,0,2-0.896,2-2S73.104,54,71.997,54z"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-sunBody" }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                          d: "M50.001,44.002c-6.627,0-11.999,5.371-11.999,11.998c0,1.404,0.254,2.747,0.697,3.999h4.381c-0.683-1.177-1.079-2.54-1.079-3.999c0-4.418,3.582-7.999,8-7.999c4.417,0,7.998,3.581,7.998,7.999c0,1.459-0.396,2.822-1.078,3.999h4.381c0.443-1.252,0.697-2.595,0.697-3.999C61.999,49.373,56.627,44.002,50.001,44.002z"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-arrow" }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_arrow climacon_component-stroke_arrow-up",
                          d: "M50.001,63.046c0.552,0,0.999-0.447,0.999-1v-3.827l2.536,2.535c0.39,0.391,1.022,0.391,1.414,0c0.39-0.391,0.39-1.023,0-1.414l-4.242-4.242c-0.391-0.391-1.024-0.391-1.414,0l-4.242,4.242c-0.391,0.391-0.391,1.023,0,1.414c0.391,0.391,1.023,0.391,1.414,0l2.535-2.535v3.827C49.001,62.599,49.448,63.046,50.001,63.046z"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-horizonLine" }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_horizonLine",
                          d: "M59.999,63.999H40.001c-1.104,0-1.999,0.896-1.999,2s0.896,1.999,1.999,1.999h19.998c1.104,0,2-0.895,2-1.999S61.104,63.999,59.999,63.999z"
                        })
                      ])
                    ])
                  ])
                ])
              ], -1)),
              _cache[151] || (_cache[151] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_sunriseFill",
                  id: "sunriseFill",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-sunriseFill" }, [
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-sunrise" }, [
                      _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-sunSpoke" }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-east",
                          d: "M71.997,57.999h-3.998c-1.104,0-2-0.896-2-1.999s0.896-2,2-2h3.998c1.104,0,2,0.896,2,2S73.104,57.999,71.997,57.999z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-east",
                          d: "M64.143,44.688c-0.781,0.781-2.05,0.781-2.828,0c-0.781-0.781-0.781-2.047,0-2.828l2.828-2.828c0.778-0.781,2.047-0.781,2.828,0c0.778,0.781,0.778,2.047,0,2.828L64.143,44.688z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-east",
                          d: "M50.001,40.002c-1.105,0-2-0.896-2-2v-3.999c0-1.104,0.895-2,2-2c1.104,0,2,0.896,2,2v3.999C52.001,39.106,51.104,40.002,50.001,40.002z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-east",
                          d: "M35.86,44.688l-2.828-2.828c-0.781-0.781-0.781-2.047,0-2.828c0.781-0.781,2.047-0.781,2.828,0l2.828,2.828c0.781,0.781,0.781,2.047,0,2.828C37.907,45.469,36.641,45.469,35.86,44.688z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-east",
                          d: "M34.002,56c0,1.104-0.896,1.999-2,1.999h-4c-1.104,0-1.999-0.896-1.999-1.999s0.896-2,1.999-2h4C33.107,54,34.002,54.896,34.002,56z"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-sunBody" }, [
                        _createElementVNode("circle", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                          cx: "50.001",
                          cy: "56",
                          r: "11.999"
                        }),
                        _createElementVNode("circle", {
                          class: "climacon_component climacon_component-fill climacon_component-fill_sunBody",
                          fill: "#FFFFFF",
                          cx: "50.001",
                          cy: "56",
                          r: "7.999"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-arrow" }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_arrow climacon_component-stroke_arrow-up",
                          d: "M50.001,63.046c0.552,0,0.999-0.447,0.999-1v-3.827l2.536,2.535c0.39,0.391,1.022,0.391,1.414,0c0.39-0.391,0.39-1.023,0-1.414l-4.242-4.242c-0.391-0.391-1.024-0.391-1.414,0l-4.242,4.242c-0.391,0.391-0.391,1.023,0,1.414c0.391,0.391,1.023,0.391,1.414,0l2.535-2.535v3.827C49.001,62.599,49.448,63.046,50.001,63.046z"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-horizonLine" }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_horizonLine",
                          d: "M59.999,63.999H40.001c-1.104,0-1.999,0.896-1.999,2s0.896,1.999,1.999,1.999h19.998c1.104,0,2-0.895,2-1.999S61.104,63.999,59.999,63.999z"
                        })
                      ])
                    ])
                  ])
                ])
              ], -1)),
              _cache[152] || (_cache[152] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_sunset",
                  id: "sunset",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-sunset" }, [
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-sunset" }, [
                      _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-sunSpoke" }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-east",
                          d: "M32.003,54h-4c-1.104,0-2,0.896-2,2s0.896,2,2,2h4c1.104,0,2-0.896,2-2S33.106,54,32.003,54z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-northEast",
                          d: "M38.688,41.859l-2.828-2.828c-0.781-0.78-2.047-0.78-2.828,0c-0.781,0.781-0.781,2.047,0,2.828l2.828,2.828c0.781,0.781,2.047,0.781,2.828,0C39.469,43.906,39.469,42.641,38.688,41.859z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M50.001,40.002c1.104,0,1.999-0.896,1.999-2v-3.999c0-1.104-0.896-2-1.999-2c-1.105,0-2,0.896-2,2v3.999C48.001,39.106,48.896,40.002,50.001,40.002z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-northWest",
                          d: "M66.969,39.031c-0.779-0.78-2.048-0.78-2.828,0l-2.828,2.828c-0.779,0.781-0.779,2.047,0,2.828c0.781,0.781,2.049,0.781,2.828,0l2.828-2.828C67.749,41.078,67.749,39.812,66.969,39.031z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-west",
                          d: "M71.997,54h-3.999c-1.104,0-1.999,0.896-1.999,2s0.896,2,1.999,2h3.999c1.104,0,2-0.896,2-2S73.104,54,71.997,54z"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-sunBody" }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                          d: "M50.001,44.002c-6.627,0-11.999,5.371-11.999,11.998c0,1.404,0.254,2.747,0.697,3.999h4.381c-0.683-1.177-1.079-2.54-1.079-3.999c0-4.418,3.582-7.999,8-7.999c4.417,0,7.998,3.581,7.998,7.999c0,1.459-0.396,2.822-1.078,3.999h4.381c0.443-1.252,0.697-2.595,0.697-3.999C61.999,49.373,56.627,44.002,50.001,44.002z"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-arrow" }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_arrow climacon_component-stroke_arrow-down",
                          d: "M50,49.107c0.552,0,1,0.448,1,1.002v3.83l2.535-2.535c0.391-0.391,1.022-0.391,1.414,0c0.391,0.391,0.391,1.023,0,1.414l-4.242,4.242c-0.392,0.391-1.022,0.391-1.414,0l-4.242-4.242c-0.391-0.391-0.391-1.023,0-1.414c0.392-0.391,1.023-0.391,1.414,0L49,53.939v-3.83C49,49.555,49.447,49.107,50,49.107z"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-horizonLine" }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_horizonLine",
                          d: "M59.999,63.999H40.001c-1.104,0-1.999,0.896-1.999,2s0.896,1.999,1.999,1.999h19.998c1.104,0,2-0.895,2-1.999S61.104,63.999,59.999,63.999z"
                        })
                      ])
                    ])
                  ])
                ])
              ], -1)),
              _cache[153] || (_cache[153] = _createElementVNode("div", { class: "col-lg-2 col-3" }, [
                _createElementVNode("svg", {
                  class: "climacon climacon_sunsetFill",
                  id: "sunsetFill",
                  version: "1.1",
                  viewBox: "15 15 70 70"
                }, [
                  _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-sunsetFill" }, [
                    _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-sunsetFill" }, [
                      _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-sunSpoke" }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-west",
                          d: "M71.997,57.999h-3.998c-1.104,0-2-0.896-2-1.999s0.896-2,2-2h3.998c1.104,0,2,0.896,2,2S73.104,57.999,71.997,57.999z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-northWest",
                          d: "M64.143,44.688c-0.781,0.781-2.05,0.781-2.828,0c-0.781-0.781-0.781-2.047,0-2.828l2.828-2.828c0.778-0.781,2.047-0.781,2.828,0c0.778,0.781,0.778,2.047,0,2.828L64.143,44.688z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                          d: "M50.001,40.002c-1.105,0-2-0.896-2-2v-3.999c0-1.104,0.895-2,2-2c1.104,0,2,0.896,2,2v3.999C52.001,39.106,51.104,40.002,50.001,40.002z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-northEast",
                          d: "M35.86,44.688l-2.828-2.828c-0.781-0.781-0.781-2.047,0-2.828c0.781-0.781,2.047-0.781,2.828,0l2.828,2.828c0.781,0.781,0.781,2.047,0,2.828C37.907,45.469,36.641,45.469,35.86,44.688z"
                        }),
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-east",
                          d: "M34.002,56c0,1.104-0.896,1.999-2,1.999h-4c-1.104,0-1.999-0.896-1.999-1.999s0.896-2,1.999-2h4C33.107,54,34.002,54.896,34.002,56z"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-sunBody" }, [
                        _createElementVNode("circle", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                          cx: "50.001",
                          cy: "56",
                          r: "11.999"
                        }),
                        _createElementVNode("circle", {
                          class: "climacon_component climacon_component-fill climacon_component-fill_sunBody",
                          fill: "#FFFFFF",
                          cx: "50.001",
                          cy: "56",
                          r: "7.999"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-arrow" }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_arrow climacon_component-stroke_arrow-down",
                          d: "M50,49.107c0.552,0,1,0.448,1,1.002v3.83l2.535-2.535c0.391-0.391,1.022-0.391,1.414,0c0.391,0.391,0.391,1.023,0,1.414l-4.242,4.242c-0.392,0.391-1.022,0.391-1.414,0l-4.242-4.242c-0.391-0.391-0.391-1.023,0-1.414c0.392-0.391,1.023-0.391,1.414,0L49,53.939v-3.83C49,49.555,49.447,49.107,50,49.107z"
                        })
                      ]),
                      _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-horizonLine" }, [
                        _createElementVNode("path", {
                          class: "climacon_component climacon_component-stroke climacon_component-stroke_horizonLine",
                          d: "M59.999,63.999H40.001c-1.104,0-1.999,0.896-1.999,2s0.896,1.999,1.999,1.999h19.998c1.104,0,2-0.895,2-1.999S61.104,63.999,59.999,63.999z"
                        })
                      ])
                    ])
                  ])
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_70, [
                (_openBlock(), _createElementBlock("svg", _hoisted_71, [
                  _createVNode(_component_clippath, { id: "sunriseClip" }, {
                    default: _withCtx(() => _cache[101] || (_cache[101] = [
                      _createElementVNode("rect", {
                        x: "15",
                        y: "15",
                        width: "70",
                        height: "45"
                      }, null, -1)
                    ])),
                    _: 1
                  }),
                  _cache[102] || (_cache[102] = _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-sunriseAlt" }, [
                    _createElementVNode("g", { "clip-path": "url(#sunriseClip)" }, [
                      _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-sunriseAlt" }, [
                        _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-sunSpoke" }, [
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-east",
                            d: "M71.997,74.002h-3.999c-1.104,0-2-0.896-2-2c0-1.105,0.896-2,2-2h3.999c1.104,0,2,0.895,2,2C73.997,73.105,73.104,74.002,71.997,74.002z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-east",
                            d: "M64.141,60.689c-0.781,0.78-2.048,0.78-2.828,0c-0.779-0.781-0.779-2.047,0-2.828l2.828-2.828c0.78-0.78,2.047-0.78,2.828,0c0.78,0.781,0.78,2.047,0,2.828L64.141,60.689z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-east",
                            d: "M50,56.003c-1.104,0-1.999-0.896-1.999-2v-3.999c0-1.104,0.896-2,1.999-2s2,0.896,2,2v3.999C52,55.107,51.104,56.003,50,56.003z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-east",
                            d: "M35.86,60.689l-2.828-2.828c-0.781-0.781-0.781-2.047,0-2.828c0.78-0.78,2.047-0.78,2.828,0l2.828,2.828c0.78,0.781,0.78,2.047,0,2.828C37.907,61.47,36.641,61.47,35.86,60.689z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-east",
                            d: "M34.002,72.002c0,1.104-0.896,2-1.999,2h-4c-1.104,0-2-0.896-2-2c0-1.105,0.896-2,2-2h4C33.106,70.002,34.002,70.896,34.002,72.002z"
                          })
                        ]),
                        _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-sunBody" }, [
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                            d: "M61.302,76h-4.381c0.683-1.176,1.078-2.539,1.078-3.998c0-4.418-3.581-8-7.999-8c-4.417,0-7.999,3.582-7.999,8c0,1.459,0.396,2.822,1.079,3.998h-4.381c-0.444-1.252-0.698-2.594-0.698-3.998c0-6.627,5.373-11.999,11.999-11.999c6.627,0,11.999,5.371,11.999,11.999C61.999,73.406,61.745,74.748,61.302,76z"
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-horizonLine" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_horizonLine",
                        d: "M40.001,63.998h19.998c1.104,0,2,0.896,2,2c0,1.105-0.896,2-2,2H40.001c-1.104,0-2-0.895-2-2C38.001,64.895,38.897,63.998,40.001,63.998z"
                      })
                    ])
                  ], -1))
                ]))
              ]),
              _createElementVNode("div", _hoisted_72, [
                (_openBlock(), _createElementBlock("svg", _hoisted_73, [
                  _createVNode(_component_clippath, { id: "sunriseFillClip" }, {
                    default: _withCtx(() => _cache[103] || (_cache[103] = [
                      _createElementVNode("rect", {
                        x: "15",
                        y: "15",
                        width: "70",
                        height: "48.999"
                      }, null, -1)
                    ])),
                    _: 1
                  }),
                  _cache[104] || (_cache[104] = _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-sunriseAltFill" }, [
                    _createElementVNode("g", { "clip-path": "url(#sunriseFillClip)" }, [
                      _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-sunriseAlt" }, [
                        _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-sunSpoke" }, [
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-east",
                            d: "M72.31,77.999h-3.998c-1.104,0-2-0.896-2-1.999s0.896-2,2-2h3.998c1.104,0,2,0.896,2,2S73.416,77.999,72.31,77.999z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-east",
                            d: "M64.455,64.688c-0.781,0.781-2.05,0.781-2.828,0c-0.781-0.78-0.781-2.047,0-2.828l2.828-2.827c0.778-0.781,2.047-0.781,2.828,0c0.778,0.78,0.778,2.047,0,2.827L64.455,64.688z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-east",
                            d: "M50.313,60.002c-1.104,0-2-0.896-2-2v-3.999c0-1.104,0.896-2,2-2s2,0.896,2,2v3.999C52.313,59.105,51.416,60.002,50.313,60.002z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-east",
                            d: "M36.172,64.688l-2.828-2.828c-0.781-0.78-0.781-2.047,0-2.827c0.781-0.781,2.047-0.781,2.828,0L39,61.859c0.781,0.781,0.781,2.048,0,2.828C38.22,65.469,36.954,65.469,36.172,64.688z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-east",
                            d: "M34.314,76c0,1.104-0.896,1.999-2,1.999h-4c-1.104,0-1.999-0.896-1.999-1.999s0.896-2,1.999-2h4C33.419,74,34.314,74.896,34.314,76z"
                          })
                        ]),
                        _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-sunBody" }, [
                          _createElementVNode("circle", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                            cx: "50.313",
                            cy: "76",
                            r: "11.999"
                          }),
                          _createElementVNode("circle", {
                            class: "climacon_component climacon_component-fill climacon_component-fill_sunBody",
                            fill: "#FFFFFF",
                            cx: "50.001",
                            cy: "76",
                            r: "7.999"
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-horizonLine" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_horizonLine",
                        d: "M40.001,63.998h19.998c1.104,0,2,0.896,2,2c0,1.105-0.896,2-2,2H40.001c-1.104,0-2-0.895-2-2C38.001,64.895,38.897,63.998,40.001,63.998z"
                      })
                    ])
                  ], -1))
                ]))
              ]),
              _createElementVNode("div", _hoisted_74, [
                (_openBlock(), _createElementBlock("svg", _hoisted_75, [
                  _createVNode(_component_clippath, { id: "sunriseClipfill" }, {
                    default: _withCtx(() => _cache[105] || (_cache[105] = [
                      _createElementVNode("rect", {
                        x: "15",
                        y: "15",
                        width: "70",
                        height: "45"
                      }, null, -1)
                    ])),
                    _: 1
                  }),
                  _cache[106] || (_cache[106] = _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-sunsetAlt" }, [
                    _createElementVNode("g", { "clip-path": "url(#sunriseClip)" }, [
                      _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-sunsetAlt" }, [
                        _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-sunSpoke" }, [
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-east",
                            d: "M71.997,74.002h-3.999c-1.104,0-2-0.896-2-2c0-1.105,0.896-2,2-2h3.999c1.104,0,2,0.895,2,2C73.997,73.105,73.104,74.002,71.997,74.002z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-east",
                            d: "M64.141,60.689c-0.781,0.78-2.048,0.78-2.828,0c-0.779-0.781-0.779-2.047,0-2.828l2.828-2.828c0.78-0.78,2.047-0.78,2.828,0c0.78,0.781,0.78,2.047,0,2.828L64.141,60.689z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-east",
                            d: "M50,56.003c-1.104,0-1.999-0.896-1.999-2v-3.999c0-1.104,0.896-2,1.999-2s2,0.896,2,2v3.999C52,55.107,51.104,56.003,50,56.003z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-east",
                            d: "M35.86,60.689l-2.828-2.828c-0.781-0.781-0.781-2.047,0-2.828c0.78-0.78,2.047-0.78,2.828,0l2.828,2.828c0.78,0.781,0.78,2.047,0,2.828C37.907,61.47,36.641,61.47,35.86,60.689z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-east",
                            d: "M34.002,72.002c0,1.104-0.896,2-1.999,2h-4c-1.104,0-2-0.896-2-2c0-1.105,0.896-2,2-2h4C33.106,70.002,34.002,70.896,34.002,72.002z"
                          })
                        ]),
                        _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-sunBody" }, [
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                            d: "M61.302,76h-4.381c0.683-1.176,1.078-2.539,1.078-3.998c0-4.418-3.581-8-7.999-8c-4.417,0-7.999,3.582-7.999,8c0,1.459,0.396,2.822,1.079,3.998h-4.381c-0.444-1.252-0.698-2.594-0.698-3.998c0-6.627,5.373-11.999,11.999-11.999c6.627,0,11.999,5.371,11.999,11.999C61.999,73.406,61.745,74.748,61.302,76z"
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-horizonLine" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_horizonLine",
                        d: "M40.001,63.998h19.998c1.104,0,2,0.896,2,2c0,1.105-0.896,2-2,2H40.001c-1.104,0-2-0.895-2-2C38.001,64.895,38.897,63.998,40.001,63.998z"
                      })
                    ])
                  ], -1))
                ]))
              ]),
              _createElementVNode("div", _hoisted_76, [
                (_openBlock(), _createElementBlock("svg", _hoisted_77, [
                  _createVNode(_component_clippath, { id: "sunriseFillClipfill" }, {
                    default: _withCtx(() => _cache[107] || (_cache[107] = [
                      _createElementVNode("rect", {
                        x: "15",
                        y: "15",
                        width: "70",
                        height: "48.999"
                      }, null, -1)
                    ])),
                    _: 1
                  }),
                  _cache[108] || (_cache[108] = _createElementVNode("g", { class: "climacon_iconWrap climacon_iconWrap-sunsetAltFill" }, [
                    _createElementVNode("g", { "clip-path": "url(#sunriseFillClip)" }, [
                      _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-sunset climacon_componentWrap-sunsetAlt" }, [
                        _createElementVNode("g", { class: "climacon_componentWrap climacon_componentWrap-sunSpoke" }, [
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-east",
                            d: "M72.31,77.999h-3.998c-1.104,0-2-0.896-2-1.999s0.896-2,2-2h3.998c1.104,0,2,0.896,2,2S73.416,77.999,72.31,77.999z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-northEast",
                            d: "M64.455,64.688c-0.781,0.781-2.05,0.781-2.828,0c-0.781-0.78-0.781-2.047,0-2.828l2.828-2.827c0.778-0.781,2.047-0.781,2.828,0c0.778,0.78,0.778,2.047,0,2.827L64.455,64.688z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-north",
                            d: "M50.313,60.002c-1.104,0-2-0.896-2-2v-3.999c0-1.104,0.896-2,2-2s2,0.896,2,2v3.999C52.313,59.105,51.416,60.002,50.313,60.002z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-northWest",
                            d: "M36.172,64.688l-2.828-2.828c-0.781-0.78-0.781-2.047,0-2.827c0.781-0.781,2.047-0.781,2.828,0L39,61.859c0.781,0.781,0.781,2.048,0,2.828C38.22,65.469,36.954,65.469,36.172,64.688z"
                          }),
                          _createElementVNode("path", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunSpoke climacon_component-stroke_sunSpoke-west",
                            d: "M34.314,76c0,1.104-0.896,1.999-2,1.999h-4c-1.104,0-1.999-0.896-1.999-1.999s0.896-2,1.999-2h4C33.419,74,34.314,74.896,34.314,76z"
                          })
                        ]),
                        _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-sunBody" }, [
                          _createElementVNode("circle", {
                            class: "climacon_component climacon_component-stroke climacon_component-stroke_sunBody",
                            cx: "50.313",
                            cy: "76",
                            r: "11.999"
                          }),
                          _createElementVNode("circle", {
                            class: "climacon_component climacon_component-fill climacon_component-fill_sunBody",
                            fill: "#FFFFFF",
                            cx: "50.001",
                            cy: "76",
                            r: "7.999"
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("g", { class: "climacon_wrapperComponent climacon_wrapperComponent-horizonLine" }, [
                      _createElementVNode("path", {
                        class: "climacon_component climacon_component-stroke climacon_component-stroke_horizonLine",
                        d: "M40.001,63.998h19.998c1.104,0,2,0.896,2,2c0,1.105-0.896,2-2,2H40.001c-1.104,0-2-0.895-2-2C38.001,64.895,38.897,63.998,40.001,63.998z"
                      })
                    ])
                  ], -1))
                ]))
              ])
            ])
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}
}

})